<template>
  <div class="section-reporting" v-if="activeReporting">
    <!-- <div class="pages-sidebar" :class="{'contract': !advancedTabs}" v-click-outside="contractTabs"> -->
    <div class="pages-sidebar" :class="{'contract': tabsIsMinimize}" v-if="!hideToPdf">
      <div class="table-title" @click="toggleExpandTabs">
          <p>{{$t('dash.tab.reporting')}}</p>
      </div>
      <div class="show-setting">
        <!-- <i class="material-icons expand-btn minimize" @click="toggleExpandTabs" v-if="advancedTabs">navigate_before</i>
        <i class="material-icons expand-btn maximize" @click="toggleExpandTabs" v-if="!advancedTabs">navigate_next</i> -->
        <i class="material-icons expand-btn minimize" @click="toggleExpandTabs" v-if="!tabsIsMinimize">navigate_before</i>
        <i class="material-icons expand-btn maximize" @click="toggleExpandTabs" v-if="tabsIsMinimize">navigate_next</i>
      </div>
      <div class="search-page">
        <vs-input
          v-model="pageFilter"
          :class="{'input': true}"
          color="#B20564"
          class="inputx"
          icon-after="true"  icon="search"
          :placeholder="$t('dash.settings.user.label.page_filter')"
        />
      </div>
      <ul v-if="groups && pages">
        <li class="group" v-for="group in groups" :key="`page-sidebar-group-${group.id}`" :class="[{'show': group.show, 'hide': !checkPagesInGroup(group) || checkGroupFilter(group)}]">
          <div class="group-wrapper" @click="toggleShowGroup(group)">
            <img v-if="!group.show" alt="show group" class="show-group" src="../../../assets/img/icon-show-group.svg"/>
            <img v-else alt="hide group" class="hide-group" src="../../../assets/img/icon-hide-group.svg"/>
            <div class="group-content">
              <Tooltip :text="group.name" position="top">
                <div class="group-name messagedefilant"><div :data-text="group.name"><span>{{ group.name }}</span></div></div>
                
              </Tooltip>
            </div>
          </div>
          <ul>
            
            <div v-for="item in group.pages" :key="`page-ingroup-sidebar-${item}`">
              <li class="page" v-if="findPage(item)"
                    @click="accessNotActived(findPage(item)) ? confirmActiveAccess(findPage(item)) : null"
                    :class="[{ disabled: !checkLock(findPage(item).network) || accessNotActived(findPage(item)) || findPage(item).bot_status == 0, 'hide': !checkPageFilter(findPage(item)) }]">
                <div class="page-wrapper" :class="{disabled: !checkLock(findPage(item).network) || accessNotActived(findPage(item)) || findPage(item).bot_status == 0}">
                  <div class="checkbox">
                    <input
                      type="radio"
                      :id="`pages-${findPage(item).id}`"
                      :data-qa="`reporting-selector-list-page-${findPage(item).name}`"
                      name="pages[]"
                      :value="pages.findIndex(p => p.id == findPage(item).id)"
                      :disabled="!checkLock(findPage(item).network) || accessNotActived(findPage(item)) || findPage(item).bot_status == 0"
                      v-model="selectedTab"
                      v-on:click="updateSelected(pages.findIndex(p => p.id == findPage(item).id))"
                    >
                    <span class="checkmark">
                      <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
                    </span>
                  </div>
                  <div class="page-content">
                    <Tooltip :text="findPage(item).name" position="top">
                      <page-image-avatar :page="findPage(item)"/>
                      <div class="page-name messagedefilant"><div :data-text="findPage(item).name"><span>{{ findPage(item).name }}</span></div></div>
                      
                    </Tooltip>
                  </div>
                </div>
              </li>
            </div>
          </ul>
        </li>
        <li class="page" v-for="(item, index) in pages" :key="`page-sidebar-${item.id}`" 
                @click="accessNotActived(item) ? confirmActiveAccess(item) : null"
                :class="[{ current: selectedTab == index, disabled: !checkLock(item.network) || accessNotActived(item) || item.bot_status == 0, 'hide': !checkPageFilter(item) || pageInGroup(item) }]">
          <div class="page-wrapper" :class="{disabled: !checkLock(item.network) || accessNotActived(item) || item.bot_status == 0}" v-if="!pageInGroup(item)">
            <div class="page-content">
              <Tooltip :text="item.name" position="top">
                <page-image-avatar :page="item"/>
                <div class="page-name messagedefilant"><div :data-text="item.name"><span>{{ item.name }}</span></div></div>
                
              </Tooltip>
            </div>
            <div class="checkbox">
              <input
                type="radio"
                :id="`pages-${item.id}`"
                :data-qa="`reporting-selector-list-page-${item.name}`"
                name="pages[]"
                :value="index"
                :disabled="!checkLock(item.network) || accessNotActived(item) || item.bot_status == 0"
                v-model="selectedTab"
                v-on:click="updateSelected(index)"
              >
              <span class="checkmark">
                <img alt="checkup" src="../../../assets/img/icon-checkup.svg"/>
              </span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    
    <div v-if="(progressFunction && showLoader) || (!groups || pages.length == 0)" class="progress-bar">
      <component-loader :progress="progress" :unlimitedProgress="(!groups || pages.length == 0) || unlimitedProgress" :activeClose="true" v-on:close="showLoader = false"></component-loader>
    </div>
    <!-- <div v-else-if="updateCountDayLoader != null && updateCountDayLoader >= 0" class="progress-bar minimize"> -->
    <div v-else-if="updateCountDayLoader != null && updateCountDayLoader >= 0" class="progress-bar">
      <!-- <component-loader :detail="this.updateDayLoader" :progress="graphLabels && graphLabels.length ? (Math.round(updateCountDayLoader / graphLabels.length * 100) > 100 ? 100 : Math.round(updateCountDayLoader / graphLabels.length * 100)) : updateCountDayLoader" :unlimitedProgress="updateCountDayLoader == 0" :activeClose="true" v-on:close="showLoader = false"></component-loader> -->
      <component-loader :detail="this.updateDayLoader ? $t('dash.reporting.day.load') + this.updateDayLoader : ''" :progress="Math.round(updateCountDayLoader / updateTotalDayLoader * 100) > 100 ? 100 : Math.round(updateCountDayLoader / updateTotalDayLoader * 100)" :activeClose="true" v-on:close="updateCountDayLoader = null"></component-loader>
    </div>

   
    <div id="pageReportingLoading" class="vs-con-loading__container" v-if="!hideToPdf">
      
      <h2 v-if="!currentPage">{{$t('dash.reporting.no_page')}}</h2>      

      <div class="reporting-date" v-if="currentPage">
        <vs-select v-model="boardSelected" v-if="currentPage.network == 'pinterest' && boards" class="board-select">
          <vs-select-item
            v-for="(item,index) in boards.board.items"
            :value="item" 
            :key="`board-${index}`"
            :text= item.name
          />
        </vs-select>
        
        <div class="frequency-wrapper">
          <Tooltip :text="$t('dash.frequency.refresh')" position="top">
            <select v-model="refresh.frequency">
              <option v-for="(freq, key) in refresh.allowed"
                :key="`freq-${key}`"
                :value="freq"
              >{{ freq ? freq + 'sec' : $t('dash.posts.no_refresh') }}</option>
            </select>
      
          </Tooltip>
        </div>
        
        <select v-model="selectedTime" class="date-select">
          <option :value="-1">{{ $t('dash.reporting.period_custom') }}</option>
          <option v-for="(freq, key) in selectTime"
            :key="`board-${key}`"
            :value="key"
          >{{ freq }}</option>
        </select>

        <component-datepicker
          class="date"
          :from="this.disabledDate.fromStart"
          :to="this.disabledDate.toStart"
          v-on:picked="setDateStart"
          v-on:errorFormat="checkErrorFormatDateStart"
          :date="dateStart"
        ></component-datepicker>
        <component-datepicker
          class="date"
          :from="this.disabledDate.fromEnd"
          :to="this.disabledDate.toEnd"
          v-on:picked="setDateEnd"
          v-on:errorFormat="checkErrorFormatDateEnd"
          :date="dateEnd"
        ></component-datepicker>
      </div>  



      <vs-popup class="overlay groups export-api-reporting" 
                :title="$t('dash.reporting.export_api.overlay.title')" 
                :active.sync="popupUrlExportApi"
                v-if="popupUrlExportApi">
                
        <div class="link_to_copy" @click="copyUrlExportApi()">
          <span>{{ urlExportApi.substr(0, 50) }} ...</span>
          <img src="../../../assets/img/copy_icon.svg" alt="unlock">
        </div>

        <br/>

        <vs-button class="btnx" type="filled" 
          @click.prevent="copyUrlExportApi()"
        >
          {{$t('dash.button.copy')}}
        </vs-button>

      </vs-popup>

      <Tooltip class="update-button one-button" v-if="activeReportingV2 && currentPage && ['facebook', 'instagram', 'linkedin', 'tiktok'].includes(currentPage.network) && !currentPage.isGroup" :text="$t('dash.reporting.update_data')">
       
       <vs-button @click="getPageStat(true);" :disabled="!pageStats || updateCountDayLoader != null">
         <i class="material-icons">sync</i>
       </vs-button>
     
     </Tooltip>

      <!-- <vs-button v-else class="search-button" :class="[{'one-button': activeReportingV2 && currentPage && ['facebook', 'instagram', 'linkedin'].includes(currentPage.network) && !currentPage.isGroup}]" style="background-color: gray !important">{{$t('dash.reporting.search')}}</vs-button> -->
      <vs-button v-if="currentPage && (currentPage.network != 'pinterest' || (currentPage.network == 'pinterest' && boards)) && !errorFormatDateStart && !errorFormatDateEnd" @click="getPageStat();" class="search-button" :class="[{'one-button': activeReportingV2 && currentPage && ['facebook', 'instagram', 'linkedin'].includes(currentPage.network) && !currentPage.isGroup}]" :data-qa="`reporting-run-search`">{{$t('dash.reporting.search')}}</vs-button>
      <span v-if="refresh.last" class="last-update" :class="[{'more-buttons one-button': activeReportingV2 && currentPage && ['facebook', 'instagram', 'linkedin'].includes(currentPage.network) && !currentPage.isGroup}]">{{ $t("dash.reporting.last-update") }} : {{ formatDate(refresh.last) }}</span>
     
    
      
      
     
    
      
 

      <div class="current-page" v-if="lastPage">
        <page-image-avatar :page="lastPage"/>
        <a :href="linkPage" target="_blank"><h1 class="title-page" >{{lastPage.name}}</h1></a>
       
        <span class="date-print"> {{$t('dash.reporting.from')}} {{formatDate(dateStart, false)}} {{$t('dash.reporting.to')}} {{formatDate(dateEnd, false)}} </span>

        <!-- popup to choose format file befor exporting  -->
        <vs-button 
          @click="popupActivo2=true"
          v-if="pageStats"
          class="btn-img exportBtn" size="small"
          color="#2F1937"
          vs-type="filled">
                <p>{{$t('dash.button.exportGraphs')}}</p>
                <img src="../../../assets/img/icon_export.svg" alt="unlock">
        </vs-button>
        <vs-popup title="Export" :active.sync="popupActivo2">
          <p>
            {{$t('dash.export.selectformat')}}
          </p>
          <template v-if="checkLock('conciergerie')">
            <vs-button v-if="['facebook', 'instagram', 'linkedin', 'tiktok'].includes(lastPage.network)" @click="getPDF();" :disabled="!pageStats || updateCountDayLoader != null || !(pageStats && pageStats.page && pageStats.page.previous_period)" class="btnFormat">
              pdf
            </vs-button>
            <vs-button v-if="['facebook', 'instagram', 'linkedin', 'tiktok'].includes(lastPage.network)" @click="getExportApiUrl();" :disabled="!pageStats || updateCountDayLoader != null" class="btnFormat" style="margin-top: 10px; margin-right: 10px; margin-left: 10px;">
              api
            </vs-button>
          </template>
          <template v-else>
            <Tooltip :text="$t('dash.plan.active_conciergerie_to_get_features.content_export_reporting')">
              <vs-button v-if="['facebook', 'instagram', 'linkedin', 'tiktok'].includes(lastPage.network)" @click="goToSettings();" :disabled="!pageStats || updateCountDayLoader != null" class="btnFormat">
                pdf
              </vs-button>
            </Tooltip>
            <Tooltip :text="$t('dash.plan.active_conciergerie_to_get_features.content_export_reporting')">
              <vs-button v-if="['facebook', 'instagram', 'linkedin', 'tiktok'].includes(lastPage.network)" @click="goToSettings();" :disabled="!pageStats || updateCountDayLoader != null" class="btnFormat" style="margin-top: 10px; margin-right: 10px; margin-left: 10px;">
                api
              </vs-button>
            </Tooltip>
          </template>
          <vs-button class="btnFormat"
            v-for="format in formats" :key="`format-${format.value}`"
            v-show="pageStats && pageStats.page.nb_posts > 0"
            @click="exportData(format.value, 'graphs')"   
            style="margin-top: 10px; margin-right: 10px; margin-left: 10px;"          
          >{{format.value}}
          </vs-button>
        </vs-popup>

      </div>
      <h2 v-if="!pageStats && !progressFunction">{{$t('dash.reporting.select_page')}}</h2>

      <div class="informations" v-if="pageStats">
        <!-- page_fans -->
        <div v-if="pageStats" class="main-numbers">
          <i class="fa-solid fa-user-group"></i>
          <h3>{{$t(['linkedin', 'facebook'].includes(lastPage.network) ? 'dash.label.fb.page_follows' : 'dash.reporting.nb_fans')}}</h3>
        
          <img class="icon fan-ico" src="../../../assets/img/reporting_icons/fans.svg" alt="">
          <Tooltip v-if="pageStats.page.page_fans >= 1000000" :text="numberSpacing(pageStats.page.page_fans)">
            <p class="big-number">{{ numberSpacing(Number(pageStats.page.page_fans/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}))}}<span class="percent">M</span></p>
            
          </Tooltip>
          <Tooltip v-else-if="pageStats.page.page_fans >= 1000" :text="numberSpacing(pageStats.page.page_fans)">
            <p class="big-number">{{numberSpacing(Number(pageStats.page.page_fans/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
            
          </Tooltip>
          <p v-else>{{numberSpacing(pageStats.page.page_fans)}}</p>
          <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && ['facebook', 'instagram', 'linkedin'].includes(lastPage.network)">
            <img src="../../../assets/img/status-waiting.gif">
          </div>
          <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_fans">
            <Tooltip v-if="pageStats.page.page_fans < pageStats.page.previous_period.page_fans" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_fans)" class="trending_down">
                <span class="negative">-{{ formatPercentageChange(100 - (pageStats.page.page_fans / pageStats.page.previous_period.page_fans) * 100) }}%</span>
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                
            </Tooltip>
            <Tooltip v-if="pageStats.page.page_fans != 0 && pageStats.page.page_fans == pageStats.page.previous_period.page_fans" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_fans)" class="trending_flat">
              <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
              
            </Tooltip>
            <Tooltip v-if="pageStats.page.page_fans > pageStats.page.previous_period.page_fans" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_fans)" class="trending_up">
              <span class="positive" v-if="pageStats.page.previous_period.page_fans > 0">+{{ formatPercentageChange((pageStats.page.page_fans / pageStats.page.previous_period.page_fans) * 100 - 100) }}%</span>
              <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
              
            </Tooltip>
          </div>
        </div>
        <img v-else src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

        <!-- page_follows -->
        <!-- <div v-if="pageStats && lastPage.network == 'facebook' && !(lastPage.isGroup)" class="main-numbers">
          <i class="fa-solid fa-user-group"></i>
          <h3>{{$t('dash.label.fb.page_follows')}}</h3>
         
          <img class="icon fan-ico" src="../../../assets/img/reporting_icons/fans.svg" alt="">
          <Tooltip v-if="graphData.find(g => g.name == 'page_follows') && graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1] >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1])">
            <p class="big-number">{{ numberSpacing(Number(graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1]/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}))}}<span class="percent">M</span></p>
            
          </Tooltip>
          <Tooltip v-else-if="graphData.find(g => g.name == 'page_follows') && graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1] >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1])">
            <p class="big-number">{{numberSpacing(Number(graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1]/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
            
          </Tooltip>
          <p v-else-if="graphData.find(g => g.name == 'page_follows')">{{numberSpacing(graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1])}}</p>
          <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
            <img src="../../../assets/img/status-waiting.gif">
          </div>
          <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_follows">
            <Tooltip v-if="graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1] < pageStats.page.previous_period.page_follows[pageStats.page.previous_period.page_follows.length - 1].total" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_follows[pageStats.page.previous_period.page_follows.length - 1].total)" class="trending_down">
                <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1] / pageStats.page.previous_period.page_follows[pageStats.page.previous_period.page_follows.length - 1].total) * 100) }}%</span>
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                
            </Tooltip>
            <Tooltip v-if="graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1] != 0 && graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1] == pageStats.page.previous_period.page_follows[pageStats.page.previous_period.page_follows.length - 1].total" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_follows[pageStats.page.previous_period.page_follows.length - 1].total)" class="trending_flat">
              <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
              
            </Tooltip>
            <Tooltip v-if="graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1] > pageStats.page.previous_period.page_follows[pageStats.page.previous_period.page_follows.length - 1].total" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_follows[pageStats.page.previous_period.page_follows.length - 1].total)" class="trending_up">
              <span class="positive" v-if="pageStats.page.previous_period.page_follows[pageStats.page.previous_period.page_follows.length - 1].total > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1] / pageStats.page.previous_period.page_follows[pageStats.page.previous_period.page_follows.length - 1].total) * 100 - 100) }}%</span>
              <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
              
            </Tooltip>
          </div>
        </div>
        <img v-else-if="lastPage.network == 'facebook' && !(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt=""> -->

        <!-- nb post -->
        <div v-if="pageStats" class="main-numbers">
          <i class="fa-regular fa-square-plus"></i>
          <h3>{{capitalize($t('dash.posts.title'))}}</h3>
          <img class="icon post-ico" src="../../../assets/img/reporting_icons/posts.svg" alt="">
          <Tooltip v-if="pageStats.page.nb_posts >= 1000000" :text="numberSpacing(pageStats.page.nb_posts)">
            <p class="big-number">{{ numberSpacing(Number((pageStats.page.nb_posts)/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
            
          </Tooltip>
          <Tooltip v-else-if="pageStats.page.nb_posts >= 1000" :text="numberSpacing(pageStats.page.nb_posts)">
            <p class="big-number">{{ numberSpacing(Number((pageStats.page.nb_posts)/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">k</span></p>
            
          </Tooltip>
          <p v-else>{{ numberSpacing(pageStats.page.nb_posts ) }}</p>
          <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && ['facebook', 'instagram', 'linkedin'].includes(lastPage.network)">
            <img src="../../../assets/img/status-waiting.gif">
          </div>
          <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.nb_posts >= 0">
            <Tooltip v-if="pageStats.page.nb_posts < pageStats.page.previous_period.nb_posts" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.nb_posts)" class="trending_down">
                <span class="negative">-{{ formatPercentageChange(100 - (pageStats.page.nb_posts / pageStats.page.previous_period.nb_posts) * 100) }}%</span>
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                
            </Tooltip>
            <Tooltip v-if="pageStats.page.nb_posts != 0 && pageStats.page.nb_posts == pageStats.page.previous_period.nb_posts" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.nb_posts)" class="trending_flat">
              <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
              
            </Tooltip>
            <Tooltip v-if="pageStats.page.nb_posts > pageStats.page.previous_period.nb_posts" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.nb_posts)" class="trending_up">
              <span class="positive" v-if="pageStats.page.previous_period.nb_posts > 0">+{{ formatPercentageChange((pageStats.page.nb_posts / pageStats.page.previous_period.nb_posts) * 100 - 100) }}%</span>
              <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
              
            </Tooltip>
          </div>
        </div>
        <img v-else src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

        <!-- impression -->
        <template v-if="lastPage.network == 'linkedin'">
          <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
            <i class="fa-regular fa-eye"></i>
            <h3>{{$t('dash.reporting.impression')}}</h3>
            <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
            <p v-if="pageStats.page.shareImpressionCount === null">N/A</p>
            <Tooltip v-else-if="pageStats.page.shareImpressionCount   >= 1000000" :text="numberSpacing(pageStats.page.shareImpressionCount)">
              <p class="big-number">{{ numberSpacing(Number((pageStats.page.shareImpressionCount  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
              
            </Tooltip>
            <Tooltip v-else-if="pageStats.page.shareImpressionCount   >= 1000" :text="numberSpacing(pageStats.page.shareImpressionCount)">
              <p class="big-number">{{ numberSpacing(Number((pageStats.page.shareImpressionCount)/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
              
            </Tooltip>
            <p v-else>{{ numberSpacing(pageStats.page.shareImpressionCount  ) }}</p>
            <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && ['facebook', 'instagram', 'linkedin'].includes(lastPage.network)">
              <img src="../../../assets/img/status-waiting.gif">
            </div>
            <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.shareImpressionCount >= 0">
              <Tooltip v-if="pageStats.page.shareImpressionCount < pageStats.page.previous_period.shareImpressionCount" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.shareImpressionCount)" class="trending_down">
                  <span class="negative">-{{ formatPercentageChange(100 - (pageStats.page.shareImpressionCount / pageStats.page.previous_period.shareImpressionCount) * 100) }}%</span>
                  <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                  
              </Tooltip>
              <Tooltip v-if="pageStats.page.shareImpressionCount != 0 && pageStats.page.shareImpressionCount == pageStats.page.previous_period.shareImpressionCount" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.shareImpressionCount)" class="trending_flat">
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                
              </Tooltip>
              <Tooltip v-if="pageStats.page.shareImpressionCount > pageStats.page.previous_period.shareImpressionCount" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.shareImpressionCount)" class="trending_up">
                <span class="positive" v-if="pageStats.page.previous_period.shareImpressionCount > 0">+{{ formatPercentageChange((pageStats.page.shareImpressionCount / pageStats.page.previous_period.shareImpressionCount) * 100 - 100) }}%</span>
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                
              </Tooltip>
            </div>
          </div>
          <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

          <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
            <i class="fa-regular fa-eye"></i>
            <h3>{{$t('dash.reporting.impression_unique')}}</h3>
            <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
            <p v-if="pageStats.page.shareUniqueImpressionCount === null">N/A</p>
            <Tooltip v-else-if="pageStats.page.shareUniqueImpressionCount   >= 1000000" :text="numberSpacing(pageStats.page.shareUniqueImpressionCount)">
              <p class="big-number">{{ numberSpacing(Number((pageStats.page.shareUniqueImpressionCount  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
              
            </Tooltip>
            <Tooltip v-else-if="pageStats.page.shareUniqueImpressionCount   >= 1000" :text="numberSpacing(pageStats.page.shareUniqueImpressionCount)">
              <p class="big-number">{{ numberSpacing(Number((pageStats.page.shareUniqueImpressionCount)/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
              
            </Tooltip>
            <p v-else>{{ numberSpacing(pageStats.page.shareUniqueImpressionCount  ) }}</p>
            <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && ['facebook', 'instagram', 'linkedin'].includes(lastPage.network)">
              <img src="../../../assets/img/status-waiting.gif">
            </div>
            <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.shareUniqueImpressionCount >= 0">
              <Tooltip v-if="pageStats.page.shareUniqueImpressionCount < pageStats.page.previous_period.shareUniqueImpressionCount" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.shareUniqueImpressionCount)" class="trending_down">
                  <span class="negative">-{{ formatPercentageChange(100 - (pageStats.page.shareUniqueImpressionCount / pageStats.page.previous_period.shareUniqueImpressionCount) * 100) }}%</span>
                  <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                  
              </Tooltip>
              <Tooltip v-if="pageStats.page.shareUniqueImpressionCount != 0 && pageStats.page.shareUniqueImpressionCount == pageStats.page.previous_period.shareUniqueImpressionCount" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.shareUniqueImpressionCount)" class="trending_flat">
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                
              </Tooltip>
              <Tooltip v-if="pageStats.page.shareUniqueImpressionCount > pageStats.page.previous_period.shareUniqueImpressionCount" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.shareUniqueImpressionCount)" class="trending_up">
                <span class="positive" v-if="pageStats.page.previous_period.shareUniqueImpressionCount > 0">+{{ formatPercentageChange((pageStats.page.shareUniqueImpressionCount / pageStats.page.previous_period.shareUniqueImpressionCount) * 100 - 100) }}%</span>
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                
              </Tooltip>
            </div>
          </div>
          <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">
        </template>
        <template v-else>
          <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
            <i class="fa-regular fa-eye"></i>
            <h3>{{$t('dash.reporting.impression')}}</h3>
            <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
            <p v-if="pageStats.page.totalImpressions === null">N/A</p>
            <Tooltip v-else-if="pageStats.page.totalImpressions   >= 1000000" :text="numberSpacing(pageStats.page.totalImpressions)">
              <p class="big-number">{{ numberSpacing(Number((pageStats.page.totalImpressions  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
              
            </Tooltip>
            <Tooltip v-else-if="pageStats.page.totalImpressions   >= 1000" :text="numberSpacing(pageStats.page.totalImpressions)">
              <p class="big-number">{{ numberSpacing(Number((pageStats.page.totalImpressions)/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
              
            </Tooltip>
            <p v-else>{{ numberSpacing(pageStats.page.totalImpressions  ) }}</p>
            <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && ['facebook', 'instagram', 'linkedin'].includes(lastPage.network)">
              <img src="../../../assets/img/status-waiting.gif">
            </div>
            <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.totalImpressions >= 0">
              <Tooltip v-if="pageStats.page.totalImpressions < pageStats.page.previous_period.totalImpressions" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.totalImpressions)" class="trending_down">
                  <span class="negative">-{{ formatPercentageChange(100 - (pageStats.page.totalImpressions / pageStats.page.previous_period.totalImpressions) * 100) }}%</span>
                  <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                  
              </Tooltip>
              <Tooltip v-if="pageStats.page.totalImpressions != 0 && pageStats.page.totalImpressions == pageStats.page.previous_period.totalImpressions" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.totalImpressions)" class="trending_flat">
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                
              </Tooltip>
              <Tooltip v-if="pageStats.page.totalImpressions > pageStats.page.previous_period.totalImpressions" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.totalImpressions)" class="trending_up">
                <span class="positive" v-if="pageStats.page.previous_period.totalImpressions > 0">+{{ formatPercentageChange((pageStats.page.totalImpressions / pageStats.page.previous_period.totalImpressions) * 100 - 100) }}%</span>
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                
              </Tooltip>
            </div>
          </div>
          <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">
        </template>

        <!-- click -->
        <template v-if="lastPage.network == 'linkedin'">
          <div v-if="pageStats && lastPage.network !== 'instagram' && lastPage.network !== 'tiktok' && !(lastPage.isGroup)" class="main-numbers">
            <i class="fa-solid fa-arrow-pointer"></i>
            <h3>{{$t('dash.reporting.clic')}}</h3>
            <img class="icon eng-ico" src="../../../assets/img/reporting_icons/clic.svg" alt="">
            <p v-if="pageStats.page.shareClickCount === null">N/A</p>
            <Tooltip v-else-if="pageStats.page.shareClickCount >= 1000000" :text="numberSpacing(pageStats.page.shareClickCount)">
              <p class="big-number">{{ numberSpacing(Number(pageStats.page.shareClickCount/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">M</span></p>
              
            </Tooltip>
            <Tooltip v-else-if="pageStats.page.shareClickCount >= 1000" :text="numberSpacing(pageStats.page.shareClickCount)">
              <p class="big-number">{{numberSpacing(Number(pageStats.page.shareClickCount/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">k</span></p>
              
            </Tooltip>
            <p v-else>{{ numberSpacing(pageStats.page.shareClickCount) }}</p>
            <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && ['facebook', 'instagram', 'linkedin'].includes(lastPage.network)">
              <img src="../../../assets/img/status-waiting.gif">
            </div>
            <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.shareClickCount >= 0">
              <Tooltip v-if="pageStats.page.shareClickCount < pageStats.page.previous_period.shareClickCount" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.shareClickCount)" class="trending_down">
                  <span class="negative">-{{ formatPercentageChange(100 - (pageStats.page.shareClickCount / pageStats.page.previous_period.shareClickCount) * 100) }}%</span>
                  <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                  
              </Tooltip>
              <Tooltip v-if="pageStats.page.shareClickCount != 0 && pageStats.page.shareClickCount == pageStats.page.previous_period.shareClickCount" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.shareClickCount)" class="trending_flat">
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                
              </Tooltip>
              <Tooltip v-if="pageStats.page.shareClickCount > pageStats.page.previous_period.shareClickCount" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.shareClickCount)" class="trending_up">
                <span class="positive" v-if="pageStats.page.previous_period.shareClickCount > 0">+{{ formatPercentageChange((pageStats.page.shareClickCount / pageStats.page.previous_period.shareClickCount) * 100 - 100) }}%</span>
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                
              </Tooltip>
            </div>
          </div>
          <img v-else-if="lastPage.network !== 'instagram' && !(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">
        </template>
        <template v-else>
          <div v-if="pageStats && lastPage.network !== 'instagram' && lastPage.network !== 'tiktok' && !(lastPage.isGroup)" class="main-numbers">
            <i class="fa-solid fa-arrow-pointer"></i>
            <h3>{{$t('dash.reporting.clic')}}</h3>
            <img class="icon eng-ico" src="../../../assets/img/reporting_icons/clic.svg" alt="">
            <p v-if="pageStats.page.totalClicks === null">N/A</p>
            <Tooltip v-else-if="pageStats.page.totalClicks >= 1000000 && lastPage.network == 'pinterest'" :text="numbersubstring(pageStats.page.totalClicksRate)">
              <p class="big-number">{{ numberSpacing(Number(pageStats.page.totalClicks/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">M</span></p>
              
            </Tooltip>
            <Tooltip v-else-if="pageStats.page.totalClicks >= 1000 && lastPage.network == 'pinterest'" :text="numberSpacing(pageStats.page.totalClicks) + '(' + numbersubstring(pageStats.page.totalClicksRate) +'%)'">
              <p class="big-number">{{numberSpacing(Number(pageStats.page.totalClicks/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">k</span></p>
              
            </Tooltip>
            <Tooltip v-else-if="pageStats.page.totalClicks >= 1000000" :text="numberSpacing(pageStats.page.totalClicks)">
              <p class="big-number">{{ numberSpacing(Number(pageStats.page.totalClicks/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">M</span></p>
              
            </Tooltip>
            <Tooltip v-else-if="pageStats.page.totalClicks >= 1000" :text="numberSpacing(pageStats.page.totalClicks)">
              <p class="big-number">{{numberSpacing(Number(pageStats.page.totalClicks/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">k</span></p>
              
            </Tooltip>
            <Tooltip v-else-if="lastPage.network == 'pinterest'" :text="numbersubstring(pageStats.page.totalClicksRate) + '%'">
              <p class="big-number">{{ numberSpacing(pageStats.page.totalClicks) }}</p>
              
            </Tooltip>
            <p v-else>{{ numberSpacing(pageStats.page.totalClicks) }}</p>
            <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && ['facebook', 'instagram', 'linkedin'].includes(lastPage.network)">
              <img src="../../../assets/img/status-waiting.gif">
            </div>
            <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.totalClicks >= 0">
              <Tooltip v-if="pageStats.page.totalClicks < pageStats.page.previous_period.totalClicks" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.totalClicks)" class="trending_down">
                  <span class="negative">-{{ formatPercentageChange(100 - (pageStats.page.totalClicks / pageStats.page.previous_period.totalClicks) * 100) }}%</span>
                  <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                  
              </Tooltip>
              <Tooltip v-if="pageStats.page.totalClicks != 0 && pageStats.page.totalClicks == pageStats.page.previous_period.totalClicks" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.totalClicks)" class="trending_flat">
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                
              </Tooltip>
              <Tooltip v-if="pageStats.page.totalClicks > pageStats.page.previous_period.totalClicks" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.totalClicks)" class="trending_up">
                <span class="positive" v-if="pageStats.page.previous_period.totalClicks > 0">+{{ formatPercentageChange((pageStats.page.totalClicks / pageStats.page.previous_period.totalClicks) * 100 - 100) }}%</span>
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                
              </Tooltip>
            </div>
          </div>
          <img v-else-if="lastPage.network !== 'instagram' && lastPage.network !== 'tiktok' && !(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">
        </template>
        
        <!-- interactions -->
        <template v-if="lastPage.network == 'linkedin' || lastPage.network == 'tiktok'">
          <!-- comment -->
          <div v-if="pageStats && lastPage.network != 'pinterest'" class="main-numbers">
            <i class="fa-solid fa-hand-point-up"></i>
            <h3>{{$t('dash.reporting.comment')}}</h3>
            <img class="icon eng-ico" src="../../../assets/img/reporting_icons/clic.svg" alt="">
            <Tooltip :text="$t('dash.reporting.tooltip_interactionsLI')">
              <p v-if="pageStats.page.shareCommentCount === null">N/A</p>
              <p v-else-if="pageStats.page.shareCommentCount >= 1000000" class="big-number">{{numberSpacing(Number(pageStats.page.shareCommentCount/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">M</span></p>
              <p v-else-if="pageStats.page.shareCommentCount >= 1000" class="big-number">{{numberSpacing(Number(pageStats.page.shareCommentCount/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">k</span></p>
              <p class="big-number" v-else>{{ numberSpacing(pageStats.page.shareCommentCount) }}</p>
              
            </Tooltip>
            <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && ['facebook', 'instagram', 'linkedin'].includes(lastPage.network)">
              <img src="../../../assets/img/status-waiting.gif">
            </div>
            <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.shareCommentCount >= 0">
              <Tooltip v-if="pageStats.page.shareCommentCount < pageStats.page.previous_period.shareCommentCount" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.shareCommentCount)" class="trending_down">
                  <span class="negative">-{{ formatPercentageChange(100 - (pageStats.page.shareCommentCount / pageStats.page.previous_period.shareCommentCount) * 100) }}%</span>
                  <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                  
              </Tooltip>
              <Tooltip v-if="pageStats.page.shareLikeCount != 0 && pageStats.page.shareLikeCount == pageStats.page.previous_period.shareCommentCount" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.shareCommentCount)" class="trending_flat">
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
           
              </Tooltip>
              <Tooltip v-if="pageStats.page.shareCommentCount > pageStats.page.previous_period.shareCommentCount" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.shareCommentCount)" class="trending_up">
                <span class="positive" v-if="pageStats.page.previous_period.shareCommentCount > 0">+{{ formatPercentageChange((pageStats.page.shareCommentCount / pageStats.page.previous_period.shareCommentCount) * 100 - 100) }}%</span>
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
              
              </Tooltip>
            </div>
          </div>
          <img v-else-if="lastPage.network !== 'instagram' && !(lastPage.isGroup) && lastPage.network != 'pinterest'" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

          <!-- like -->
          <div v-if="pageStats && lastPage.network != 'pinterest'" class="main-numbers">
            <i class="fa-solid fa-hand-point-up"></i>
            <h3>{{$t('dash.reporting.like')}}</h3>
            <img class="icon eng-ico" src="../../../assets/img/reporting_icons/clic.svg" alt="">
            <Tooltip :text="$t('dash.reporting.tooltip_interactionsLI')">
              <p v-if="pageStats.page.shareLikeCount === null">N/A</p>
              <p v-else-if="pageStats.page.shareLikeCount >= 1000000" class="big-number">{{numberSpacing(Number(pageStats.page.shareLikeCount/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">M</span></p>
              <p v-else-if="pageStats.page.shareLikeCount >= 1000" class="big-number">{{numberSpacing(Number(pageStats.page.shareLikeCount/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">k</span></p>
              <p class="big-number" v-else>{{ numberSpacing(pageStats.page.shareLikeCount) }}</p>
              
            </Tooltip>
            <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && ['facebook', 'instagram', 'linkedin'].includes(lastPage.network)">
              <img src="../../../assets/img/status-waiting.gif">
            </div>
            <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.shareLikeCount >= 0">
              <Tooltip v-if="pageStats.page.shareLikeCount < pageStats.page.previous_period.shareLikeCount" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.shareLikeCount)" class="trending_down">
                  <span class="negative">-{{ formatPercentageChange(100 - (pageStats.page.shareLikeCount / pageStats.page.previous_period.shareLikeCount) * 100) }}%</span>
                  <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                  
              </Tooltip>
              <Tooltip v-if="pageStats.page.shareLikeCount != 0 && pageStats.page.shareLikeCount == pageStats.page.previous_period.shareLikeCount" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.shareLikeCount)" class="trending_flat">
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
          
              </Tooltip>
              <Tooltip v-if="pageStats.page.shareLikeCount > pageStats.page.previous_period.shareLikeCount" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.shareLikeCount)" class="trending_up">
                <span class="positive" v-if="pageStats.page.previous_period.shareLikeCount > 0">+{{ formatPercentageChange((pageStats.page.shareLikeCount / pageStats.page.previous_period.shareLikeCount) * 100 - 100) }}%</span>
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
              
              </Tooltip>
            </div>
          </div>
          <img v-else-if="lastPage.network !== 'instagram' && !(lastPage.isGroup) && lastPage.network != 'pinterest'" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

          <!-- share -->
          <div v-if="pageStats && lastPage.network != 'pinterest'" class="main-numbers">
            <i class="fa-solid fa-hand-point-up"></i>
            <h3>{{$t('dash.reporting.share')}}</h3>
            <img class="icon eng-ico" src="../../../assets/img/reporting_icons/clic.svg" alt="">
            <Tooltip :text="$t('dash.reporting.tooltip_interactionsLI')">
              <p v-if="pageStats.page.shareShareCount === null">N/A</p>
              <p v-else-if="pageStats.page.shareShareCount >= 1000000" class="big-number">{{numberSpacing(Number(pageStats.page.shareShareCount/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">M</span></p>
              <p v-else-if="pageStats.page.shareShareCount >= 1000" class="big-number">{{numberSpacing(Number(pageStats.page.shareShareCount/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">k</span></p>
              <p class="big-number" v-else>{{ numberSpacing(pageStats.page.shareShareCount) }}</p>
              
            </Tooltip>
            <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && ['facebook', 'instagram', 'linkedin'].includes(lastPage.network)">
              <img src="../../../assets/img/status-waiting.gif">
            </div>
            <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.shareShareCount >= 0">
              <Tooltip v-if="pageStats.page.shareShareCount < pageStats.page.previous_period.shareShareCount" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.shareShareCount)" class="trending_down">
                  <span class="negative">-{{ formatPercentageChange(100 - (pageStats.page.shareShareCount / pageStats.page.previous_period.shareShareCount) * 100) }}%</span>
                  <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                  
              </Tooltip>
              <Tooltip v-if="pageStats.page.shareShareCount != 0 && pageStats.page.shareShareCount == pageStats.page.previous_period.shareShareCount" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.shareShareCount)" class="trending_flat">
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>

              </Tooltip>
              <Tooltip v-if="pageStats.page.shareShareCount > pageStats.page.previous_period.shareShareCount" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.shareShareCount)" class="trending_up">
                <span class="positive" v-if="pageStats.page.previous_period.shareShareCount > 0">+{{ formatPercentageChange((pageStats.page.shareShareCount / pageStats.page.previous_period.shareShareCount) * 100 - 100) }}%</span>
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
              
              </Tooltip>
            </div>
          </div>
          <img v-else-if="lastPage.network !== 'instagram' && !(lastPage.isGroup) && lastPage.network != 'pinterest'" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

        </template>
        <template v-else>
          <div v-if="pageStats && lastPage.network != 'pinterest'" class="main-numbers">
            <i class="fa-solid fa-hand-point-up"></i>
            <h3>{{$t('dash.reporting.interactions')}}</h3>
            <img class="icon eng-ico" src="../../../assets/img/reporting_icons/clic.svg" alt="">
            <Tooltip v-if="lastPage.network == 'facebook'" :text="`${$t('dash.reporting.tooltip_interactionsFB')} : ${numberSpacing(pageStats.page.totalInteractions || pageStats.page.totalEngagement)}`">
              <p v-if="!pageStats.page.totalInteractions && !pageStats.page.totalEngagement">N/A</p>
              <p v-else-if="pageStats.page.totalInteractions >= 1000000" class="big-number">{{numberSpacing(Number((pageStats.page.totalInteractions)/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">M</span></p>
              <p v-else-if="pageStats.page.totalInteractions >= 1000" class="big-number">{{numberSpacing(Number((pageStats.page.totalInteractions)/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">k</span></p>
              <p class="big-number" v-else-if="pageStats.page.totalInteractions">{{ numberSpacing(pageStats.page.totalInteractions) }}</p>
              <p v-else-if="pageStats.page.totalEngagement >= 1000000" class="big-number">{{numberSpacing(Number((pageStats.page.totalEngagement)/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">M</span></p>
              <p v-else-if="pageStats.page.totalEngagement >= 1000" class="big-number">{{numberSpacing(Number((pageStats.page.totalEngagement)/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">k</span></p>
              <p class="big-number" v-else>{{ numberSpacing(pageStats.page.totalInteractions || pageStats.page.totalEngagement) }}</p>
           
            </Tooltip>
            <Tooltip v-else-if="lastPage.network == 'twitter'" :text="$t('dash.reporting.tooltip_interactionsTW')">
              <p v-if="pageStats.page.totalInteractions === null">N/A</p>
              <p v-else-if="pageStats.page.totalInteractions >= 1000000" class="big-number">{{numberSpacing(Number(pageStats.page.totalInteractions/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">M</span></p>
              <p v-else-if="pageStats.page.totalInteractions >= 1000" class="big-number">{{numberSpacing(Number(pageStats.page.totalInteractions/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">k</span></p>
              <p class="big-number"  v-else>{{ numberSpacing(pageStats.page.totalInteractions) }}</p>
              
            </Tooltip>
            <Tooltip v-else-if="lastPage.network == 'instagram'" :text="$t('dash.reporting.tooltip_interactionsIG')">
              <p v-if="pageStats.page.totalInteractions === null">N/A</p>
              <p v-else-if="pageStats.page.totalInteractions >= 1000000" class="big-number">{{numberSpacing(Number(pageStats.page.totalInteractions/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">M</span></p>
              <p v-else-if="pageStats.page.totalInteractions >= 1000" class="big-number">{{numberSpacing(Number(pageStats.page.totalInteractions/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">k</span></p>
              <p class="big-number" v-else>{{ numberSpacing(pageStats.page.totalInteractions) }}</p>
         
            </Tooltip>
            <Tooltip v-else-if="lastPage.network == 'linkedin'" :text="$t('dash.reporting.tooltip_interactionsLI')">
              <p v-if="pageStats.page.totalInteractions === null">N/A</p>
              <p v-else-if="pageStats.page.totalInteractions >= 1000000" class="big-number">{{numberSpacing(Number(pageStats.page.totalInteractions/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">M</span></p>
              <p v-else-if="pageStats.page.totalInteractions >= 1000" class="big-number">{{numberSpacing(Number(pageStats.page.totalInteractions/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">k</span></p>
              <p class="big-number" v-else>{{ numberSpacing(pageStats.page.totalInteractions) }}</p>
              
            </Tooltip>
            <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && ['facebook', 'instagram', 'linkedin'].includes(lastPage.network)">
              <img src="../../../assets/img/status-waiting.gif">
            </div>
            <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.totalInteractions >= 0">
              <Tooltip v-if="pageStats.page.totalInteractions < pageStats.page.previous_period.totalInteractions" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.totalInteractions)" class="trending_down">
                  <span class="negative">-{{ formatPercentageChange(100 - (pageStats.page.totalInteractions / pageStats.page.previous_period.totalInteractions) * 100) }}%</span>
                  <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                  
              </Tooltip>
              <Tooltip v-if="pageStats.page.totalInteractions != 0 && pageStats.page.totalInteractions == pageStats.page.previous_period.totalInteractions" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.totalInteractions)" class="trending_flat">
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
           
              </Tooltip>
              <Tooltip v-if="pageStats.page.totalInteractions > pageStats.page.previous_period.totalInteractions" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.totalInteractions)" class="trending_up">
                <span class="positive" v-if="pageStats.page.previous_period.totalInteractions > 0">+{{ formatPercentageChange((pageStats.page.totalInteractions / pageStats.page.previous_period.totalInteractions) * 100 - 100) }}%</span>
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
              
              </Tooltip>
            </div>
          </div>
          <img v-else-if="lastPage.network !== 'instagram' && !(lastPage.isGroup) && lastPage.network != 'pinterest'" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">
        </template>

        <!-- engagemment -->
        <template v-if="lastPage.network == 'linkedin'">
          <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
            <i class="fa-solid fa-handshake-angle"></i>
            <h3>{{$t('dash.reporting.engagemment')}}</h3>
            <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
            <p v-if="pageStats.page.shareEngagement === null">N/A</p>
            <Tooltip v-else-if="lastPage.network == 'pinterest'" :text="numberSpacing(pageStats.page.totalEngagements)">
              <p class="big-number">{{ (pageStats.page.shareEngagement*100).toLocaleString($i18n.locale, {maximumFractionDigits: 1}).replace(".", ",")   }} %</p>
              
            </Tooltip>
            <!-- <p v-else-if="lastPage.network == 'linkedin'">{{ (pageStats.page.shareEngagement).toLocaleString($i18n.locale, {maximumFractionDigits: 2}).replace(".", ",")   }} %</p> -->
            <p v-else-if="lastPage.network == 'linkedin'">{{ (((pageStats.page.shareClickCount + pageStats.page.shareCommentCount + pageStats.page.shareLikeCount + pageStats.page.shareShareCount) / pageStats.page.shareImpressionCount) * 100).toLocaleString($i18n.locale, {maximumFractionDigits: 1}).replace(".", ",")   }} %</p>
            <Tooltip v-else-if="lastPage.network == 'facebook' && !lastPage.isGroup" :text="`Interactions + Clics / Impressions`">
              <p>{{ (pageStats.page.shareEngagement).toLocaleString($i18n.locale, {maximumFractionDigits: 2}).replace(".", ",") }} % </p>
              
            </Tooltip>
            <p v-else>{{ (pageStats.page.shareEngagement).toLocaleString($i18n.locale, {maximumFractionDigits: 2}).replace(".", ",")   }} % </p>
            <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && ['facebook', 'instagram', 'linkedin'].includes(lastPage.network)">
              <img src="../../../assets/img/status-waiting.gif">
            </div>
            <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.shareEngagement >= 0">
              <Tooltip v-if="parseFloat(pageStats.page.shareEngagement) < parseFloat(pageStats.page.previous_period.shareEngagement)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + pageStats.page.previous_period.shareEngagement.toLocaleString($i18n.locale, {maximumFractionDigits: 2}).replace('.', ',') + ' %'" class="trending_down">
                  <span class="negative">-{{ formatPercentageChange(100 - (parseFloat(pageStats.page.shareEngagement) / parseFloat(pageStats.page.previous_period.shareEngagement)) * 100) }}%</span>
                  <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                  
              </Tooltip>
              <Tooltip v-if="parseFloat(pageStats.page.shareEngagement) != 0 && parseFloat(pageStats.page.shareEngagement) == parseFloat(pageStats.page.previous_period.shareEngagement)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + pageStats.page.previous_period.shareEngagement.toLocaleString($i18n.locale, {maximumFractionDigits: 2}).replace('.', ',') + ' %'" class="trending_flat">
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                
              </Tooltip>
              <Tooltip v-if="parseFloat(pageStats.page.shareEngagement) > parseFloat(pageStats.page.previous_period.shareEngagement)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + pageStats.page.previous_period.shareEngagement.toLocaleString($i18n.locale, {maximumFractionDigits: 2}).replace('.', ',') + ' %'" class="trending_up">
                <span class="positive" v-if="parseFloat(pageStats.page.previous_period.shareEngagement) > 0">+{{ formatPercentageChange((parseFloat(pageStats.page.shareEngagement) / parseFloat(pageStats.page.previous_period.shareEngagement)) * 100 - 100) }}%</span>
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                
              </Tooltip>
            </div>
          </div>
          <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">
        </template>
        <template v-else>
          <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
            <i class="fa-solid fa-handshake-angle"></i>
            <h3>{{$t('dash.reporting.engagemment')}}</h3>
            <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
            <p v-if="pageStats.page.totalReachEngag === null">N/A</p>
            <Tooltip v-else-if="lastPage.network == 'pinterest'" :text="numberSpacing(pageStats.page.totalEngagements)">
              <p class="big-number">{{ (pageStats.page.totalReachEngag*100).toLocaleString($i18n.locale, {maximumFractionDigits: 1}).replace(".", ",")   }} %</p>
              
            </Tooltip>
            <p v-else-if="lastPage.network == 'linkedin'">{{ (pageStats.page.totalReachEngag).toLocaleString($i18n.locale, {maximumFractionDigits: 1}).replace(".", ",")   }} % </p>
            <Tooltip v-else-if="lastPage.network == 'facebook' && !lastPage.isGroup" :text="`Interactions + Clics / Impressions`">
              <p>{{ (pageStats.page.totalReachEngag).toLocaleString($i18n.locale, {maximumFractionDigits: 2}).replace(".", ",") }} % </p>
              
            </Tooltip>
            <p v-else>{{ (pageStats.page.totalReachEngag).toLocaleString($i18n.locale, {maximumFractionDigits: 2}).replace(".", ",")   }} % </p>
            <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && ['facebook', 'instagram', 'linkedin'].includes(lastPage.network)">
              <img src="../../../assets/img/status-waiting.gif">
            </div>
            <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.totalReachEngag >= 0">
              <Tooltip v-if="parseFloat(pageStats.page.totalReachEngag) < parseFloat(pageStats.page.previous_period.totalReachEngag)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + pageStats.page.previous_period.totalReachEngag.toLocaleString($i18n.locale, {maximumFractionDigits: 2}).replace('.', ',') + ' %'" class="trending_down">
                  <span class="negative">-{{ formatPercentageChange(100 - (parseFloat(pageStats.page.totalReachEngag) / parseFloat(pageStats.page.previous_period.totalReachEngag)) * 100) }}%</span>
                  <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                  
              </Tooltip>
              <Tooltip v-if="parseFloat(pageStats.page.totalReachEngag) != 0 && parseFloat(pageStats.page.totalReachEngag) == parseFloat(pageStats.page.previous_period.totalReachEngag)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + pageStats.page.previous_period.totalReachEngag.toLocaleString($i18n.locale, {maximumFractionDigits: 2}).replace('.', ',') + ' %'" class="trending_flat">
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                
              </Tooltip>
              <Tooltip v-if="parseFloat(pageStats.page.totalReachEngag) > parseFloat(pageStats.page.previous_period.totalReachEngag)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + pageStats.page.previous_period.totalReachEngag.toLocaleString($i18n.locale, {maximumFractionDigits: 2}).replace('.', ',') + ' %'" class="trending_up">
                <span class="positive" v-if="parseFloat(pageStats.page.previous_period.totalReachEngag) > 0">+{{ formatPercentageChange((parseFloat(pageStats.page.totalReachEngag) / parseFloat(pageStats.page.previous_period.totalReachEngag)) * 100 - 100) }}%</span>
                <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                
              </Tooltip>
            </div>
          </div>
          <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">
        </template>

        <template v-if="lastPage.network == 'pinterest'">
          <div v-if="pageStats && lastPage.network == 'pinterest'" class="main-numbers">
            <i class="fa-solid fa-arrow-pointer"></i>
            <h3>{{$t('dash.reporting.outboundclick')}}</h3>
            <img class="icon imp-ico" src="../../../assets/img/reporting_icons/clic.svg" alt="">
            <p v-if="pageStats.page.totalOutboundclick === null">N/A</p>
            <Tooltip v-else-if="pageStats.page.totalOutboundclick   >= 1000000" :text="numberSpacing(pageStats.page.totalOutboundclick) + '(' + numbersubstring(pageStats.page.totalOutboundclickRate) + '%)'">
              <p class="big-number">{{ numberSpacing(Number((pageStats.page.totalOutboundclick  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
              
            </Tooltip>
            <Tooltip v-else-if="pageStats.page.totalOutboundclick   >= 1000" :text="numberSpacing(pageStats.page.totalOutboundclick) + '(' + numbersubstring(pageStats.page.totalOutboundclickRate) + '%)'">
              <p class="big-number">{{ numberSpacing(Number((pageStats.page.totalOutboundclick)/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
              
            </Tooltip>
            <Tooltip v-else :text="numbersubstring(pageStats.page.totalOutboundclickRate) + '%'">
              <p class="big-number">{{ numberSpacing(pageStats.page.totalOutboundclick  ) }}</p>
              
            </Tooltip>
          </div>

          <div v-if="pageStats && lastPage.network == 'pinterest'" class="main-numbers">
            <i class="fa-solid fa-floppy-disk"></i>
            <h3>{{$t('dash.reporting.save')}}</h3>
            <img class="icon imp-ico" src="../../../assets/img/reporting_icons/clic.svg" alt="">
            <p v-if="pageStats.page.totalSave === null">N/A</p>
            <Tooltip v-else-if="pageStats.page.totalSave   >= 1000000" :text="numberSpacing(pageStats.page.totalSave) + '(' + numbersubstring(pageStats.page.totalSaveRate) + '%)'">
              <p class="big-number">{{ numberSpacing(Number((pageStats.page.totalSave  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
              
            </Tooltip>
            <Tooltip v-else-if="pageStats.page.totalSave   >= 1000" :text="numberSpacing(pageStats.page.totalSave) + '(' + numbersubstring(pageStats.page.totalSaveRate) + '%)'">
              <p class="big-number">{{ numberSpacing(Number((pageStats.page.totalSave)/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
              
            </Tooltip>
            <Tooltip v-else :text="numbersubstring(pageStats.page.totalSaveRate) + '%'">
              <p class="big-number">{{ numberSpacing(pageStats.page.totalSave  ) }}</p>
              
            </Tooltip>
          </div>      
        </template>
      </div>

      <div class="graph-wrapper" v-if="pageStats">
        <componentGraph
          class="graph"
          :data="graphData.filter(g => lastPage.network == 'linkedin' ? linkedinOverview.includes(g.name) : !notInOverview.includes(g.name))"
          :labels="graphLabels"
          :state="graphShowed"
          :lang="$i18n.locale"
          :section="'overview'"
          :key="'overview'"
        />
        <div class="graph-choice">
          <Tooltip :text="$t('dash.reporting.graph.choice.tooltip.posts')" position="bottom">  
          <vs-checkbox
            class="check"
            color="#E4BAF5"
            v-model="graphShowed"
            vs-value="0"
            >{{capitalize($t('dash.posts.title'))}}</vs-checkbox
          ></Tooltip>
          <Tooltip v-for="(item, idx) in graphNetwork.filter(g => lastPage.network == 'linkedin' ? linkedinOverview.includes(g.name) : !notInOverview.includes(g.name))" :key="`graph-select-overview-${idx}`" :text="item.description" position="bottom">
            <vs-checkbox class='check' 
              :color="item.color"
              :vs-value="`${idx + 1}`"
              v-model="graphShowed">
              {{item.text}} 
            </vs-checkbox>
            
          </Tooltip>
        </div>
      </div>
      <!-- <template v-if="pageStats && ['facebook','instagram'].includes(lastPage.network)"> -->      
      <template v-if="pageStats && ['linkedin'].includes(lastPage.network)">
        <div class="section-graph audiences">
          <div class="section-title">{{$t('dash.reporting.section.audience.title')}}</div>
          <div class="section-subtitle">{{$t('dash.reporting.section.audience.linkedin.subtitle')}}</div>
          
          <div v-if="graphData.filter(g => ['organicFollowerGain','paidFollowerGain'].includes(g.name)).length > 1">
            <div class="informations">
              <div v-if="pageStats" class="main-numbers">
                <i class="fa-solid fa-user-group"></i>
                <h3>{{$t('dash.reporting.organicFollowerGain')}}</h3>
                <img class="icon fan-ico" src="../../../assets/img/reporting_icons/fans.svg" alt="">
                <Tooltip v-if="pageStats.page.organicFollowerGain >= 1000000" :text="numberSpacing(pageStats.page.organicFollowerGain)">
                  <p class="big-number">{{ numberSpacing(Number(pageStats.page.organicFollowerGain/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}))}}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="pageStats.page.organicFollowerGain >= 1000" :text="numberSpacing(pageStats.page.organicFollowerGain)">
                  <p class="big-number">{{numberSpacing(Number(pageStats.page.organicFollowerGain/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{numberSpacing(pageStats.page.organicFollowerGain)}}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.organicFollowerGain">
                  <Tooltip v-if="pageStats.page.organicFollowerGain < pageStats.page.previous_period.organicFollowerGain" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.organicFollowerGain)" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (pageStats.page.organicFollowerGain / pageStats.page.previous_period.organicFollowerGain) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="pageStats.page.organicFollowerGain != 0 && pageStats.page.organicFollowerGain == pageStats.page.previous_period.organicFollowerGain" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.organicFollowerGain)" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="pageStats.page.organicFollowerGain > pageStats.page.previous_period.organicFollowerGain" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.organicFollowerGain)" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.organicFollowerGain > 0">+{{ formatPercentageChange((pageStats.page.organicFollowerGain / pageStats.page.previous_period.organicFollowerGain) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats" class="main-numbers">
                <i class="fa-solid fa-user-group"></i>
                <h3>{{$t('dash.reporting.paidFollowerGain')}}</h3>
                <img class="icon fan-ico" src="../../../assets/img/reporting_icons/fans.svg" alt="">
                <Tooltip v-if="pageStats.page.paidFollowerGain >= 1000000" :text="numberSpacing(pageStats.page.paidFollowerGain)">
                  <p class="big-number">{{ numberSpacing(Number(pageStats.page.paidFollowerGain/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}))}}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="pageStats.page.paidFollowerGain >= 1000" :text="numberSpacing(pageStats.page.paidFollowerGain)">
                  <p class="big-number">{{numberSpacing(Number(pageStats.page.paidFollowerGain/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{numberSpacing(pageStats.page.paidFollowerGain)}}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.paidFollowerGain">
                  <Tooltip v-if="pageStats.page.paidFollowerGain < pageStats.page.previous_period.paidFollowerGain" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.paidFollowerGain)" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (pageStats.page.paidFollowerGain / pageStats.page.previous_period.paidFollowerGain) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="pageStats.page.paidFollowerGain != 0 && pageStats.page.paidFollowerGain == pageStats.page.previous_period.paidFollowerGain" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.paidFollowerGain)" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="pageStats.page.paidFollowerGain > pageStats.page.previous_period.paidFollowerGain" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.paidFollowerGain)" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.paidFollowerGain > 0">+{{ formatPercentageChange((pageStats.page.paidFollowerGain / pageStats.page.previous_period.paidFollowerGain) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <componentGraph
                class="graph"
                :data="graphData.filter(g => ['organicFollowerGain','paidFollowerGain'].includes(g.name))"
                :state="graphShowedAudience"
                :labels="graphLabels"
                :lang="$i18n.locale"
                :section="'audiences'"
                :key="'audiences'"
              />
              <div class="graph-choice">
                <Tooltip v-for="(item, idx) in graphNetwork.filter(g => ['organicFollowerGain','paidFollowerGain'].includes(g.name))" :key="`graph-select-audience-${idx}`" :text="item.description" position="bottom">
                  <vs-checkbox class='check' 
                    :color="item.color"
                    :vs-value="`${idx}`"
                    v-model="graphShowedAudience">
                    {{item.text}} 
                  </vs-checkbox>
                  
                </Tooltip>
              </div>
            </div>
          </div>
        </div>
        <div class="section-graph impressions">
          <div class="section-title">{{$t('dash.reporting.section.impressions.page.linkedin.title')}}</div>
          <div class="section-subtitle">{{$t('dash.reporting.section.impressions.page.linkedin.subtitle')}}</div>
          

          <div v-if="graphData.filter(g => ['pageViews', 'pageCustomButtonClickCounts'].includes(g.name)).length == 2">
            <div class="informations">
              <div v-if="pageStats" class="main-numbers">
                <i class="fa-solid fa-user-group"></i>
                <h3>{{$t('dash.reporting.pageViews')}}</h3>
                <img class="icon fan-ico" src="../../../assets/img/reporting_icons/fans.svg" alt="">
                <Tooltip v-if="pageStats.page.pageViews >= 1000000" :text="numberSpacing(pageStats.page.pageViews)">
                  <p class="big-number">{{ numberSpacing(Number(pageStats.page.pageViews/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}))}}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="pageStats.page.pageViews >= 1000" :text="numberSpacing(pageStats.page.pageViews)">
                  <p class="big-number">{{numberSpacing(Number(pageStats.page.pageViews/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{numberSpacing(pageStats.page.pageViews)}}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.pageViews">
                  <Tooltip v-if="pageStats.page.pageViews < pageStats.page.previous_period.pageViews" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.pageViews)" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (pageStats.page.pageViews / pageStats.page.previous_period.pageViews) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="pageStats.page.pageViews != 0 && pageStats.page.pageViews == pageStats.page.previous_period.pageViews" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.pageViews)" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="pageStats.page.pageViews > pageStats.page.previous_period.pageViews" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.pageViews)" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.pageViews > 0">+{{ formatPercentageChange((pageStats.page.pageViews / pageStats.page.previous_period.pageViews) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats" class="main-numbers">
                <i class="fa-solid fa-user-group"></i>
                <h3>{{$t('dash.reporting.pageCustomButtonClickCounts')}}</h3>
                <img class="icon fan-ico" src="../../../assets/img/reporting_icons/fans.svg" alt="">
                <Tooltip v-if="pageStats.page.pageCustomButtonClickCounts >= 1000000" :text="numberSpacing(pageStats.page.pageCustomButtonClickCounts)">
                  <p class="big-number">{{ numberSpacing(Number(pageStats.page.pageCustomButtonClickCounts/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}))}}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="pageStats.page.pageCustomButtonClickCounts >= 1000" :text="numberSpacing(pageStats.page.pageCustomButtonClickCounts)">
                  <p class="big-number">{{numberSpacing(Number(pageStats.page.pageCustomButtonClickCounts/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{numberSpacing(pageStats.page.pageCustomButtonClickCounts)}}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.pageCustomButtonClickCounts">
                  <Tooltip v-if="pageStats.page.pageCustomButtonClickCounts < pageStats.page.previous_period.pageCustomButtonClickCounts" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.pageCustomButtonClickCounts)" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (pageStats.page.pageCustomButtonClickCounts / pageStats.page.previous_period.pageCustomButtonClickCounts) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="pageStats.page.pageCustomButtonClickCounts != 0 && pageStats.page.pageCustomButtonClickCounts == pageStats.page.previous_period.pageCustomButtonClickCounts" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.pageCustomButtonClickCounts)" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="pageStats.page.pageCustomButtonClickCounts > pageStats.page.previous_period.pageCustomButtonClickCounts" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.pageCustomButtonClickCounts)" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.pageCustomButtonClickCounts > 0">+{{ formatPercentageChange((pageStats.page.pageCustomButtonClickCounts / pageStats.page.previous_period.pageCustomButtonClickCounts) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <componentGraph
                class="graph"
                :data="graphData.filter(g => ['pageViews', 'pageCustomButtonClickCounts'].includes(g.name))"
                :state="graphShowedImpressions"
                :labels="graphLabels"
                :lang="$i18n.locale"
                :section="'impressions'"
                :key="'impressions'"
              />
              <div class="graph-choice">
                <Tooltip v-for="(item, idx) in graphNetwork.filter(g => ['pageViews', 'pageCustomButtonClickCounts'].includes(g.name))" :key="`graph-select-impressions-${idx}`" :text="item.description" position="bottom">
                  <vs-checkbox class='check' 
                    :color="item.color"
                    :vs-value="`${idx}`"
                    v-model="graphShowedImpressions">
                    {{item.text}} 
                  </vs-checkbox>
                  
                </Tooltip>
              </div>
            </div>
          </div>

        </div>

        <div class="section-graph demographie">
          <div class="section-title">{{$t(`dash.reporting.section.demographie.title.${lastPage.network}`)}}</div>
          <div class="section-subtitle">{{$t(`dash.reporting.section.demographie.subtitle.${lastPage.network}`)}}</div>
          <!--<div v-if="graphData.filter(g => g.data && ['fans_country', 'fans_locale', 'fans_city', 'fans_male_age', 'fans_female_age', 'fans_undifined_age'].includes(g.name)).length == 6">-->
          <div v-if="graphData.filter(g => g.data && ['fans_country', 'fans_city', 'fans_male_age', 'fans_female_age', 'fans_undifined_age'].includes(g.name)).length >= 1">
            <MapChart
              :countryData="graphData.filter(g => ['fans_country'].includes(g.name))[0].data"
              highColor="rgba(106, 31, 76, 1)"
              lowColor="rgba(106, 31, 76, 0.1)"
              countryStrokeColor="#ffffff"
              defaultCountryFillColor="#dadada"
              :LangUser="$i18n.locale"
              :currencyAdd="false"
            />
            
            <ul class="bar">
              <!-- <li v-if="graphData.find(g => ['fans_locale'].includes(g.name))">
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['fans_locale'].includes(g.name)).slice(0,10)"
                  :state="['0','1','2','3','4','5','6','7','8','9']"
                  :labels="graphData.find(g => ['fans_locale'].includes(g.name)).labels.slice(0,10)"
                  :lang="$i18n.locale"
                  :section="'demographie_locale'"
                  :key="'demographie_locale'"
                  :size="sizeHorizontalGraph"
                />
              </li> -->
              <li>
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['fans_city'].includes(g.name)).slice(0,10)"
                  :state="['0','1','2','3','4','5','6','7','8','9']"
                  :labels="graphData.find(g => ['fans_city'].includes(g.name)).labels.slice(0,10).map(n => n.replace(/\b(Greater|Metropolitan|region|area)\b/gi, '').replace(/\s\s+/g, ' ').trim())"
                  :lang="$i18n.locale"
                  :section="'demographie_city'"
                  :key="'demographie_city'"
                  :size="sizeHorizontalGraph"
                />
              </li>
              <li class="small">
                <div class="graph_name">{{ $t('dash.reporting.graph.linkedin.seniority') }}</div>
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['followerCountsBySeniority'].includes(g.name))"
                  :state="Array.from({length: pageStats.page.followerCountsBySeniority.length}, (_, i) => `${i}`)"
                  :labels="pageStats.page.followerCountsBySeniority.map(f => f.name)"
                  :lang="$i18n.locale"
                  :section="'demographie_seniority'"
                  :key="'demographie_seniority'"
                />
              </li>
              <li class="small">
                <div class="graph_name">{{ $t('dash.reporting.graph.linkedin.function') }}</div>
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['followerCountsByFunction'].includes(g.name))"
                  :state="Array.from({length: pageStats.page.followerCountsByFunction.length}, (_, i) => `${i}`)"
                  :labels="pageStats.page.followerCountsByFunction.map(f => f.name)"
                  :lang="$i18n.locale"
                  :section="'demographie_function'"
                  :key="'demographie_function'"
                />
              </li>
              <!-- 'followerCountsByStaffCountRange', 'followerCountsBySeniority', 'followerCountsByIndustry', 'followerCountsByFunction' -->
              <li class="small">
                <div class="graph_name">{{ $t('dash.reporting.graph.linkedin.industry') }}</div>
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['followerCountsByIndustry'].includes(g.name))"
                  :state="Array.from({length: pageStats.page.followerCountsByIndustry.length}, (_, i) => `${i}`)"
                  :labels="pageStats.page.followerCountsByIndustry.map(f => f.name)"
                  :lang="$i18n.locale"
                  :section="'demographie_industry'"
                  :key="'demographie_industry'"
                />
              </li>
              <li class="small">
                <div class="graph_name">{{ $t('dash.reporting.graph.linkedin.StaffCount') }}</div>
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['followerCountsByStaffCountRange'].includes(g.name))"
                  :state="Array.from({length: pageStats.page.followerCountsByStaffCountRange.length}, (_, i) => `${i}`)"
                  :labels="pageStats.page.followerCountsByStaffCountRange.map(f => f.name).map(n => n.replace('SIZE_', '').replace('_TO_', ' à ').replace('_OR_MORE', ' ou plus'))"
                  :lang="$i18n.locale"
                  :section="'demographie_StaffCount'"
                  :key="'demographie_StaffCount'"
                />
              </li>
            </ul>
            
            <!-- <ul class="bar" v-if="!graphData.find(g => ['fans_locale'].includes(g.name))">
              <li class="big">
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['fans_age'].includes(g.name))"
                  :state="['0']"
                  :labels="graphData.find(g => ['fans_age'].includes(g.name)).labels"
                  :lang="$i18n.locale"
                  :section="'demographie_age'"
                  :key="'demographie_age'"
                />
              </li>
              <li class="small">
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['fans_gender'].includes(g.name))"
                  :state="['0']"
                  :labels="[$t('page_follows_by_gender_male'), $t('page_follows_by_gender_female'), $t('page_follows_by_gender_undefined')]"
                  :lang="$i18n.locale"
                  :section="'demographie_gender'"
                  :key="'demographie_gender'"
                />
              </li>
            </ul>
            <ul class="bar" v-else-if="lastPage.network == 'instagram'">
              <li class="big">
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['fans_male_age', 'fans_female_age', 'fans_undifined_age'].includes(g.name))"
                  :state="['0','1','2']"
                  :labels="graphData.find(g => ['fans_male_age'].includes(g.name)).labels"
                  :lang="$i18n.locale"
                  :section="'demographie_gender_age'"
                  :key="'demographie_gender_age'"
                />
              </li>
              <li class="small" v-if="lastPage.network == 'instagram'">
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['fans_by_gender'].includes(g.name))"
                  :state="['0','1','2']"
                  :labels="[$t('page_follows_by_gender_male'), $t('page_follows_by_gender_female'), $t('page_follows_by_gender_undefined')]"
                  :lang="$i18n.locale"
                  :section="'demographie_gender'"
                  :key="'demographie_gender'"
                />
              </li>
            </ul> -->

            <!-- <div class="profil-type" v-if="lastPage.network === 'facebook' && pageStats && pageStats.page && pageStats.page.profil_type_age && pageStats.page.profil_type_country">
              <div class="section-subtitle">{{$t('dash.reporting.section.demographie.subtitle.profil_type')}}</div>
              <div class="content">
                {{ pageStats.page.profil_type_age.slice(2) }} 
                <span v-if="pageStats.page.profil_type_age.includes('M.')">{{ $t('dash.reporting.section.demographie.type_man') }}</span>
                <span v-else-if="pageStats.page.profil_type_age.includes('F.')">{{ $t('dash.reporting.section.demographie.type_female') }}</span>
                <span v-else-if="pageStats.page.profil_type_age.includes('U.')">{{ $t('dash.reporting.section.demographie.type_undefined') }}</span>
                <img :src="`https://flagcdn.com/h40/${pageStats.page.profil_type_country.toLowerCase()}.png`">
              </div>
            </div> -->
          </div>
        </div>
      </template>
      <template v-else-if="pageStats && ['facebook', 'instagram', 'tiktok'].includes(lastPage.network)">
        <div class="section-graph audiences" v-if="lastPage.network == 'instagram'">
          <div class="section-title">{{$t('dash.reporting.section.audience.title')}}</div>
          <div class="section-subtitle">{{$t('dash.reporting.section.audience.subtitle')}}</div>
          <div v-if="graphData.filter(g => ['impressions_graph','reach_graph','follower_count_graph'].includes(g.name)).length > 1">
            <div class="informations">
              <div v-if="pageStats" class="main-numbers">
                <i class="fa-solid fa-user-group"></i>
                <h3>{{$t('dash.reporting.nb_fans')}}</h3>
                <img class="icon fan-ico" src="../../../assets/img/reporting_icons/fans.svg" alt="">
                <Tooltip v-if="pageStats.page.page_fans >= 1000000" :text="numberSpacing(pageStats.page.page_fans)">
                  <p class="big-number">{{ numberSpacing(Number(pageStats.page.page_fans/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}))}}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="pageStats.page.page_fans >= 1000" :text="numberSpacing(pageStats.page.page_fans)">
                  <p class="big-number">{{numberSpacing(Number(pageStats.page.page_fans/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{numberSpacing(pageStats.page.page_fans)}}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_fans">
                  <Tooltip v-if="pageStats.page.page_fans < pageStats.page.previous_period.page_fans" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_fans)" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (pageStats.page.page_fans / pageStats.page.previous_period.page_fans) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="pageStats.page.page_fans != 0 && pageStats.page.page_fans == pageStats.page.previous_period.page_fans" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_fans)" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="pageStats.page.page_fans > pageStats.page.previous_period.page_fans" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_fans)" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_fans > 0">+{{ formatPercentageChange((pageStats.page.page_fans / pageStats.page.previous_period.page_fans) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-eye"></i>
                <h3>{{$t('dash.label.fb.page_views')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'impression_posts_graph') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'impression_posts_graph').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'impression_posts_graph').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'impression_posts_graph').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'impression_posts_graph').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'impression_posts_graph').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'impression_posts_graph').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'impression_posts_graph').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'instagram'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.impression_posts_graph">
                  <Tooltip v-if="graphData.find(g => g.name == 'impression_posts_graph').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.impression_posts_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.impression_posts_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'impression_posts_graph').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.impression_posts_graph.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'impression_posts_graph').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'impression_posts_graph').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.impression_posts_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.impression_posts_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'impression_posts_graph').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.impression_posts_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.impression_posts_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.impression_posts_graph.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'impression_posts_graph').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.impression_posts_graph.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-eye"></i>
                <h3>{{$t('dash.label.fb.impressions_reach')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'reach_graph') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'reach_graph').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'reach_graph').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'reach_graph').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'reach_graph').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'reach_graph').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'reach_graph').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'reach_graph').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'instagram'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.daily_reach_graph">
                  <Tooltip v-if="graphData.find(g => g.name == 'reach_graph').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.daily_reach_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_reach_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'reach_graph').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.daily_reach_graph.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'reach_graph').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'reach_graph').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.daily_reach_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_reach_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'reach_graph').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.daily_reach_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_reach_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.daily_reach_graph.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'reach_graph').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.daily_reach_graph.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">
            </div>
            <componentGraph
              class="graph"
              :data="graphData.filter(g => ['impressions_graph','reach_graph','follower_count_graph'].includes(g.name))"
              :state="graphShowedAudience"
              :labels="graphLabels"
              :lang="$i18n.locale"
              :section="'audiences'"
              :key="'audiences'"
            />
            <div class="graph-choice">
              <Tooltip v-for="(item, idx) in graphNetwork.filter(g => ['impressions_graph','reach_graph','follower_count_graph'].includes(g.name))" :key="`graph-select-audience-${idx}`" :text="item.description" position="bottom">
                <vs-checkbox class='check' 
                  :color="item.color"
                  :vs-value="`${idx}`"
                  v-model="graphShowedAudience">
                  {{item.text}} 
                </vs-checkbox>
                
              </Tooltip>
            </div>
          </div>
        </div>
        <!-- <div class="section-graph profil" v-if="lastPage.network == 'instagram'">
          <div class="section-title">{{$t('dash.reporting.section.profil.title')}}</div>
          <div class="section-subtitle">{{$t('dash.reporting.section.profil.subtitle')}}</div>
          <div v-if="graphData.filter(g => ['email_contacts_graph','phone_call_clicks_graph','text_message_clicks_graph', 'get_directions_clicks_graph', 'website_clicks_graph', 'profile_views_graph'].includes(g.name)).length > 1">
            <div class="informations">
              
              <div v-if="pageStats" class="main-numbers">
                <i class="fa-solid fa-at"></i>
                <h3>{{$t('dash.label.insta.email_contacts_graph')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'email_contacts_graph') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'email_contacts_graph').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'email_contacts_graph').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'email_contacts_graph').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'email_contacts_graph').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'email_contacts_graph').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'email_contacts_graph').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'email_contacts_graph').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'instagram'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.daily_email_contacts_graph">
                  <Tooltip v-if="graphData.find(g => g.name == 'email_contacts_graph').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.daily_email_contacts_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_email_contacts_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'email_contacts_graph').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.daily_email_contacts_graph.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'email_contacts_graph').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.daily_email_contacts_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_email_contacts_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'email_contacts_graph').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.daily_email_contacts_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_email_contacts_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.daily_email_contacts_graph.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'email_contacts_graph').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.daily_email_contacts_graph.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-mobile-retro"></i>
                <h3>{{$t('dash.label.insta.phone_call_clicks_graph')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'phone_call_clicks_graph') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'phone_call_clicks_graph').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'phone_call_clicks_graph').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'phone_call_clicks_graph').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'phone_call_clicks_graph').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'phone_call_clicks_graph').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'phone_call_clicks_graph').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'phone_call_clicks_graph').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'instagram'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.daily_phone_call_clicks_graph">
                  <Tooltip v-if="graphData.find(g => g.name == 'phone_call_clicks_graph').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.daily_phone_call_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_phone_call_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'phone_call_clicks_graph').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.daily_phone_call_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'phone_call_clicks_graph').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.daily_phone_call_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_phone_call_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'phone_call_clicks_graph').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.daily_phone_call_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_phone_call_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.daily_phone_call_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'phone_call_clicks_graph').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.daily_phone_call_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-arrow-pointer"></i>
                <h3>{{$t('dash.label.insta.text_message_clicks_graph')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'text_message_clicks_graph') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'text_message_clicks_graph').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'text_message_clicks_graph').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'text_message_clicks_graph').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'text_message_clicks_graph').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'text_message_clicks_graph').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'text_message_clicks_graph').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'text_message_clicks_graph').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'instagram'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.daily_text_message_clicks_graph">
                  <Tooltip v-if="graphData.find(g => g.name == 'text_message_clicks_graph').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.daily_text_message_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_text_message_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'text_message_clicks_graph').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.daily_text_message_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'text_message_clicks_graph').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.daily_text_message_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_text_message_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'text_message_clicks_graph').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.daily_text_message_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_text_message_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.daily_text_message_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'text_message_clicks_graph').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.daily_text_message_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-arrow-pointer"></i>
                <h3>{{$t('dash.label.insta.get_directions_clicks_graph')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'get_directions_clicks_graph') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'get_directions_clicks_graph').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'get_directions_clicks_graph').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'get_directions_clicks_graph').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'get_directions_clicks_graph').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'get_directions_clicks_graph').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'get_directions_clicks_graph').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'get_directions_clicks_graph').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'instagram'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.daily_get_directions_clicks_graph">
                  <Tooltip v-if="graphData.find(g => g.name == 'get_directions_clicks_graph').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.daily_get_directions_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_get_directions_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'get_directions_clicks_graph').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.daily_get_directions_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'get_directions_clicks_graph').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.daily_get_directions_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_get_directions_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'get_directions_clicks_graph').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.daily_get_directions_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_get_directions_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.daily_get_directions_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'get_directions_clicks_graph').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.daily_get_directions_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-arrow-pointer"></i>
                <h3>{{$t('dash.label.insta.website_clicks_graph')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'website_clicks_graph') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'website_clicks_graph').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'website_clicks_graph').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'website_clicks_graph').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'website_clicks_graph').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'website_clicks_graph').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'website_clicks_graph').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'website_clicks_graph').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'instagram'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.daily_website_clicks_graph">
                  <Tooltip v-if="graphData.find(g => g.name == 'website_clicks_graph').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.daily_website_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_website_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'website_clicks_graph').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.daily_website_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'website_clicks_graph').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.daily_website_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_website_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'website_clicks_graph').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.daily_website_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_website_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.daily_website_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'website_clicks_graph').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.daily_website_clicks_graph.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-eye"></i>
                <h3>{{$t('dash.label.insta.profile_views_graph')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'profile_views_graph') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'profile_views_graph').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'profile_views_graph').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'profile_views_graph').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'profile_views_graph').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'profile_views_graph').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'profile_views_graph').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'profile_views_graph').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'instagram'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.daily_profile_views_graph">
                  <Tooltip v-if="graphData.find(g => g.name == 'profile_views_graph').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.daily_profile_views_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_profile_views_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'profile_views_graph').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.daily_profile_views_graph.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'profile_views_graph').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.daily_profile_views_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_profile_views_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'profile_views_graph').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.daily_profile_views_graph.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.daily_profile_views_graph.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.daily_profile_views_graph.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'profile_views_graph').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.daily_profile_views_graph.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">
            </div>
            <componentGraph
              class="graph"
              :data="graphData.filter(g => ['email_contacts_graph','phone_call_clicks_graph','text_message_clicks_graph', 'get_directions_clicks_graph', 'website_clicks_graph', 'profile_views_graph'].includes(g.name))"
              :state="graphShowedProfil"
              :labels="graphLabels"
              :lang="$i18n.locale"
              :section="'profil'"
              :key="'profil'"
            />
            <div class="graph-choice">
              <Tooltip v-for="(item, idx) in graphNetwork.filter(g => ['email_contacts_graph','phone_call_clicks_graph','text_message_clicks_graph', 'get_directions_clicks_graph', 'website_clicks_graph', 'profile_views_graph'].includes(g.name))" :key="`graph-select-profil-${idx}`" :text="item.description" position="bottom">
                <vs-checkbox class='check' 
                  :color="item.color"
                  :vs-value="`${idx}`"
                  v-model="graphShowedProfil">
                  {{item.text}} 
                </vs-checkbox>
                
              </Tooltip>
            </div>
          </div>
        </div> -->

        <div class="section-graph audiences" v-if="['facebook', 'tiktok'].includes(lastPage.network)">
          <div class="section-title">{{$t('dash.reporting.section.audience.title')}}</div>
          <div class="section-subtitle">{{$t('dash.reporting.section.audience.subtitle')}}</div>
          <div v-if="graphData.filter(g => ['fans_evol', 'fans_adds', 'fans_paids_adds', 'fans_removes', 'page_follows', 'page_daily_follows', 'page_daily_unfollows'].includes(g.name)).length > 1">
            <div class="informations">
              <div v-if="pageStats && lastPage.network == 'facebook'" class="main-numbers">
                <i class="fa-solid fa-user-group"></i>
                <!-- <h3>{{$t('dash.reporting.nb_fans')}}</h3> -->
                <h3>{{$t('dash.label.fb.page_follows')}}</h3>
                <img class="icon fan-ico" src="../../../assets/img/reporting_icons/fans.svg" alt="">
                <Tooltip v-if="pageStats.page.page_fans >= 1000000" :text="numberSpacing(pageStats.page.page_fans)">
                  <p class="big-number">{{ numberSpacing(Number(pageStats.page.page_fans/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}))}}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="pageStats.page.page_fans >= 1000" :text="numberSpacing(pageStats.page.page_fans)">
                  <p class="big-number">{{numberSpacing(Number(pageStats.page.page_fans/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{numberSpacing(pageStats.page.page_fans)}}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_fans">
                  <Tooltip v-if="pageStats.page.page_fans < pageStats.page.previous_period.page_fans" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_fans)" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (pageStats.page.page_fans / pageStats.page.previous_period.page_fans) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="pageStats.page.page_fans != 0 && pageStats.page.page_fans == pageStats.page.previous_period.page_fans" :text="$t('dash.reporting.previous_period')+ ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : '  + numberSpacing(pageStats.page.previous_period.page_fans)" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="pageStats.page.page_fans > pageStats.page.previous_period.page_fans" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_fans)" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_fans > 0">+{{ formatPercentageChange((pageStats.page.page_fans / pageStats.page.previous_period.page_fans) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="lastPage.network == 'facebook'" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats && lastPage.network == 'facebook'" class="main-numbers">
                <i class="fa-solid fa-user-group"></i>
                <!-- <h3>{{$t('dash.label.fb.adds_fans')}}</h3> -->
                <h3>{{$t('dash.label.fb.page_daily_follows')}}</h3>
                <img class="icon fan-ico" src="../../../assets/img/reporting_icons/fans.svg" alt="">
                <Tooltip v-if="graphData.find(g => g.name == 'fans_adds').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'fans_adds').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number(graphData.find(g => g.name == 'fans_adds').data.reduce((prev, curr) => prev + curr)/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}))}}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'fans_adds').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'fans_adds').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{numberSpacing(Number(graphData.find(g => g.name == 'fans_adds').data.reduce((prev, curr) => prev + curr)/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{numberSpacing(graphData.find(g => g.name == 'fans_adds').data.reduce((prev, curr) => prev + curr))}}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_fan_adds_unique">
                  <Tooltip v-if="graphData.find(g => g.name == 'fans_adds').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.page_fan_adds_unique.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_fan_adds_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'fans_adds').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_fan_adds_unique.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'fans_adds').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'fans_adds').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.page_fan_adds_unique.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_fan_adds_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'fans_adds').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.page_fan_adds_unique.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_fan_adds_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_fan_adds_unique.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'fans_adds').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_fan_adds_unique.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100 )}}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="lastPage.network == 'facebook'" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <!-- <div v-if="pageStats && lastPage.network == 'facebook' && graphData.find(g => g.name == 'fans_paids_adds')" class="main-numbers">
                <i class="fa-solid fa-user-group"></i>
                <h3>{{$t('dash.label.fb.paids_adds_fans')}}</h3>
                <img class="icon fan-ico" src="../../../assets/img/reporting_icons/fans.svg" alt="">
                <Tooltip v-if="graphData.find(g => g.name == 'fans_paids_adds').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'fans_paids_adds').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number(graphData.find(g => g.name == 'fans_paids_adds').data.reduce((prev, curr) => prev + curr)/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}))}}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'fans_paids_adds').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'fans_paids_adds').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{numberSpacing(Number(graphData.find(g => g.name == 'fans_paids_adds').data.reduce((prev, curr) => prev + curr)/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{numberSpacing(graphData.find(g => g.name == 'fans_paids_adds').data.reduce((prev, curr) => prev + curr))}}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_fan_paids_adds_unique">
                  <Tooltip v-if="graphData.find(g => g.name == 'fans_paids_adds').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.page_fan_paids_adds_unique.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_fan_paids_adds_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'fans_paids_adds').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_fan_paids_adds_unique.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'fans_paids_adds').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'fans_paids_adds').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.page_fan_paids_adds_unique.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_fan_paids_adds_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'fans_paids_adds').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.page_fan_paids_adds_unique.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_fan_paids_adds_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_fan_paids_adds_unique.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'fans_paids_adds').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_fan_paids_adds_unique.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div> -->
              <!-- <img v-else src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt=""> -->

              <div v-if="pageStats && lastPage.network == 'facebook'" class="main-numbers">
                <i class="fa-solid fa-user-group"></i>
                <!-- <h3>{{$t('dash.label.fb.fans_removes')}}</h3> -->
                <h3>{{$t('dash.label.fb.page_daily_unfollows')}}</h3>
                <img class="icon fan-ico" src="../../../assets/img/reporting_icons/fans.svg" alt="">
                <Tooltip v-if="Math.abs(graphData.find(g => g.name == 'fans_removes').data.reduce((prev, curr) => prev + curr)) >= 1000000" :text="numberSpacing(Math.abs(graphData.find(g => g.name == 'fans_removes').data.reduce((prev, curr) => prev + curr)))">
                  <p class="big-number">{{ numberSpacing(Number(graphData.find(g => g.name == 'fans_removes').data.reduce((prev, curr) => prev + curr)/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}))}}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="Math.abs(graphData.find(g => g.name == 'fans_removes').data.reduce((prev, curr) => prev + curr)) >= 1000" :text="numberSpacing(Math.abs(graphData.find(g => g.name == 'fans_removes').data.reduce((prev, curr) => prev + curr)))">
                  <p class="big-number">{{numberSpacing(Number(Math.abs(graphData.find(g => g.name == 'fans_removes').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{numberSpacing(Math.abs(graphData.find(g => g.name == 'fans_removes').data.reduce((prev, curr) => prev + curr)))}}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_fan_removes_unique">
                  <Tooltip v-if="graphData.find(g => g.name == 'fans_removes').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.page_fan_removes_unique.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_fan_removes_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'fans_removes').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_fan_removes_unique.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'fans_removes').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'fans_removes').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.page_fan_removes_unique.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_fan_removes_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'fans_removes').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.page_fan_removes_unique.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_fan_removes_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_fan_removes_unique.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'fans_removes').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_fan_removes_unique.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="lastPage.network == 'facebook'" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <!-- <div v-if="pageStats" class="main-numbers">
                <i class="fa-solid fa-note-sticky"></i>
                <h3>{{$t('dash.label.fb.page_follows')}}</h3>
                <img class="icon fan-ico" src="../../../assets/img/reporting_icons/fans.svg" alt="">
                <Tooltip v-if="graphData.find(g => g.name == 'page_follows') && graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1] >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1])">
                  <p class="big-number">{{ numberSpacing(Number(graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1]/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}))}}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'page_follows') && graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1] >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1])">
                  <p class="big-number">{{numberSpacing(Number(graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1]/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else-if="graphData.find(g => g.name == 'page_follows')">{{numberSpacing(graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1])}}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_follows">
                  <Tooltip v-if="graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1] < pageStats.page.previous_period.page_follows[pageStats.page.previous_period.page_follows.length - 1].total" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_follows[pageStats.page.previous_period.page_follows.length - 1].total)" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1] / pageStats.page.previous_period.page_follows[pageStats.page.previous_period.page_follows.length - 1].total) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1] != 0 && graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1] == pageStats.page.previous_period.page_follows[pageStats.page.previous_period.page_follows.length - 1].total" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_follows[pageStats.page.previous_period.page_follows.length - 1].total)" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1] > pageStats.page.previous_period.page_follows[pageStats.page.previous_period.page_follows.length - 1].total" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_follows[pageStats.page.previous_period.page_follows.length - 1].total)" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_follows[pageStats.page.previous_period.page_follows.length - 1].total > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1] / pageStats.page.previous_period.page_follows[pageStats.page.previous_period.page_follows.length - 1].total) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats" class="main-numbers">
                <i class="fa-solid fa-user-group"></i>
                <h3>{{$t('dash.label.fb.page_daily_follows')}}</h3>
                <img class="icon fan-ico" src="../../../assets/img/reporting_icons/fans.svg" alt="">
                <Tooltip v-if="graphData.find(g => g.name == 'page_daily_follows').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'page_daily_follows').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number(graphData.find(g => g.name == 'page_daily_follows').data.reduce((prev, curr) => prev + curr)/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}))}}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'page_daily_follows').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'page_daily_follows').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{numberSpacing(Number(graphData.find(g => g.name == 'page_daily_follows').data.reduce((prev, curr) => prev + curr)/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{numberSpacing(graphData.find(g => g.name == 'page_daily_follows').data.reduce((prev, curr) => prev + curr))}}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_daily_follows_unique">
                  <Tooltip v-if="graphData.find(g => g.name == 'page_daily_follows').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.page_daily_follows_unique.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_daily_follows_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'page_daily_follows').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_daily_follows_unique.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'page_daily_follows').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'page_daily_follows').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.page_daily_follows_unique.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_daily_follows_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'page_daily_follows').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.page_daily_follows_unique.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_daily_follows_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_daily_follows_unique.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'page_daily_follows').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_daily_follows_unique.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats" class="main-numbers">
                <i class="fa-solid fa-user-group"></i>
                <h3>{{$t('dash.label.fb.page_daily_unfollows')}}</h3>
                <img class="icon fan-ico" src="../../../assets/img/reporting_icons/fans.svg" alt="">
                <Tooltip v-if="Math.abs(graphData.find(g => g.name == 'page_daily_unfollows').data.reduce((prev, curr) => prev + curr)) >= 1000000" :text="numberSpacing(Math.abs(graphData.find(g => g.name == 'page_daily_unfollows').data.reduce((prev, curr) => prev + curr)))">
                  <p class="big-number">{{ numberSpacing(Number(graphData.find(g => g.name == 'page_daily_unfollows').data.reduce((prev, curr) => prev + curr)/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}))}}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="Math.abs(graphData.find(g => g.name == 'page_daily_unfollows').data.reduce((prev, curr) => prev + curr)) >= 1000" :text="numberSpacing(Math.abs(graphData.find(g => g.name == 'page_daily_unfollows').data.reduce((prev, curr) => prev + curr)))">
                  <p class="big-number">{{numberSpacing(Number(Math.abs(graphData.find(g => g.name == 'page_daily_unfollows').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{numberSpacing(Math.abs(graphData.find(g => g.name == 'page_daily_unfollows').data.reduce((prev, curr) => prev + curr)))}}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_daily_unfollows_unique">
                  <Tooltip v-if="graphData.find(g => g.name == 'page_daily_unfollows').data.reduce((prev, curr) => prev + curr) < Math.abs(pageStats.page.previous_period.page_daily_unfollows_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(Math.abs(pageStats.page.previous_period.page_daily_unfollows_unique.map(v => v.total).reduce((prev, curr) => prev + curr)))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'page_daily_unfollows').data.reduce((prev, curr) => prev + curr) / Math.abs(pageStats.page.previous_period.page_daily_unfollows_unique.map(v => v.total).reduce((prev, curr) => prev + curr))) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'page_daily_unfollows').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'page_daily_unfollows').data.reduce((prev, curr) => prev + curr) == Math.abs(pageStats.page.previous_period.page_daily_unfollows_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(Math.abs(pageStats.page.previous_period.page_daily_unfollows_unique.map(v => v.total).reduce((prev, curr) => prev + curr)))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'page_daily_unfollows').data.reduce((prev, curr) => prev + curr) > Math.abs(pageStats.page.previous_period.page_daily_unfollows_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(Math.abs(pageStats.page.previous_period.page_daily_unfollows_unique.map(v => v.total).reduce((prev, curr) => prev + curr)))" class="trending_up">
                    <span class="positive" v-if="Math.abs(pageStats.page.previous_period.page_daily_unfollows_unique.map(v => v.total).reduce((prev, curr) => prev + curr)) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'page_daily_unfollows').data.reduce((prev, curr) => prev + curr) / Math.abs(pageStats.page.previous_period.page_daily_unfollows_unique.map(v => v.total).reduce((prev, curr) => prev + curr))) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt=""> -->
            </div>
            <!-- <componentGraph
              class="graph"
              :data="graphData.filter(g => ['fans_evol', 'fans_adds', 'fans_paids_adds', 'fans_removes', 'page_follows', 'page_daily_follows', 'page_daily_unfollows'].includes(g.name))"
              :state="graphShowedAudience"
              :labels="graphLabels"
              :lang="$i18n.locale"
              :section="'audiences'"
              :key="'audiences'"
            /> -->
            <componentGraph
              class="graph"
              :data="graphData.filter(g => (lastPage.network == 'facebook' ? ['page_follows', 'page_daily_follows', 'page_daily_unfollows'] : ['fans_evol', 'fans_adds', 'fans_removes', 'page_follows', 'page_daily_follows', 'page_daily_unfollows']).includes(g.name))"
              :state="graphShowedAudience"
              :labels="graphLabels"
              :lang="$i18n.locale"
              :section="'audiences'"
              :key="'audiences'"
            />
            <div class="graph-choice">
              <!-- <Tooltip v-for="(item, idx) in graphNetwork.filter(g => ['fans_evol', 'fans_adds', 'fans_paids_adds', 'fans_removes', 'page_follows', 'page_daily_follows', 'page_daily_unfollows'].includes(g.name))" :key="`graph-select-audience-${idx}`" :text="item.description" position="bottom"> -->
              <Tooltip v-for="(item, idx) in graphNetwork.filter(g => (lastPage.network == 'facebook' ? ['page_follows', 'page_daily_follows', 'page_daily_unfollows'] : ['fans_evol', 'fans_adds', 'fans_removes', 'page_follows', 'page_daily_follows', 'page_daily_unfollows']).includes(g.name))" :key="`graph-select-audience-${idx}`" :text="item.description" position="bottom">
                <vs-checkbox class='check' 
                  :color="item.color"
                  :vs-value="`${idx}`"
                  v-model="graphShowedAudience">
                  {{item.text}} 
                </vs-checkbox>
                
              </Tooltip>
            </div>
          </div>
        </div>

        <!-- <div class="section-graph engagements">
          <div class="section-title">{{$t('dash.reporting.section.engagements.title')}}</div>
          <div class="section-subtitle">{{$t('dash.reporting.section.engagements.subtitle')}}</div>
          <div class="informations">
            <div v-if="pageStats && lastPage.network !== 'instagram' && !(lastPage.isGroup)" class="main-numbers">
              <h3>{{$t('dash.reporting.clic')}}</h3>
              <img class="icon eng-ico" src="../../../assets/img/reporting_icons/clic.svg" alt="">
              <p v-if="pageStats.page.totalClicks === null">N/A</p>
              <Tooltip v-else-if="pageStats.page.totalClicks >= 1000000 && lastPage.network == 'pinterest'" :text="numbersubstring(pageStats.page.totalClicksRate)">
                <p class="big-number">{{ numberSpacing(Number(pageStats.page.totalClicks/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">M</span></p>
                
              </Tooltip>
              <Tooltip v-else-if="pageStats.page.totalClicks >= 10000 && lastPage.network == 'pinterest'" :text="numberSpacing(pageStats.page.totalClicks) + '(' + numbersubstring(pageStats.page.totalClicksRate) +'%)'">
                <p class="big-number">{{numberSpacing(Number(pageStats.page.totalClicks/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">k</span></p>
                
              </Tooltip>
              <Tooltip v-else-if="pageStats.page.totalClicks >= 1000000" :text="numberSpacing(pageStats.page.totalClicks)">
                <p class="big-number">{{ numberSpacing(Number(pageStats.page.totalClicks/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">M</span></p>
                
              </Tooltip>
              <Tooltip v-else-if="pageStats.page.totalClicks >= 10000" :text="numberSpacing(pageStats.page.totalClicks)">
                <p class="big-number">{{numberSpacing(Number(pageStats.page.totalClicks/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">k</span></p>
                
              </Tooltip>
              <Tooltip v-else-if="lastPage.network == 'pinterest'" :text="numbersubstring(pageStats.page.totalClicksRate) + '%'">
                <p class="big-number">{{ numberSpacing(pageStats.page.totalClicks) }}</p>
                
              </Tooltip>
              <p v-else>{{ numberSpacing(pageStats.page.totalClicks) }}</p>
            </div>
            <img v-else-if="lastPage.network !== 'instagram' && !(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">
            
            <div v-if="pageStats && lastPage.network != 'pinterest'" class="main-numbers">
              <h3>{{$t('dash.reporting.interactions')}}</h3>
              <img class="icon eng-ico" src="../../../assets/img/reporting_icons/clic.svg" alt="">
              <Tooltip v-if="lastPage.network == 'facebook'" :text="$t('dash.reporting.tooltip_interactionsFB')">
                <p v-if="pageStats.page.totalInteractions === null">N/A</p>
                <p v-else-if="pageStats.page.totalInteractions >= 10000" class="big-number">{{numberSpacing(Number(pageStats.page.totalInteractions/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">k</span></p>
                <p class="big-number" v-else>{{ numberSpacing(pageStats.page.totalInteractions) }}</p>
                
              </Tooltip>
              <Tooltip v-else-if="lastPage.network == 'twitter'" :text="$t('dash.reporting.tooltip_interactionsTW')">
                <p v-if="pageStats.page.totalInteractions === null">N/A</p>
                <p v-else-if="pageStats.page.totalInteractions >= 10000" class="big-number">{{numberSpacing(Number(pageStats.page.totalInteractions/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">k</span></p>
                <p class="big-number"  v-else>{{ numberSpacing(pageStats.page.totalInteractions) }}</p>
                
              </Tooltip>
              <Tooltip v-else-if="lastPage.network == 'instagram'" :text="$t('dash.reporting.tooltip_interactionsIG')">
                <p v-if="pageStats.page.totalInteractions === null">N/A</p>
                <p v-else-if="pageStats.page.totalInteractions >= 10000" class="big-number">{{numberSpacing(Number(pageStats.page.totalInteractions/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">k</span></p>
                <p class="big-number" v-else>{{ numberSpacing(pageStats.page.totalInteractions) }}</p>
                
              </Tooltip>
              <Tooltip v-else-if="lastPage.network == 'linkedin'" :text="$t('dash.reporting.tooltip_interactionsLI')">
                <p v-if="pageStats.page.totalInteractions === null">N/A</p>
                <p v-else-if="pageStats.page.totalInteractions >= 10000" class="big-number">{{numberSpacing(Number(pageStats.page.totalInteractions/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1}) )}}<span class="percent">k</span></p>
                <p class="big-number" v-else>{{ numberSpacing(pageStats.page.totalInteractions) }}</p>
                
              </Tooltip>
            </div>
            <img v-else-if="lastPage.network !== 'instagram' && !(lastPage.isGroup) && lastPage.network != 'pinterest'" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

            <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
              <h3>{{$t('dash.reporting.engagemment')}}</h3>
              <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
              <p v-if="pageStats.page.totalReachEngag === null">N/A</p>
              <Tooltip v-else-if="lastPage.network == 'pinterest'" :text="numberSpacing(pageStats.page.totalEngagements)">
                <p class="big-number">{{ (pageStats.page.totalReachEngag*100).toLocaleString($i18n.locale, {maximumFractionDigits: 1})   }} %</p>
                
              </Tooltip>
              <p v-else-if="lastPage.network == 'linkedin'">{{ (pageStats.page.totalReachEngag*100).toLocaleString($i18n.locale, {maximumFractionDigits: 1})   }} % </p>
              <p v-else>{{ (pageStats.page.totalReachEngag).toLocaleString($i18n.locale, {maximumFractionDigits: 2})   }} % </p>
            </div>
            <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">
          </div>
          <componentGraph
            class="graph"
            :data="graphData.filter(g => ['reponses', 'clics_out', 'engagements', 'likes', 'reactions', 'commentaires', 'shares', 'clics'].includes(g.name))"
            :labels="graphLabels"
            :lang="$i18n.locale"
            :section="'engagements'"
          />
        </div> -->

        <div class="section-graph impressions" v-if="lastPage.network == 'facebook' && graphData.filter(g => ['fans_evol', 'fans_adds', 'fans_paids_adds', 'fans_removes', 'page_follows', 'page_daily_follows', 'page_daily_unfollows'].includes(g.name)).length > 1">
          <div class="section-title">{{$t('dash.reporting.section.impressions.title')}}</div>
          <div class="section-subtitle">{{$t('dash.reporting.section.impressions.subtitle')}}</div>
          <div v-if="graphData.filter(g => ['impressions','impressions_paid','impressions_viral'].includes(g.name)).length >=2">
            <div class="informations">
              
              <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-eye"></i>
                <h3>{{$t('dash.label.fb.page_views')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'page_views') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'page_views').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'page_views').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'page_views').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'page_views').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'page_views').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'page_views').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'page_views').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_views_total">
                  <Tooltip v-if="graphData.find(g => g.name == 'page_views').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.page_views_total.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_views_total.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'page_views').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_views_total.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'page_views').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'page_views').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.page_views_total.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_views_total.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'page_views').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.page_views_total.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_views_total.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_views_total.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'page_views').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_views_total.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-eye"></i>
                <h3>{{$t('dash.label.fb.impressions_reach')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'impressions_reach') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'impressions_reach').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'impressions_reach').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'impressions_reach').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'impressions_reach').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'impressions_reach').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'impressions_reach').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'impressions_reach').data.reduce((prev, curr) => prev + curr)) }}</p>
                <!-- <div class="compare" v-if="pageStats.page.previous_period && pageStats.page.previous_period.page_impressions_unique">
                  <Tooltip v-if="graphData.find(g => g.name == 'impressions_reach').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.page_impressions_unique.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + numberSpacing(pageStats.page.previous_period.page_impressions_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'impressions_reach').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_impressions_unique.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'impressions_reach').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.page_impressions_unique.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + numberSpacing(pageStats.page.previous_period.page_impressions_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'impressions_reach').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.page_impressions_unique.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + numberSpacing(pageStats.page.previous_period.page_impressions_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span>+{{ Math.round((graphData.find(g => g.name == 'impressions_reach').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_impressions_unique.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) - 100 }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                  </Tooltip>
                </div> -->
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_impressions">
                  <Tooltip v-if="graphData.find(g => g.name == 'impressions_reach').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.page_impressions.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_impressions.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'impressions_reach').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_impressions.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'impressions_reach').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'impressions_reach').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.page_impressions.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_impressions.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'impressions_reach').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.page_impressions.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_impressions.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_impressions.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'impressions_reach').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_impressions.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">


              <!-- <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <h3>{{$t('dash.reporting.impression')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="pageStats.page.totalImpressions === null">N/A</p>
                <Tooltip v-else-if="pageStats.page.totalImpressions   >= 1000000" :text="numberSpacing(pageStats.page.totalImpressions)">
                  <p class="big-number">{{ numberSpacing(Number((pageStats.page.totalImpressions  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="pageStats.page.totalImpressions   >= 1000" :text="numberSpacing(pageStats.page.totalImpressions)">
                  <p class="big-number">{{ numberSpacing(Number((pageStats.page.totalImpressions)/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(pageStats.page.totalImpressions  ) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.totalImpressions">
                  <Tooltip v-if="pageStats.page.totalImpressions < pageStats.page.previous_period.totalImpressions" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.totalImpressions)" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (pageStats.page.totalImpressions / pageStats.page.previous_period.totalImpressions) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="pageStats.page.totalImpressions == pageStats.page.previous_period.totalImpressions" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.totalImpressions)" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="pageStats.page.totalImpressions > pageStats.page.previous_period.totalImpressions" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.totalImpressions)" class="trending_up">
                    <span v-if="pageStats.page.previous_period.totalImpressions > 0">+{{ Math.round((pageStats.page.totalImpressions / pageStats.page.previous_period.totalImpressions) * 100) - 100 }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt=""> -->

              <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-eye"></i>
                <h3>{{$t('dash.label.fb.impressions_organic')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'impressions_organic') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'impressions_organic').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'impressions_organic').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'impressions_organic').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'impressions_organic').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'impressions_organic').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'impressions_organic').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'impressions_organic').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_impressions_organic_v2">
                  <Tooltip v-if="graphData.find(g => g.name == 'impressions_organic').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.page_impressions_organic_v2.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_impressions_organic_v2.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'impressions_organic').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_impressions_organic_v2.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'impressions_organic').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'impressions_organic').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.page_impressions_organic_v2.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_impressions_organic_v2.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'impressions_organic').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.page_impressions_organic_v2.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_impressions_organic_v2.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_impressions_organic_v2.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'impressions_organic').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_impressions_organic_v2.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">


              <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-eye"></i>
                <h3>{{$t('dash.label.fb.impressions_paid')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'impressions_paid') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'impressions_paid').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'impressions_paid').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'impressions_paid').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'impressions_paid').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'impressions_paid').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'impressions_paid').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'impressions_paid').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_impressions_paid">
                  <Tooltip v-if="graphData.find(g => g.name == 'impressions_paid').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.page_impressions_paid.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_impressions_paid.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'impressions_paid').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_impressions_paid.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'impressions_paid').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'impressions_paid').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.page_impressions_paid.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_impressions_paid.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'impressions_paid').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.page_impressions_paid.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_impressions_paid.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_impressions_paid.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'impressions_paid').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_impressions_paid.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

            </div>       
            <componentGraph
              class="graph"
              :data="graphData.filter(g => ['page_views', 'impressions_reach', 'impressions','impressions_paid','impressions_organic','impressions_viral'].includes(g.name))"
              :state="graphShowedImpressions"
              :labels="graphLabels"
              :lang="$i18n.locale"
              :section="'impressions'"
              :key="'impressions'"
            />
            <div class="graph-choice">
              <Tooltip v-for="(item, idx) in graphNetwork.filter(g => ['page_views', 'impressions_reach', 'impressions','impressions_paid','impressions_organic','impressions_viral'].includes(g.name))" :key="`graph-select-impressions-${idx}`" :text="item.description" position="bottom">
                <vs-checkbox class='check' 
                  :color="item.color"
                  :vs-value="`${idx}`"
                  v-model="graphShowedImpressions">
                  {{item.text}} 
                </vs-checkbox>
                
              </Tooltip>
            </div>
          </div>
        </div>

        <!-- <div class="section-graph demographie" v-if="lastPage.network == 'instagram' && pageStats && pageStats.page && !pageStats.page.demographicKO">
          <div class="section-title">{{$t('dash.reporting.section.demographie.title')}}</div>
          <div class="section-subtitle">{{$t('dash.reporting.section.demographie.subtitle')}}</div>
          <div v-if="graphData.filter(g => g.data && ['audience_country', 'audience_locale', 'audience_city', 'audience_male_age', 'audience_female_age', 'audience_undifined_age'].includes(g.name)).length == 6">
            <MapChart
              :countryData="graphData.filter(g => ['audience_country'].includes(g.name))[0].data"
              highColor="rgba(106, 31, 76, 1)"
              lowColor="rgba(106, 31, 76, 0.1)"
              countryStrokeColor="#ffffff"
              defaultCountryFillColor="#dadada"
              :LangUser="$i18n.locale"
              :currencyAdd="false"
            />
            
            <ul class="bar">
              <li>
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['audience_locale'].includes(g.name)).slice(0,10)"
                  :state="['0','1','2','3','4','5','6','7','8','9']"
                  :labels="graphData.find(g => ['audience_locale'].includes(g.name)).labels.slice(0,10)"
                  :lang="$i18n.locale"
                  :section="'demographie_locale'"
                  :key="'demographie_locale'"
                  :size="sizeHorizontalGraph"
                />
              </li>
              <li>
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['audience_city'].includes(g.name)).slice(0,10)"
                  :state="['0','1','2','3','4','5','6','7','8','9']"
                  :labels="graphData.find(g => ['audience_city'].includes(g.name)).labels.slice(0,10)"
                  :lang="$i18n.locale"
                  :section="'demographie_city'"
                  :key="'demographie_city'"
                  :size="sizeHorizontalGraph"
                />
              </li>
            </ul>
            
            <ul class="bar">
              <li class="big">
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['audience_male_age', 'audience_female_age', 'audience_undifined_age'].includes(g.name))"
                  :state="['0','1','2']"
                  :labels="graphData.find(g => ['audience_male_age'].includes(g.name)).labels"
                  :lang="$i18n.locale"
                  :section="'demographie_gender_age'"
                  :key="'demographie_gender_age'"
                />
              </li>
              <li class="small">
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['audience_gender_age'].includes(g.name))"
                  :state="['0','1','2']"
                  :labels="[$t('audience_male_age'), $t('audience_female_age'), $t('audience_undifined_age')]"
                  :lang="$i18n.locale"
                  :section="'demographie_gender'"
                  :key="'demographie_gender'"
                />
              </li>
            </ul>

            <div class="profil-type" v-if="pageStats && pageStats.page && pageStats.page.profil_type_age && pageStats.page.profil_type_country">
              <div class="section-subtitle">{{$t('dash.reporting.section.demographie.subtitle.profil_type')}}</div>
              <div class="content">
                {{ pageStats.page.profil_type_age.slice(2) }} 
                <span v-if="pageStats.page.profil_type_age.includes('M.')">{{ $t('dash.reporting.section.demographie.type_man') }}</span>
                <span v-else-if="pageStats.page.profil_type_age.includes('F.')">{{ $t('dash.reporting.section.demographie.type_female') }}</span>
                <span v-else-if="pageStats.page.profil_type_age.includes('U.')">{{ $t('dash.reporting.section.demographie.type_undefined') }}</span>
                <img :src="`https://flagcdn.com/h40/${pageStats.page.profil_type_country.toLowerCase()}.png`">
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="section-graph demographie" v-if="lastPage.network == 'facebook' && graphData.filter(g => ['fans_evol', 'fans_adds', 'fans_paids_adds', 'fans_removes', 'page_follows', 'page_daily_follows', 'page_daily_unfollows'].includes(g.name)).length > 1 && graphData.filter(g => ['impressions','impressions_paid','impressions_viral'].includes(g.name)).length == 3 && pageStats && pageStats.page && !pageStats.page.demographicKO"> -->
        <!-- <div class="section-graph demographie" v-if="['facebook', 'instagram'].includes(lastPage.network) && pageStats && pageStats.page && !pageStats.page.demographicKO"> -->
        <div class="section-graph demographie" v-if="pageStats && pageStats.page && ((lastPage.network == 'instagram' && !pageStats.page.demographicKO) || lastPage.network == 'facebook' || lastPage.network == 'tiktok')">
          <div class="section-title">{{$t(`dash.reporting.section.demographie.title.${lastPage.network}`)}}</div>
          <div class="section-subtitle">{{$t(`dash.reporting.section.demographie.subtitle.${lastPage.network}`)}}</div>
          <!--<div v-if="graphData.filter(g => g.data && ['fans_country', 'fans_locale', 'fans_city', 'fans_male_age', 'fans_female_age', 'fans_undifined_age'].includes(g.name)).length == 6">-->
          <div v-if="graphData.filter(g => g.data && ['fans_country', 'fans_city', 'fans_male_age', 'fans_female_age', 'fans_undifined_age'].includes(g.name)).length >= 2">
            <template v-if="graphData.find(g => g.name === 'fans_country' && g.data)">
              <MapChart
                :countryData="graphData.filter(g => ['fans_country'].includes(g.name))[0].data"
                highColor="rgba(106, 31, 76, 1)"
                lowColor="rgba(106, 31, 76, 0.1)"
                countryStrokeColor="#ffffff"
                defaultCountryFillColor="#dadada"
                :LangUser="$i18n.locale"
                :currencyAdd="false"
              />
            </template>
            
            <ul class="bar">
              <li v-if="graphData.find(g => ['fans_locale'].includes(g.name))">
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['fans_locale'].includes(g.name)).slice(0,10)"
                  :state="['0','1','2','3','4','5','6','7','8','9']"
                  :labels="graphData.find(g => ['fans_locale'].includes(g.name)).labels.slice(0,10)"
                  :lang="$i18n.locale"
                  :section="'demographie_locale'"
                  :key="'demographie_locale'"
                  :size="sizeHorizontalGraph"
                />
              </li>
              <li v-if="graphData.find(g => ['fans_city'].includes(g.name))">
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['fans_city'].includes(g.name)).slice(0,10)"
                  :state="['0','1','2','3','4','5','6','7','8','9']"
                  :labels="graphData.find(g => ['fans_city'].includes(g.name)).labels.slice(0,10)"
                  :lang="$i18n.locale"
                  :section="'demographie_city'"
                  :key="'demographie_city'"
                  :size="sizeHorizontalGraph"
                />
              </li>
            </ul>
            
            <ul class="bar" v-if="!graphData.find(g => ['fans_locale'].includes(g.name)) && graphData.find(g => ['fans_age'].includes(g.name))">
              <li class="big">
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['fans_age'].includes(g.name))"
                  :state="['0']"
                  :labels="graphData.find(g => ['fans_age'].includes(g.name)).labels"
                  :lang="$i18n.locale"
                  :section="'demographie_age'"
                  :key="'demographie_age'"
                />
              </li>
              <li class="small" v-if="graphData.find(g => ['fans_gender'].includes(g.name))">
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['fans_gender'].includes(g.name))"
                  :state="['0']"
                  :labels="[$t('page_follows_by_gender_male'), $t('page_follows_by_gender_female'), $t('page_follows_by_gender_undefined')]"
                  :lang="$i18n.locale"
                  :section="'demographie_gender'"
                  :key="'demographie_gender'"
                />
              </li>
            </ul>
            <ul class="bar" v-else-if="(lastPage.network == 'instagram' || lastPage.network == 'tiktok') && graphData.find(g => g.name == 'fans_male_age' && g.labels)">
              <li class="big">
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['fans_male_age', 'fans_female_age', 'fans_undifined_age'].includes(g.name))"
                  :state="['0','1','2']"
                  :labels="graphData.find(g => ['fans_male_age'].includes(g.name)).labels"
                  :lang="$i18n.locale"
                  :section="'demographie_gender_age'"
                  :key="'demographie_gender_age'"
                />
              </li>
              <li class="small" v-if="graphData.find(g => g.name == 'fans_by_gender')">
                <componentGraph
                  class="graph"
                  :data="graphData.filter(g => ['fans_by_gender'].includes(g.name))"
                  :state="['0','1','2']"
                  :labels="[$t('page_follows_by_gender_male'), $t('page_follows_by_gender_female'), $t('page_follows_by_gender_undefined')]"
                  :lang="$i18n.locale"
                  :section="'demographie_gender'"
                  :key="'demographie_gender'"
                />
              </li>
            </ul>

            <!-- <div class="profil-type" v-if="lastPage.network === 'facebook' && pageStats && pageStats.page && pageStats.page.profil_type_age && pageStats.page.profil_type_country">
              <div class="section-subtitle">{{$t('dash.reporting.section.demographie.subtitle.profil_type')}}</div>
              <div class="content">
                {{ pageStats.page.profil_type_age.slice(2) }} 
                <span v-if="pageStats.page.profil_type_age.includes('M.')">{{ $t('dash.reporting.section.demographie.type_man') }}</span>
                <span v-else-if="pageStats.page.profil_type_age.includes('F.')">{{ $t('dash.reporting.section.demographie.type_female') }}</span>
                <span v-else-if="pageStats.page.profil_type_age.includes('U.')">{{ $t('dash.reporting.section.demographie.type_undefined') }}</span>
                <img :src="`https://flagcdn.com/h40/${pageStats.page.profil_type_country.toLowerCase()}.png`">
              </div>
            </div> -->
          </div>
        </div>
      </template>


      <div class="posts table-wrapper" :class="{'on-load': pageStats && pageStats.postsPercentLoader < 100}" v-if="lastPage && (lastPage.network !== 'facebook' || lastPage.isGroup || (lastPage.network === 'facebook' && graphData.filter(g => ['fans_evol', 'fans_adds', 'fans_removes', 'page_follows', 'page_daily_follows', 'page_daily_unfollows'].includes(g.name)).length > 1 && graphData.filter(g => ['impressions','impressions_paid','impressions_viral'].includes(g.name)).length == 3 && graphData.filter(g => g.data && ['fans_country', 'fans_locale', 'fans_city'].includes(g.name)).length == 3 || (pageStats && pageStats.page && pageStats.page.demographicKO)))">

          <span v-if="lastPage.network === 'facebook' && !lastPage.isGroup && pageStats && (pageStats.postsPercentLoader >= 0 || !pageStats.postsPercentLoader)" class="loader-posts">
            <component-loader :progress="pageStats.postsPercentLoader" v-if="pageStats.postsPercentLoader < 100"></component-loader>
          </span>

          <vs-table :hoverFlat='true'
            class="content-table"
            search
            :data="postList"
            max-items="20" pagination
            :noDataText="$t('dash.noDataText')"
          >
            <template slot="header">
              <div>
                <h3>{{$t('dash.reporting.section.posts.title')}}</h3>
                
                <!-- popup to choose format file befor exporting  -->
                <div class = 'exportRep'>
                  <vs-button 
                    @click="popupActivo3=true"
                    v-if="pageStats"
                    class="btn-img"
                    color="#2F1937"
                    size="small"
                    vs-type="filled">
                          <p>{{$t('dash.button.exportPosts')}}</p>
                          <img src="../../../assets/img/icon_export.svg" alt="unlock">
                  </vs-button>

                  <vs-popup title="Export" :active.sync="popupActivo3">
                    <p>
                      {{$t('dash.export.selectformat')}}
                    </p>
                    <template v-if="checkLock('conciergerie')">
                      <vs-button v-if="['facebook', 'instagram', 'linkedin', 'tiktok'].includes(lastPage.network)" @click="getPDF();" :disabled="!pageStats || updateCountDayLoader != null || !(pageStats && pageStats.page && pageStats.page.previous_period)" class="btnFormat">
                        pdf
                      </vs-button>
                      <vs-button v-if="['facebook', 'instagram', 'linkedin', 'tiktok'].includes(lastPage.network)" @click="getExportApiUrl();" :disabled="!pageStats || updateCountDayLoader != null" class="btnFormat" style="margin-top: 10px; margin-right: 10px; margin-left: 10px;">
                        api
                      </vs-button>
                    </template>
                    <template v-else>
                      <Tooltip :text="$t('dash.plan.active_conciergerie_to_get_features.content_export_reporting')">
                        <vs-button v-if="['facebook', 'instagram', 'linkedin', 'tiktok'].includes(lastPage.network)" @click="goToSettings();" :disabled="!pageStats || updateCountDayLoader != null" class="btnFormat">
                          pdf
                        </vs-button>
                      </Tooltip>
                      <Tooltip :text="$t('dash.plan.active_conciergerie_to_get_features.content_export_reporting')">
                        <vs-button v-if="['facebook', 'instagram', 'linkedin', 'tiktok'].includes(lastPage.network)" @click="goToSettings();" :disabled="!pageStats || updateCountDayLoader != null" class="btnFormat" style="margin-top: 10px; margin-right: 10px; margin-left: 10px;">
                          api
                        </vs-button>
                      </Tooltip>
                    </template>
                    <vs-button v-for="format in formats" :key="`export-${format.value}`" 
                      v-show="pageStats && pageStats.page.nb_posts > 0"
                      @click="exportData(format.value, 'posts')"              
                      class="btnFormat"
                      style="margin-top: 10px; margin-right: 10px; margin-left: 10px;"
                    >{{format.value}}
                    </vs-button>
                  </vs-popup>   
                </div>
              </div>
            </template>
        
            <template slot="thead">
              <vs-th class="t-id"><Tooltip  :text="$t('dash.reporting.header_id')"><span>  </span>  </Tooltip> </vs-th> 
              <vs-th class="t-date" sortKey="created_time"> 
                {{capitalize($t('dash.table.title.date'))}}
                <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
              <vs-th class="t-msg" sortKey="message"> 
                {{capitalize($t('dash.table.title.content'))}} 
                <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
              <vs-th class="t-type">
                Type
              </vs-th>
              <vs-th class="t-imp" sortKey="post_impressions">
                <Tooltip  :text="$t('dash.reporting.header_impression')"><span>
                {{$t('dash.reporting.impression')}}
                </span>  </Tooltip>
                <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
              <vs-th v-if="lastPage.network !== 'instagram' && lastPage.network !== 'tiktok'" class="t-clc" sortKey="link_clicks"> 
                <Tooltip  :text="$t(`dash.reporting.header_click${lastPage.network === 'facebook' ? '.fb' : ''}`)"><span>
                {{$t(`dash.reporting.clic`)}} 
                </span>
                <span v-if="lastPage.network === 'facebook'">
                  <br/>
                  {{$t(`dash.reporting.clic.fb`)}} 
                </span>  </Tooltip>
                <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
              <vs-th v-if="lastPage.network !== 'twitter' && lastPage.network !== 'pinterest'" class="t-com" sortKey="comments_count"> 
                Commentaires
                <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
              <vs-th class="t-ptg" v-if="['facebook', 'linkedin', 'tiktok'].includes(lastPage.network)" sortKey="shares_count">
                <Tooltip  :text="$t('dash.reporting.header_share')"><span> 
                {{$t('dash.label.fb.shares')}}
                </span>  </Tooltip>
                <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
              <vs-th class="t-rea" v-if="lastPage.network === 'facebook' || lastPage.network === 'linkedin'" sortKey="post_reactions_sum"> 
                {{$t('dash.reporting.reaction')}} 
                 <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
              <vs-th class="t-tw-rt" v-if="lastPage.network === 'twitter'" sortKey="retweet_count">
                <Tooltip  :text="$t('dash.reporting.header_retweet')"><span> 
                Retweet
                </span>  </Tooltip>
                <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
              <vs-th class="t-tw-like" v-if="lastPage.network === 'twitter' || lastPage.network === 'instagram' || lastPage.network === 'tiktok'" sortKey="like_count">
                <Tooltip  :text="$t('dash.reporting.header_like')"><span>
                Like
                </span>  </Tooltip>
                <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
              <!-- TikTok Conciergerie metrics -->
              <vs-th class="t-time_watched" v-if="lastPage.network === 'tiktok'" sortKey="time_watched">
                <Tooltip :text="$t('dash.reporting.header_video_time_watched')"><span>
                {{$t('dash.reporting.video_time_watched')}}
                </span></Tooltip>
                <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
              <vs-th class="t-video_per_duration" v-if="lastPage.network === 'tiktok'" sortKey="video_per_duration">
                <Tooltip :text="$t('dash.reporting.header_video_time_watched_avg')"><span>
                {{$t('dash.reporting.video_time_watched_avg')}}
                </span></Tooltip>
                <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
              <vs-th class="t-viewer" v-if="lastPage.network === 'tiktok'" sortKey="viewer">
                <Tooltip :text="$t('dash.reporting.header_video_viewer')"><span>
                {{$t('dash.reporting.video_viewer')}}
                </span></Tooltip>
                <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
              <vs-th class="t-video_finish_rate" v-if="lastPage.network === 'tiktok'" sortKey="video_finish_rate">
                <Tooltip :text="$t('dash.reporting.header_video_finish_rate')"><span>
                {{$t('dash.reporting.video_finish_rate')}}
                </span></Tooltip>
                <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
              <vs-th class="t-video_new_follower" v-if="lastPage.network === 'tiktok'" sortKey="video_new_follower">
                <Tooltip :text="$t('dash.reporting.header_video_new_follower')"><span>
                {{$t('dash.reporting.video_new_follower')}}
                </span></Tooltip>
                <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
              <vs-th class="t-tw-reply" v-if="lastPage.network === 'twitter'" sortKey="reply_count">
                <Tooltip  :text="$t('dash.reporting.header_reply')"><span>
                Reply
                </span>  </Tooltip>
                <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
              <vs-th class="t-tw-quote" v-if="lastPage.network === 'twitter'" sortKey="quote_count">
                <Tooltip  :text="$t('dash.reporting.header_quote')"><span>
                Quote
                </span>  </Tooltip>
                <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
              <vs-th class="t-eng" v-if="lastPage.network != 'pinterest'" sortKey="reach_engagement">
                <Tooltip  :text="$t('dash.reporting.header_engamement')"><span> 
                {{$t('dash.reporting.engagemment')}} 
                </span>  </Tooltip>
                <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
              <vs-th class="t-eng" v-if="lastPage.network == 'pinterest'" sortKey="reach_save">
                <Tooltip  :text="$t('dash.reporting.header_save')"><span> 
                {{$t('dash.reporting.save')}} 
                </span>  </Tooltip>
                <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
              <vs-th class="t-eng" v-if="lastPage.network == 'pinterest'" sortKey="reach_outboundclicks">
                <Tooltip  :text="$t('dash.reporting.header_outboundclicks')"><span> 
                {{$t('dash.reporting.outboundclick')}} 
                </span>  </Tooltip>
                <span class="sort-th">
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                    expand_less
                  </i>
                  <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                    expand_more
                  </i>
                </span>
              </vs-th>
            </template>

            <template slot-scope="{ data }" v-if="!data">
              <vs-tr v-for="i in 25" :key="`header-posts-${i}`">
                <vs-td class="t-id">
                  <a @click.prevent="" >#</a>
                </vs-td>

                <vs-td class="t-date">
                  <img src="../../../assets/img/content_loader/reporting_posts_date.svg" alt="">
                </vs-td>

                <vs-td class="t-msg">
                  <img src="../../../assets/img/content_loader/reporting_posts_content.svg" alt="">
                </vs-td>

                <vs-td class="t-imp">
                  <img src="../../../assets/img/content_loader/reporting_posts_numbers.svg" alt="">
                </vs-td>


                <vs-td class="t-clc">
                  <img src="../../../assets/img/content_loader/reporting_posts_numbers.svg" alt="">
                </vs-td>

                <vs-td v-if="lastPage.network === 'facebook'" class="t-ptg">
                  <img src="../../../assets/img/content_loader/reporting_posts_numbers.svg" alt="">
                </vs-td>

                <vs-td class="t-rea" v-if="lastPage.network === 'facebook'">
                  <div class="reaction">
                    <span class="icon">
                      <img src="../../../assets/img/reporting_icons/angry.svg" alt="Angry">
                    </span> 
                  <img src="../../../assets/img/content_loader/reporting_posts_reaction.svg" alt="">
                  </div>
                  <div class="reaction">
                    <span class="icon">
                      <img src="../../../assets/img/reporting_icons/haha.svg" alt="Haha">
                    </span> 
                  <img src="../../../assets/img/content_loader/reporting_posts_reaction.svg" alt="">
                  </div>
                  <div class="reaction">
                    <span class="icon">
                      <img src="../../../assets/img/reporting_icons/like.svg" alt="Like">
                    </span> 
                  <img src="../../../assets/img/content_loader/reporting_posts_reaction.svg" alt="">
                  </div>
                  <div class="reaction">
                    <span class="icon">
                      <img src="../../../assets/img/reporting_icons/love.svg" alt="Love">
                    </span> 
                  <img src="../../../assets/img/content_loader/reporting_posts_reaction.svg" alt="">
                  </div>
                  <div class="reaction">
                    <span class="icon">
                      <img src="../../../assets/img/reporting_icons/sad.svg" alt="Sad">
                    </span> 
                  <img src="../../../assets/img/content_loader/reporting_posts_reaction.svg" alt="">
                  </div>
                  <div class="reaction">
                    <span class="icon">
                      <img src="../../../assets/img/reporting_icons/wow.svg" alt="Wow">
                    </span> 
                  <img src="../../../assets/img/content_loader/reporting_posts_reaction.svg" alt="">
                  </div>
                  <div class="sum">{{$t('dash.reporting.total_reactions')}}
                    <img src="../../../assets/img/content_loader/reporting_posts_reaction.svg" alt="">
                  </div>
                </vs-td>

                <vs-td v-if="lastPage.network === 'twitter'" class="t-tw-rt" >
                  <img src="../../../assets/img/content_loader/reporting_posts_numbers.svg" alt="">
                </vs-td>

                <vs-td v-if="lastPage.network === 'twitter'  || lastPage.network === 'instagram'" class="t-tw-like" >
                  <img src="../../../assets/img/content_loader/reporting_posts_numbers.svg" alt="">
                </vs-td>

                <vs-td v-if="lastPage.network === 'twitter'" class="t-tw-reply">
                  <img src="../../../assets/img/content_loader/reporting_posts_numbers.svg" alt="">
                </vs-td>

                <vs-td v-if="lastPage.network === 'twitter'" class="t-tw-quote">
                  <img src="../../../assets/img/content_loader/reporting_posts_numbers.svg" alt="">
                </vs-td>

                <vs-td class="t-eng">
                  <img src="../../../assets/img/content_loader/reporting_posts_numbers.svg" alt="">
                </vs-td>
              </vs-tr>
            </template>

            <template slot-scope="{ data }" v-if="data">
              <vs-tr :key="`data-posts-${indextr}`" v-for="(tr, indextr) in data">
                <vs-td class="t-id" :data="data[indextr].id">
                  <a @click.prevent="openLink(data[indextr].permalink_url || data[indextr].permalink)">#{{ data[indextr].id }}</a>
                </vs-td>

                <vs-td class="t-date" :data="data[indextr].created_time || data[indextr].timestamp">
                  {{ formatDate(data[indextr].created_time || data[indextr].timestamp) }}
                </vs-td>

                <vs-td class="t-msg" :data="data[indextr].message">
                  <div class="cell-msg">
                    <p class="only-text" v-if="(!data[indextr].attachment_url || data[indextr].attachment_url === '') && !(lastPage.network == 'linkedin' && ['NATIVE_DOCUMENT', 'VIDEO', 'MULTI-IMAGE'].includes(data[indextr].type))">
                      {{
                        data[indextr].message
                          ? textTruncat(data[indextr].message
                                    .replace(/[^\s]{25,}/, '')
                                    .replace(/[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                                    '')
                            , 100)
                          : ''
                      }}
                      </p>
                    <div class="thumb-wrapper" v-if="(data[indextr].attachment_url && data[indextr].attachment_url !== '')">
                      <video v-if="lastPage.network == 'instagram' && ['video', 'VIDEO'].includes(data[indextr].type)" :src="data[indextr].attachment_url"></video>
                      <video v-else-if="lastPage.network == 'instagram' && ['story', 'Story'].includes(data[indextr].type) && data[indextr].attachment_url.includes('.mp4')" :src="data[indextr].attachment_url"></video>
                      <!-- <video v-else-if="lastPage.network == 'linkedin' && ['VIDEO'].includes(data[indextr].type) && data[indextr].video.includes('.mp4')" :src="data[indextr].video"></video> -->
                      
                      <img v-else
                        class="table-img"
                        :src="data[indextr].attachment_url"
                        alt="Image"
                        @error="getMetaOgImage(data[indextr].unshimmed_url, `meta-image-${indextr}`, indextr)"
                        :ref="`meta-image-${indextr}`"
                      />
                    </div>
                    <div class="thumb-wrapper" v-if="lastPage.network == 'linkedin' && ['VIDEO'].includes(data[indextr].type) && data[indextr].video && (data[indextr].video.downloadUrl || data[indextr].video.includes('.mp4'))">
                      <video :src="data[indextr].video.downloadUrl || data[indextr].video"></video>
                    </div>
                    <div class="thumb-wrapper" v-if="lastPage.network == 'linkedin' && ['MULTI-IMAGE'].includes(data[indextr].type) && data[indextr].carrousel && data[indextr].carrousel.length && data[indextr].carrousel[0].url">                      
                      <img
                        class="table-img"
                        :src="data[indextr].carrousel[0].url"
                        alt="Image"
                        @error="getMetaOgImage(data[indextr].unshimmed_url, `meta-image-${indextr}`, indextr)"
                        :ref="`meta-image-${indextr}`"
                      />
                    </div>
                    <div class="thumb-wrapper" v-if="lastPage.network == 'linkedin' && ['NATIVE_DOCUMENT'].includes(data[indextr].type) && data[indextr].document && data[indextr].document.downloadUrl">
                      <pdf :src="data[indextr].document.downloadUrl" :page="1"></pdf>
                    </div>
                    <div class="txt-wrapper" v-if="(data[indextr].attachment_url && data[indextr].attachment_url !== '') || (lastPage.network == 'linkedin' && ['NATIVE_DOCUMENT', 'VIDEO', 'MULTI-IMAGE'].includes(data[indextr].type))">
                      <p v-if="data[indextr].message.replace(/[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/, '')">
                        {{  
                          data[indextr].message
                            ? textTruncat(data[indextr].message
                                      .replace(/[^\s]{25,}/, '')
                                      .replace(/[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/, '')
                              , 100)
                            : ''
                        }}
                      </p>
                      <p v-else-if="data[indextr].unshimmed_url" :ref="`meta-title-${indextr}`">{{ getMetaOgTitle(data[indextr].unshimmed_url, `meta-title-${indextr}`, indextr) }}</p>
                    </div>
                  </div>
                </vs-td>

                <vs-td class="t-type" :data="data[indextr].type">
                  <!-- facebook -->
                  <span v-if="data[indextr].type == 'photo' || data[indextr].type == 'IMAGE' || data[indextr].type === 'RICH'">
                    {{$t('dash.reporting.type_photo')}}
                  </span>
                  <span v-else-if="data[indextr].type == 'MULTI-IMAGE'">
                    {{$t('dash.reporting.type_multi_images')}}
                  </span>
                  <span v-else-if="data[indextr].type == 'video' || data[indextr].type == 'VIDEO'">
                    {{$t('dash.reporting.type_video')}}
                  </span>
                  <span v-else-if="data[indextr].type == 'snippet' || data[indextr].type ==='ARTICLE'">
                    {{$t('dash.reporting.type_snippet')}}
                  </span>
                  <span v-else-if="data[indextr].type == 'text' || data[indextr].type == 'NONE'">
                    {{$t('dash.reporting.type_text')}}
                  </span>
                  <!-- twitter -->
                  <span v-else-if="data[indextr].type == 'tweet'">
                    {{$t('dash.reporting.type_tweet')}}
                  </span>
                  <span v-else-if="data[indextr].type == 'tweet_image'">
                    {{$t('dash.reporting.type_tweet_image')}}
                  </span>
                  <span v-else-if="data[indextr].type == 'tweet_video'">
                    {{$t('dash.reporting.type_tweet_video')}}
                  </span>
                  <span v-else-if="data[indextr].type == 'tweet_animated_gif'">
                    {{$t('dash.reporting.type_tweet_animated_gif')}}
                  </span>
                  <span v-else-if="data[indextr].type == 'quoted'">
                    {{$t('dash.reporting.type_quote')}}
                  </span>
                  <span v-else-if="data[indextr].type == 'quote_image'">
                    {{$t('dash.reporting.type_quote_image')}}
                  </span>
                  <span v-else-if="data[indextr].type === 'quote_video'">
                    {{$t('dash.reporting.type_quote_video')}}
                  </span>
                  <span v-else-if="data[indextr].type === 'quote_animated_gif'">
                    {{$t('dash.reporting.type_quote_animated_gif')}}
                  </span>
                  <!-- instagram -->
                  <span v-else-if="data[indextr].type === 'CAROUSEL_ALBUM'">
                    {{$t('dash.reporting.type_CAROUSEL_ALBUM')}}
                  </span>
                  <!-- linkedin -->
                  <span v-else-if="data[indextr].type === 'NONE' || data[indextr].type === 'none'
                                  || data[indextr].type === 'URN_REFERENCE' || data[indextr].type === '' ">
                    {{$t('dash.reporting.type_NONE')}}
                  </span>
                  <span v-else-if="data[indextr].type ==='NATIVE_DOCUMENT'">
                    {{$t('dash.reporting.type_NATIVE_DOCUMENT')}}
                  </span>
                  <span v-else-if="data[indextr].type === 'LIVE_VIDEO'">
                    {{$t('dash.reporting.type_LIVE_VIDEO')}}
                  </span>
                  <span v-else-if="data[indextr].type === 'CAROUSEL'">
                    {{$t('dash.reporting.type_CAROUSEL')}}
                  </span>
                  <span v-else :data="data[indextr].type">
                    {{data[indextr].type}}
                  </span>
                </vs-td>

                <vs-td
                  class="t-imp"
                  :data="data[indextr].post_impressions || data[indextr].impressions"
                >
                  <span v-if="data[indextr].type === 'video' && data[indextr].video_view_count">
                    {{numberSpacing(data[indextr].video_view_count)}}
                  </span>
                  <span v-else-if="lastPage.network == 'instagram' && data[indextr].post_impressions === null || data[indextr].post_impressions === undefined || data[indextr].post_impressions == 0">0</span>
                  <Tooltip v-else-if="data[indextr].post_impressions === null || data[indextr].post_impressions === undefined" :text="$t('dash.table.no.data')">
                    <span>N/A</span>
                    
                  </Tooltip>
                  <Tooltip v-else-if="data[indextr].reach_impression !== null && data[indextr].reach_impression !== undefined"
                    :text="data[indextr].reach_impression.toLocaleString($i18n.locale, {maximumFractionDigits: 2}) + '%'"
                  >
                    <span>
                      {{ numberSpacing(data[indextr].post_impressions || data[indextr].impressions)}}
                    </span>
                    
                  </Tooltip>
                  <span v-else>
                    {{ numberSpacing(data[indextr].post_impressions || data[indextr].impressions)}}
                  </span>
                  &nbsp;
                  <Tooltip v-if="lastPage.network == 'linkedin' && data[indextr].post_impressions_unique !== null && data[indextr].post_impressions_unique !== undefined"
                    :text="$t('dash.reporting.impression_unique')"
                  >
                    <span>
                      ({{ numberSpacing(data[indextr].post_impressions_unique)}})
                    </span>
                  </Tooltip>
                </vs-td>

                <vs-td class="t-clc" v-if="lastPage.network !== 'instagram' && lastPage.network !== 'tiktok'" :data="data[indextr].link_clicks">
                  <span v-if="data[indextr].total_clicks">
                    {{ numberSpacing(data[indextr].total_clicks)}}
                    <br/>
                    {{ `(${numberSpacing(data[indextr].link_clicks)})`}}
                  </span>
                  <span v-else-if="data[indextr].link_clicks !== null && data[indextr].link_clicks !== undefined">
                    {{ numberSpacing(data[indextr].link_clicks) }}
                  </span>
                  <Tooltip v-else :text="$t('dash.table.no.data')">
                    <span>N/A</span>
                    
                  </Tooltip>
                </vs-td>

                   <vs-td class="t-clc" v-if="lastPage.network == 'pinterest'" :data="data[indextr].reach_save">
                    <span v-if="data[indextr].reach_save !== null && data[indextr].reach_save !== undefined">
                      {{ numberSpacing(data[indextr].reach_save) }}
                    </span>
                    <Tooltip v-else :text="$t('dash.table.no.data')">
                      <span>N/A</span>
                      
                  </Tooltip>
                </vs-td>

                     <vs-td class="t-clc" v-if="lastPage.network == 'pinterest'" :data="data[indextr].reach_outboundclicks">
                    <span v-if="data[indextr].reach_outboundclicks !== null && data[indextr].reach_outboundclicks !== undefined">
                      {{ numberSpacing(data[indextr].reach_outboundclicks) }}
                    </span>
                    <Tooltip v-else :text="$t('dash.table.no.data')">
                      <span>N/A</span>
                      
                  </Tooltip>
                </vs-td>

                <vs-td v-if="lastPage.network !== 'twitter' && lastPage.network != 'pinterest'" class="t-com" :data="data[indextr].comments_count">
                    <span v-if="data[indextr].comments_count !== null && data[indextr].comments_count !== undefined">
                      {{ numberSpacing(data[indextr].comments_count) }}
                    </span>
                    <Tooltip v-else :text="$t('dash.table.no.data')">
                      <span>N/A</span>
                      
                  </Tooltip>
                </vs-td>

                <vs-td v-if="['facebook', 'linkedin', 'tiktok'].includes(lastPage.network)" class="t-ptg" :data="data[indextr].shares_count">
                  <span>
                    {{ numberSpacing(data[indextr].shares_count) }}
                  </span>
                </vs-td>

                <vs-td class="t-rea" v-if="lastPage.network === 'facebook'" :data="data[indextr].post_reactions">
                  <div class="reaction">
                    <span class="icon">
                      <img src="../../../assets/img/reporting_icons/angry.svg" alt="Angry">
                    </span> 
                    <span class="text">{{ numberSpacing(data[indextr].post_reactions[0].value.anger) }}</span>
                  </div>
                  <div class="reaction">
                    <span class="icon">
                      <img src="../../../assets/img/reporting_icons/haha.svg" alt="Haha">
                    </span> 
                    <span class="text">{{ numberSpacing(data[indextr].post_reactions[0].value.haha) }}</span>
                  </div>
                  <div class="reaction">
                    <span class="icon">
                      <img src="../../../assets/img/reporting_icons/like.svg" alt="Like">
                    </span> 
                    <span class="text">{{ numberSpacing(data[indextr].post_reactions[0].value.like) }}</span>
                  </div>
                  <div class="reaction">
                    <span class="icon">
                      <img src="../../../assets/img/reporting_icons/love.svg" alt="Love">
                    </span> 
                    <span class="text">{{ numberSpacing(data[indextr].post_reactions[0].value.love) }}</span>
                  </div>
                  <div class="reaction">
                    <span class="icon">
                      <img src="../../../assets/img/reporting_icons/sad.svg" alt="Sad">
                    </span> 
                    <span class="text">{{ numberSpacing(data[indextr].post_reactions[0].value.sad) }}</span>
                  </div>
                  <div class="reaction">
                    <span class="icon">
                      <img src="../../../assets/img/reporting_icons/wow.svg" alt="Wow">
                    </span> 
                    <span class="text">{{ numberSpacing(data[indextr].post_reactions[0].value.wow) }}</span>
                  </div>
                  <div class="sum">{{$t('dash.reporting.total_reactions') + ' ' + numberSpacing(data[indextr].post_reactions[0].sum)}}</div>
                </vs-td>
                
                <vs-td class="t-rea" v-if="lastPage.network === 'linkedin' && data[indextr].post_reactions" :data="data[indextr].post_reactions">
                  <div class="reaction">
                    <span class="icon icon-linkedin">
                      <img src="../../../assets/img/reporting_icons/linkedin-curious.png" alt="MAYBE">
                    </span> 
                    <span class="text">{{ numberSpacing(data[indextr].post_reactions[0].value.MAYBE) }}</span>
                  </div>
                  <div class="reaction">
                    <span class="icon icon-linkedin">
                      <img src="../../../assets/img/reporting_icons/linkedin-celebrate.png" alt="PRAISE">
                    </span> 
                    <span class="text">{{ numberSpacing(data[indextr].post_reactions[0].value.PRAISE) }}</span>
                  </div>
                  <div class="reaction">
                    <span class="icon icon-linkedin">
                      <img src="../../../assets/img/reporting_icons/linkedin-like.png" alt="LIKE">
                    </span> 
                    <span class="text">{{ numberSpacing(data[indextr].post_reactions[0].value.LIKE) }}</span>
                  </div>
                  <div class="reaction">
                    <span class="icon icon-linkedin">
                      <img src="../../../assets/img/reporting_icons/linkedin-love.png" alt="EMPATHY">
                    </span> 
                    <span class="text">{{ numberSpacing(data[indextr].post_reactions[0].value.EMPATHY) }}</span>
                  </div>
                  <div class="reaction">
                    <span class="icon icon-linkedin" >
                      <img src="../../../assets/img/reporting_icons/linkedin-insightful.png" alt="INTEREST">
                    </span> 
                    <span class="text">{{ numberSpacing(data[indextr].post_reactions[0].value.INTEREST) }}</span>
                  </div>
                  <div class="reaction">
                    <span class="icon icon-linkedin">
                      <img src="../../../assets/img/reporting_icons/linkedin-support.png" alt="APPRECIATION">
                    </span> 
                    <span class="text">{{ numberSpacing(data[indextr].post_reactions[0].value.APPRECIATION) }}</span>
                  </div>
                  <div class="sum">{{$t('dash.reporting.total_reactions') + ' ' + numberSpacing(data[indextr].post_reactions[0].sum)}}</div>
                </vs-td>
                <vs-td v-else-if="lastPage.network === 'linkedin'">
                  <Tooltip :text="$t('dash.table.no.data')">
                    <span>N/A</span>
                    
                  </Tooltip>
                </vs-td>

                <vs-td v-if="lastPage.network === 'twitter'" class="t-tw-rt" :data="data[indextr].retweet_count">
                  {{data[indextr].retweet_count}}
                </vs-td>

                <vs-td v-if="lastPage.network === 'twitter'  || lastPage.network === 'instagram' || lastPage.network === 'tiktok'" class="t-tw-like" :data="data[indextr].like_count">
                  <span v-if="data[indextr].like_count !== null && data[indextr].like_count !== undefined">
                    {{data[indextr].like_count}}
                  </span>
                  <Tooltip v-else :text="$t('dash.table.no.data')">
                    <span>N/A</span>

                  </Tooltip>
                </vs-td>

                <!-- TikTok Conciergerie metrics cells -->
                <vs-td v-if="lastPage.network === 'tiktok'" class="t-time_watched" :data="data[indextr].time_watched">
                  <span v-if="data[indextr].time_watched !== null && data[indextr].time_watched !== undefined">
                    {{ humanizeTime(data[indextr].time_watched * 1000) }}
                  </span>
                  <Tooltip v-else :text="$t('dash.table.no.data')">
                    <span>N/A</span>
                  </Tooltip>
                </vs-td>

                <vs-td v-if="lastPage.network === 'tiktok'" class="t-video_per_duration" :data="data[indextr].video_per_duration">
                  <span v-if="data[indextr].video_per_duration !== null && data[indextr].video_per_duration !== undefined">
                    {{ humanizeTime(data[indextr].video_per_duration * 1000) }}
                  </span>
                  <Tooltip v-else :text="$t('dash.table.no.data')">
                    <span>N/A</span>
                  </Tooltip>
                </vs-td>

                <vs-td v-if="lastPage.network === 'tiktok'" class="t-viewer" :data="data[indextr].viewer">
                  <span v-if="data[indextr].viewer !== null && data[indextr].viewer !== undefined">
                    {{ numberSpacing(data[indextr].viewer) }}
                  </span>
                  <Tooltip v-else :text="$t('dash.table.no.data')">
                    <span>N/A</span>
                  </Tooltip>
                </vs-td>

                <vs-td v-if="lastPage.network === 'tiktok'" class="t-video_finish_rate" :data="data[indextr].video_finish_rate">
                  <span v-if="data[indextr].video_finish_rate !== null && data[indextr].video_finish_rate !== undefined">
                    {{ (data[indextr].video_finish_rate * 100).toLocaleString($i18n.locale, {maximumFractionDigits: 2}) }}%
                  </span>
                  <Tooltip v-else :text="$t('dash.table.no.data')">
                    <span>N/A</span>
                  </Tooltip>
                </vs-td>

                <vs-td v-if="lastPage.network === 'tiktok'" class="t-video_new_follower" :data="data[indextr].video_new_follower">
                  <span v-if="data[indextr].video_new_follower !== null && data[indextr].video_new_follower !== undefined">
                    {{ numberSpacing(data[indextr].video_new_follower) }}
                  </span>
                  <Tooltip v-else :text="$t('dash.table.no.data')">
                    <span>N/A</span>
                  </Tooltip>
                </vs-td>

                <vs-td v-if="lastPage.network === 'twitter'" class="t-tw-reply" :data="data[indextr].reply_count">
                  {{data[indextr].reply_count}}
                </vs-td>

                <vs-td v-if="lastPage.network === 'twitter'" class="t-tw-quote" :data="data[indextr].quote_count">
                  {{data[indextr].quote_count}}
                </vs-td>

                <vs-td  v-if="lastPage.network != 'pinterest'" class="t-eng" :data="data[indextr].reach_engagement ||  (data[indextr].like_count*100 / data[indextr].impressions)">
                  <span v-if="data[indextr].reach_engagement !== undefined">
                    {{data[indextr].reach_engagement !== null ? data[indextr].reach_engagement.toLocaleString($i18n.locale, {maximumFractionDigits: 2}) : (data[indextr].like_count*100 / data[indextr].impressions).toLocaleString($i18n.locale, {maximumFractionDigits: 2})}}%
                  </span>
                  <Tooltip v-else :text="$t('dash.table.no.data')">
                    <span>N/A</span>
                    
                  </Tooltip>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <div class="section-graph" v-if="pageStats && ['linkedin', 'instagram', 'facebook', 'tiktok'].includes(lastPage.network)">
            <div>
              <ul class="bar">
                <li class="small">
                  <componentGraph
                    class="graph"
                    :data="graphData.filter(g => ['typePosts_graph'].includes(g.name)).slice(0,10)"
                    :state="['0','1','2','3','4','5','6']"
                    :labels="graphData.find(g => ['typePosts_graph'].includes(g.name)).labels.slice(0,10)"
                    :lang="$i18n.locale"
                    :section="'typePosts_graph'"
                    :key="'typePosts_graph'"
                    :size="sizeHorizontalGraph"
                  />
                </li>
                <li class="small">
                  <componentGraph
                    class="graph"
                    :data="graphData.filter(g => ['typePosts_engagement_graph'].includes(g.name)).slice(0,10)"
                    :state="['0','1','2','3','4','5','6']"
                    :labels="graphData.find(g => ['typePosts_engagement_graph'].includes(g.name)).labels.slice(0,10)"
                    :lang="$i18n.locale"
                    :section="'typePosts_engagement_graph'"
                    :key="'typePosts_engagement_graph'"
                    :size="sizeHorizontalGraph"
                  />
                </li>
                <li class="small">
                  <componentGraph
                    class="graph"
                    :data="graphData.filter(g => ['dayPosts_graph'].includes(g.name)).slice(0,10)"
                    :state="['0','1','2','3','4','5','6']"
                    :labels="graphData.find(g => ['dayPosts_graph'].includes(g.name)).labels.slice(0,10)"
                    :lang="$i18n.locale"
                    :section="'dayPosts_graph'"
                    :key="'dayPosts_graph'"
                    :size="sizeHorizontalGraph"
                  />
                </li>
                <li class="small">
                  <componentGraph
                    class="graph"
                    :data="graphData.filter(g => ['dayPosts_engagement_graph'].includes(g.name)).slice(0,10)"
                    :state="['0','1','2','3','4','5','6']"
                    :labels="graphData.find(g => ['dayPosts_engagement_graph'].includes(g.name)).labels.slice(0,10)"
                    :lang="$i18n.locale"
                    :section="'dayPosts_engagement_graph'"
                    :key="'dayPosts_engagement_graph'"
                    :size="sizeHorizontalGraph"
                  />
                </li>
                
              </ul>
            </div>
          </div>

          <div class="posts table-wrapper linkedin-video" v-if="pageStats && postList && postList.length && postList.filter(p => p.type == 'VIDEO').length && lastPage.network === 'linkedin'">
            <vs-table :hoverFlat='true'
              class="content-table"
              search
              :data="postList.filter(p => p.type == 'VIDEO')"
              max-items="20" pagination
              :noDataText="$t('dash.noDataText')"
            >

              <template slot="header">
                <div>
                  <h3>{{$t('dash.reporting.section.videos-list.title')}}</h3>
                </div>
              </template>

              <template slot="thead">
                <vs-th class="t-id"><Tooltip  :text="$t('dash.reporting.header_id')"><span>  </span>  </Tooltip> </vs-th> 
                <vs-th class="t-date" sortKey="created_time"> 
                  {{capitalize($t('dash.table.title.date'))}}
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-msg" sortKey="message"> 
                  {{capitalize($t('dash.table.title.content'))}} 
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>

                <vs-th class="t-video_view_count" sortKey="video_view_count">
                  <Tooltip  :text="$t('dash.reporting.header_video_view_count')"><span>
                  {{$t('dash.reporting.video_view_count')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-video_time_watched" sortKey="video_time_watched">
                  <Tooltip  :text="$t('dash.reporting.header_video_time_watched')"><span>
                  {{$t('dash.reporting.video_time_watched')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-video_time_watched_avg" sortKey="video_time_watched_avg">
                  <Tooltip  :text="$t('dash.reporting.header_video_time_watched_avg')"><span>
                  {{$t('dash.reporting.video_time_watched_avg')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-video_viewer" sortKey="video_viewer">
                  <Tooltip  :text="$t('dash.reporting.header_video_viewer')"><span>
                  {{$t('dash.reporting.video_viewer')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-imp" sortKey="post_impressions">
                  <Tooltip  :text="$t('dash.reporting.header_impression')"><span>
                  {{$t('dash.reporting.impression')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th v-if="lastPage.network !== 'instagram' && lastPage.network !== 'tiktok'" class="t-clc" sortKey="link_clicks"> 
                  <Tooltip  :text="$t(`dash.reporting.header_click${lastPage.network === 'facebook' ? '.fb' : ''}`)"><span>
                  {{$t(`dash.reporting.clic`)}} 
                  </span>
                  <span v-if="lastPage.network === 'facebook'">
                    <br/>
                    {{$t(`dash.reporting.clic.fb`)}} 
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th v-if="lastPage.network !== 'twitter' && lastPage.network !== 'pinterest'" class="t-com" sortKey="comments_count"> 
                  {{$t('dash.reporting.comment')}}
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-ptg" v-if="['facebook', 'linkedin', 'tiktok'].includes(lastPage.network)" sortKey="shares_count">
                  <Tooltip  :text="$t('dash.reporting.header_share')"><span> 
                  {{$t('dash.label.fb.shares')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th> 
                <!-- <vs-th class="t-rea" v-if="lastPage.network === 'facebook' || lastPage.network === 'linkedin'" sortKey="post_reactions_sum"> 
                  {{$t('dash.reporting.reaction')}} 
                   <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th> -->
                <vs-th class="t-eng" v-if="lastPage.network != 'pinterest'" sortKey="reach_engagement">
                  <Tooltip  :text="$t('dash.reporting.header_engamement')"><span> 
                  {{$t('dash.reporting.engagemment')}} 
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
              </template>

              <template slot-scope="{ data }" v-if="data">
                <vs-tr :key="`data-posts-${indextr}`" v-for="(tr, indextr) in data">
                  <vs-td class="t-id" :data="data[indextr].id">
                    <a @click.prevent="openLink(data[indextr].permalink_url || data[indextr].permalink)">#{{ data[indextr].id }}</a>
                  </vs-td>

                  <vs-td class="t-date" :data="data[indextr].created_time || data[indextr].timestamp">
                    {{ formatDate(data[indextr].created_time || data[indextr].timestamp) }}
                  </vs-td>

                  <vs-td class="t-msg" :data="data[indextr].message">
                    <div class="cell-msg">
                      <p class="only-text" v-if="(!data[indextr].attachment_url || data[indextr].attachment_url === '')">
                        {{
                          data[indextr].message
                            ? textTruncat(data[indextr].message
                                      .replace(/[^\s]{25,}/, '')
                                      .replace(/[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                                      '')
                              , 100)
                            : ''
                        }}
                        </p>
                      <div class="thumb-wrapper" v-if="(data[indextr].attachment_url && data[indextr].attachment_url !== '')">
                        <video v-if="lastPage.network == 'instagram' && ['video', 'VIDEO'].includes(data[indextr].type)" :src="data[indextr].attachment_url"></video>
                        <video v-else-if="lastPage.network == 'instagram' && ['story', 'Story'].includes(data[indextr].type) && data[indextr].attachment_url.includes('.mp4')" :src="data[indextr].attachment_url"></video>
                  
                        <img v-else
                          class="table-img"
                          :src="data[indextr].attachment_url"
                          alt="Image"
                          @error="getMetaOgImage(data[indextr].unshimmed_url, `meta-image-${indextr}`, indextr)"
                          :ref="`meta-image-${indextr}`"
                        />
                      </div>
                      <div class="txt-wrapper" v-if="(data[indextr].attachment_url && data[indextr].attachment_url !== '')">
                        <p v-if="data[indextr].message.replace(/[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/, '')">
                          {{  
                            data[indextr].message
                              ? textTruncat(data[indextr].message
                                        .replace(/[^\s]{25,}/, '')
                                        .replace(/[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/, '')
                                , 100)
                              : ''
                          }}
                        </p>
                        <p v-else-if="data[indextr].unshimmed_url" :ref="`meta-title-${indextr}`">{{ getMetaOgTitle(data[indextr].unshimmed_url, `meta-title-${indextr}`, indextr) }}</p>
                      </div>
                    </div>
                  </vs-td>
                  <vs-td
                    class="t-video_view_count"
                    :data="data[indextr].video_view"
                  >
                    <span>
                      {{ numberSpacing(data[indextr].video_view)}}
                    </span>
                  </vs-td>
                  <vs-td
                    class="t-video_time_watched"
                    :data="humanizeTime(data[indextr].time_watched)"
                  >
                    <span>
                      {{ humanizeTime(data[indextr].time_watched)}}
                    </span>
                  </vs-td>
                  <vs-td
                    class="t-video_time_watched_avg"
                    :data="humanizeTime(data[indextr].time_watched / data[indextr].video_view)"
                  >
                    <span>
                      <!-- {{ numberSpacing(data[indextr].time_watched / data[indextr].video_view)}} ms -->
                      {{ humanizeTime(data[indextr].time_watched / data[indextr].video_view)}}
                    </span>
                  </vs-td>
                  <vs-td
                    class="t-video_viewer"
                    :data="data[indextr].viewer"
                  >
                    <span>
                      {{ numberSpacing(data[indextr].viewer)}}
                    </span>
                  </vs-td>
                  <vs-td
                  class="t-imp"
                  :data="data[indextr].post_impressions || data[indextr].impressions"
                  >
                    <span v-if="data[indextr].type === 'video' && data[indextr].video_view_count">
                      {{numberSpacing(data[indextr].video_view_count)}}
                    </span>
                    <span v-else-if="lastPage.network == 'instagram' && data[indextr].post_impressions === null || data[indextr].post_impressions === undefined || data[indextr].post_impressions == 0">0</span>
                    <Tooltip v-else-if="data[indextr].post_impressions === null || data[indextr].post_impressions === undefined" :text="$t('dash.table.no.data')">
                      <span>N/A</span>
                      
                    </Tooltip>
                    <Tooltip v-else-if="data[indextr].reach_impression !== null && data[indextr].reach_impression !== undefined"
                      :text="data[indextr].reach_impression.toLocaleString($i18n.locale, {maximumFractionDigits: 2}) + '%'"
                    >
                      <span>
                        {{ numberSpacing(data[indextr].post_impressions || data[indextr].impressions)}}
                      </span>
                      
                    </Tooltip>
                    <span v-else>
                      {{ numberSpacing(data[indextr].post_impressions || data[indextr].impressions)}}
                    </span>
                    &nbsp;
                    <Tooltip v-if="data[indextr].post_impressions_unique !== null && data[indextr].post_impressions_unique !== undefined"
                      :text="$t('dash.reporting.impression_unique')"
                    >
                      <span>
                        ({{ numberSpacing(data[indextr].post_impressions_unique)}})
                      </span>
                    </Tooltip>
                  </vs-td>
                  <vs-td class="t-clc" v-if="lastPage.network !== 'instagram' && lastPage.network !== 'tiktok'" :data="data[indextr].link_clicks">
                    <span v-if="data[indextr].total_clicks">
                      {{ numberSpacing(data[indextr].total_clicks)}}
                      <br/>
                      {{ `(${numberSpacing(data[indextr].link_clicks)})`}}
                    </span>
                    <span v-else-if="data[indextr].link_clicks !== null && data[indextr].link_clicks !== undefined">
                      {{ numberSpacing(data[indextr].link_clicks) }}
                    </span>
                    <Tooltip v-else :text="$t('dash.table.no.data')">
                      <span>N/A</span>
                      
                    </Tooltip>
                  </vs-td>
                  <vs-td v-if="lastPage.network !== 'twitter' && lastPage.network != 'pinterest'" class="t-com" :data="data[indextr].comments_count">
                    <span v-if="data[indextr].comments_count !== null && data[indextr].comments_count !== undefined">
                      {{ numberSpacing(data[indextr].comments_count) }}
                    </span>
                    <Tooltip v-else :text="$t('dash.table.no.data')">
                      <span>N/A</span>
                      
                    </Tooltip>
                  </vs-td>
                  <vs-td v-if="['facebook', 'linkedin', 'tiktok'].includes(lastPage.network)" class="t-ptg" :data="data[indextr].shares_count">
                    <span>
                      {{ numberSpacing(data[indextr].shares_count) }}
                    </span>
                  </vs-td>
                  <!-- <vs-td class="t-rea" v-if="lastPage.network === 'linkedin' && data[indextr].post_reactions" :data="data[indextr].post_reactions">
                    <div class="reaction">
                      <span class="icon icon-linkedin">
                        <img src="../../../assets/img/reporting_icons/linkedin-curious.png" alt="MAYBE">
                      </span> 
                      <span class="text">{{ numberSpacing(data[indextr].post_reactions[0].value.MAYBE) }}</span>
                    </div>
                    <div class="reaction">
                      <span class="icon icon-linkedin">
                        <img src="../../../assets/img/reporting_icons/linkedin-celebrate.png" alt="PRAISE">
                      </span> 
                      <span class="text">{{ numberSpacing(data[indextr].post_reactions[0].value.PRAISE) }}</span>
                    </div>
                    <div class="reaction">
                      <span class="icon icon-linkedin">
                        <img src="../../../assets/img/reporting_icons/linkedin-like.png" alt="LIKE">
                      </span> 
                      <span class="text">{{ numberSpacing(data[indextr].post_reactions[0].value.LIKE) }}</span>
                    </div>
                    <div class="reaction">
                      <span class="icon icon-linkedin">
                        <img src="../../../assets/img/reporting_icons/linkedin-love.png" alt="EMPATHY">
                      </span> 
                      <span class="text">{{ numberSpacing(data[indextr].post_reactions[0].value.EMPATHY) }}</span>
                    </div>
                    <div class="reaction">
                      <span class="icon icon-linkedin" >
                        <img src="../../../assets/img/reporting_icons/linkedin-insightful.png" alt="INTEREST">
                      </span> 
                      <span class="text">{{ numberSpacing(data[indextr].post_reactions[0].value.INTEREST) }}</span>
                    </div>
                    <div class="reaction">
                      <span class="icon icon-linkedin">
                        <img src="../../../assets/img/reporting_icons/linkedin-support.png" alt="APPRECIATION">
                      </span> 
                      <span class="text">{{ numberSpacing(data[indextr].post_reactions[0].value.APPRECIATION) }}</span>
                    </div>
                    <div class="sum">{{$t('dash.reporting.total_reactions') + ' ' + numberSpacing(data[indextr].post_reactions[0].sum)}}</div>
                  </vs-td>
                  <vs-td v-else-if="lastPage.network === 'linkedin'">
                    <Tooltip :text="$t('dash.table.no.data')">
                      <span>N/A</span>
                      
                    </Tooltip>
                  </vs-td> -->
                  <vs-td  v-if="lastPage.network != 'pinterest'" class="t-eng" :data="data[indextr].reach_engagement ||  (data[indextr].like_count*100 / data[indextr].impressions)">
                    <span v-if="data[indextr].reach_engagement !== undefined">
                      {{data[indextr].reach_engagement !== null ? data[indextr].reach_engagement.toLocaleString($i18n.locale, {maximumFractionDigits: 2}) : (data[indextr].like_count*100 / data[indextr].impressions).toLocaleString($i18n.locale, {maximumFractionDigits: 2})}}%
                    </span>
                    <Tooltip v-else :text="$t('dash.table.no.data')">
                      <span>N/A</span>
                      
                    </Tooltip>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
          </div>

        </div>

        <div class="section-graph stories" v-if="(pageStats && pageStats.page && pageStats.postsPercentLoader == 100) && lastPage.network === 'instagram' && postList.filter(p => p.type == 'Story').length">
          <div class="posts table-wrapper">
            <vs-table :hoverFlat='true'
              class="content-table"
              search
              :data="postList.filter(p => p.type == 'Story')"
              max-items="20" pagination
              :noDataText="$t('dash.noDataText')"
            >

              <template slot="header">
                <div>
                  <h3>{{$t('dash.reporting.section.story-list.title')}}</h3>
                </div>
              </template>

              <template slot="thead">
                <vs-th class="t-id"><Tooltip  :text="$t('dash.reporting.header_id')"><span>  </span>  </Tooltip> </vs-th> 
                <vs-th class="t-date" sortKey="created_time"> 
                  {{capitalize($t('dash.table.title.date'))}}
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-msg" sortKey="message"> 
                  {{capitalize($t('dash.table.title.content'))}} 
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>

                <vs-th class="t-post_impressions" sortKey="post_impressions">
                  <Tooltip  :text="$t('dash.reporting.header_story_impressions')"><span>
                  {{$t('dash.reporting.impressions')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-replies" sortKey="replies">
                  <Tooltip  :text="$t('dash.reporting.header_story_replies')"><span>
                  {{$t('dash.reporting.replies')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-shares" sortKey="shares">
                  <Tooltip  :text="$t('dash.reporting.header_story_shares')"><span>
                  {{$t('dash.reporting.shares')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-total_interactions" sortKey="total_interactions">
                  <Tooltip  :text="$t('dash.reporting.header_story_total_interactions')"><span>
                  {{$t('dash.reporting.total_interactions')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-navigation" sortKey="navigation">
                  <Tooltip  :text="$t('dash.reporting.header_story_navigation')"><span>
                  {{$t('dash.reporting.navigation')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-profile_visits" sortKey="profile_visits">
                  <Tooltip  :text="$t('dash.reporting.header_story_profile_visits')"><span>
                  {{$t('dash.reporting.profile_visits')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-profile_activity" sortKey="profile_activity">
                  <Tooltip  :text="$t('dash.reporting.header_story_profile_activity')"><span>
                  {{$t('dash.reporting.profile_activity')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-follows" sortKey="follows">
                  <Tooltip  :text="$t('dash.reporting.header_story_follows')"><span>
                  {{$t('dash.reporting.follows')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
              </template>

              <template slot-scope="{ data }" v-if="data">
                <vs-tr :key="`data-posts-${indextr}`" v-for="(tr, indextr) in data">
                  <vs-td class="t-id" :data="data[indextr].id">
                    <a @click.prevent="openLink(data[indextr].permalink_url || data[indextr].permalink)">#{{ data[indextr].id }}</a>
                  </vs-td>

                  <vs-td class="t-date" :data="data[indextr].created_time || data[indextr].timestamp">
                    {{ formatDate(data[indextr].created_time || data[indextr].timestamp) }}
                  </vs-td>

                  <vs-td class="t-msg" :data="data[indextr].message">
                    <div class="cell-msg">
                      <p class="only-text" v-if="(!data[indextr].attachment_url || data[indextr].attachment_url === '')">
                        {{
                          data[indextr].message
                            ? textTruncat(data[indextr].message
                                      .replace(/[^\s]{25,}/, '')
                                      .replace(/[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                                      '')
                              , 100)
                            : ''
                        }}
                        </p>
                      <div class="thumb-wrapper" v-if="(data[indextr].attachment_url && data[indextr].attachment_url !== '')">
                        <video v-if="lastPage.network == 'instagram' && ['video', 'VIDEO'].includes(data[indextr].type)" :src="data[indextr].attachment_url"></video>
                        <video v-else-if="lastPage.network == 'instagram' && ['story', 'Story'].includes(data[indextr].type) && data[indextr].attachment_url.includes('.mp4')" :src="data[indextr].attachment_url"></video>
                  
                        <img v-else
                          class="table-img"
                          :src="data[indextr].attachment_url"
                          alt="Image"
                          @error="getMetaOgImage(data[indextr].unshimmed_url, `meta-image-${indextr}`, indextr)"
                          :ref="`meta-image-${indextr}`"
                        />
                      </div>
                      <div class="txt-wrapper" v-if="(data[indextr].attachment_url && data[indextr].attachment_url !== '')">
                        <p v-if="data[indextr].message.replace(/[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/, '')">
                          {{  
                            data[indextr].message
                              ? textTruncat(data[indextr].message
                                        .replace(/[^\s]{25,}/, '')
                                        .replace(/[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/, '')
                                , 100)
                              : ''
                          }}
                        </p>
                        <p v-else-if="data[indextr].unshimmed_url" :ref="`meta-title-${indextr}`">{{ getMetaOgTitle(data[indextr].unshimmed_url, `meta-title-${indextr}`, indextr) }}</p>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td
                    class="t-post_impressions"
                    :data="data[indextr].post_impressions"
                  >
                    <span>
                      {{ numberSpacing(data[indextr].post_impressions)}}
                    </span>
                  </vs-td>
                  <vs-td
                    class="t-replies"
                    :data="data[indextr].replies"
                  >
                    <span>
                      {{ numberSpacing(data[indextr].replies)}}
                    </span>
                  </vs-td>
                  <vs-td
                    class="t-shares"
                    :data="data[indextr].shares"
                  >
                    <span>
                      {{ numberSpacing(data[indextr].shares)}}
                    </span>
                  </vs-td>
                  <vs-td
                    class="t-total_interactions"
                    :data="data[indextr].total_interactions"
                  >
                    <span>
                      {{ numberSpacing(data[indextr].total_interactions)}}
                    </span>
                  </vs-td>
                  <vs-td
                    class="t-navigation"
                    :data="data[indextr].navigation"
                  >
                    <span>
                      {{ numberSpacing(data[indextr].navigation)}}
                    </span>
                  </vs-td>
                  <vs-td
                    class="t-profile_visits"
                    :data="data[indextr].profile_visits"
                  >
                    <span>
                      {{ numberSpacing(data[indextr].profile_visits)}}
                    </span>
                  </vs-td>
                  <vs-td
                    class="t-profile_activity"
                    :data="data[indextr].profile_activity"
                  >
                    <span>
                      {{ numberSpacing(data[indextr].profile_activity)}}
                    </span>
                  </vs-td>
                  <vs-td
                    class="t-follows"
                    :data="data[indextr].follows"
                  >
                    <span>
                      {{ numberSpacing(data[indextr].follows)}}
                    </span>
                  </vs-td>
                </vs-tr>
              </template>

            </vs-table>
          </div>
        </div>

        <div class="section-graph videos" v-if="(pageStats && pageStats.page && pageStats.postsPercentLoader == 100) && lastPage.network === 'facebook' && !lastPage.isGroup && graphData.filter(g => ['video_views','video_views_paid','video_views_organic','video_views_autoplayed','video_views_click_to_play','video_views_unique','video_repeat_views','video_complete_views_30s','video_view_time'].includes(g.name)).length > 1">
          <div class="section-title">{{$t('dash.reporting.section.videos.title')}}</div>
          <div class="section-subtitle">{{$t('dash.reporting.section.videos.subtitle')}}</div>
          <div>
            <div class="informations">
              
              <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-eye"></i>
                <h3>{{$t('dash.label.fb.video_views')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'video_views') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_video_views">
                  <Tooltip v-if="graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.page_video_views.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_views.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.page_video_views.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_views.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.page_video_views.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_views.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_video_views.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

             <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
              <i class="fa-solid fa-eye"></i>
                <h3>{{$t('dash.label.fb.video_views_paid')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'video_views_paid') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'video_views_paid').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'video_views_paid').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'video_views_paid').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'video_views_paid').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'video_views_paid').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'video_views_paid').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'video_views_paid').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_video_views_paid">
                  <Tooltip v-if="graphData.find(g => g.name == 'video_views_paid').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.page_video_views_paid.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_views_paid.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'video_views_paid').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views_paid.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'video_views_paid').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'video_views_paid').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.page_video_views_paid.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_views_paid.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'video_views_paid').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.page_video_views_paid.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_views_paid.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_video_views_paid.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'video_views_paid').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views_paid.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-eye"></i>
                <h3>{{$t('dash.label.fb.video_views_organic')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'video_views_organic') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'video_views_organic').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'video_views_organic').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'video_views_organic').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'video_views_organic').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'video_views_organic').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'video_views_organic').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'video_views_organic').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_video_views_organic">
                  <Tooltip v-if="graphData.find(g => g.name == 'video_views_organic').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.page_video_views_organic.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_views_organic.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'video_views_organic').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views_organic.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'video_views_organic').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'video_views_organic').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.page_video_views_organic.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_views_organic.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'video_views_organic').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.page_video_views_organic.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_views_organic.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_video_views_organic.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'video_views_organic').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views_organic.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-eye"></i>
                <h3>{{$t('dash.label.fb.video_views_autoplayed')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'video_views_autoplayed') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'video_views_autoplayed').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'video_views_autoplayed').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'video_views_autoplayed').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'video_views_autoplayed').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'video_views_autoplayed').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'video_views_autoplayed').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'video_views_autoplayed').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_video_views_autoplayed">
                  <Tooltip v-if="graphData.find(g => g.name == 'video_views_autoplayed').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.page_video_views_autoplayed.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_views_autoplayed.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'video_views_autoplayed').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views_autoplayed.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'video_views_autoplayed').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'video_views_autoplayed').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.page_video_views_autoplayed.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_views_autoplayed.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'video_views_autoplayed').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.page_video_views_autoplayed.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_views_autoplayed.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_video_views_autoplayed.map(v => v.total).reduce((prev, curr) => prev + curr)">+{{ formatPercentageChange((graphData.find(g => g.name == 'video_views_autoplayed').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views_autoplayed.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-arrow-pointer"></i>
                <h3>{{$t('dash.label.fb.video_views_click_to_play')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'video_views_click_to_play') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'video_views_click_to_play').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'video_views_click_to_play').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'video_views_click_to_play').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'video_views_click_to_play').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'video_views_click_to_play').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'video_views_click_to_play').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'video_views_click_to_play').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_video_views_click_to_play">
                  <Tooltip v-if="graphData.find(g => g.name == 'video_views_click_to_play').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.page_video_views_click_to_play.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_views_click_to_play.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'video_views_click_to_play').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views_click_to_play.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'video_views_click_to_play').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'video_views_click_to_play').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.page_video_views_click_to_play.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_views_click_to_play.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'video_views_click_to_play').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.page_video_views_click_to_play.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_views_click_to_play.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_video_views_click_to_play.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'video_views_click_to_play').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views_click_to_play.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-repeat"></i>
                <h3>{{$t('dash.label.fb.video_views_unique')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'video_views_unique') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'video_views_unique').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'video_views_unique').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'video_views_unique').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'video_views_unique').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'video_views_unique').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'video_views_unique').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'video_views_unique').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_video_views_unique">
                  <Tooltip v-if="graphData.find(g => g.name == 'video_views_unique').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.page_video_views_unique.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_views_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'video_views_unique').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views_unique.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'video_views_unique').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'video_views_unique').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.page_video_views_unique.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_views_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'video_views_unique').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.page_video_views_unique.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_views_unique.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_video_views_unique.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'video_views_unique').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views_unique.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-repeat"></i>
                <h3>{{$t('dash.label.fb.video_repeat_views')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'video_repeat_views') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'video_repeat_views').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'video_repeat_views').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'video_repeat_views').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'video_repeat_views').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'video_repeat_views').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'video_repeat_views').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'video_repeat_views').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_video_repeat_views">
                  <Tooltip v-if="graphData.find(g => g.name == 'video_repeat_views').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.page_video_repeat_views.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_repeat_views.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'video_repeat_views').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_repeat_views.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'video_repeat_views').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'video_repeat_views').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.page_video_repeat_views.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_repeat_views.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'video_repeat_views').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.page_video_repeat_views.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_repeat_views.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_video_repeat_views.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'video_repeat_views').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_repeat_views.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">

              <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-repeat"></i>
                <h3>{{$t('dash.label.fb.video_complete_views_30s')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'video_complete_views_30s') === null">N/A</p>
                <Tooltip v-else-if="graphData.find(g => g.name == 'video_complete_views_30s').data.reduce((prev, curr) => prev + curr) >= 1000000" :text="numberSpacing(graphData.find(g => g.name == 'video_complete_views_30s').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'video_complete_views_30s').data.reduce((prev, curr) => prev + curr)  )/1000000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">M</span></p>
                  
                </Tooltip>
                <Tooltip v-else-if="graphData.find(g => g.name == 'video_complete_views_30s').data.reduce((prev, curr) => prev + curr) >= 1000" :text="numberSpacing(graphData.find(g => g.name == 'video_complete_views_30s').data.reduce((prev, curr) => prev + curr))">
                  <p class="big-number">{{ numberSpacing(Number((graphData.find(g => g.name == 'video_complete_views_30s').data.reduce((prev, curr) => prev + curr))/1000).toLocaleString($i18n.locale, {maximumFractionDigits: 1})) }}<span class="percent">k</span></p>
                  
                </Tooltip>
                <p v-else>{{ numberSpacing(graphData.find(g => g.name == 'video_complete_views_30s').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_video_complete_views_30s">
                  <Tooltip v-if="graphData.find(g => g.name == 'video_complete_views_30s').data.reduce((prev, curr) => prev + curr) < pageStats.page.previous_period.page_video_complete_views_30s.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_complete_views_30s.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - (graphData.find(g => g.name == 'video_complete_views_30s').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_complete_views_30s.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'video_complete_views_30s').data.reduce((prev, curr) => prev + curr) != 0 && graphData.find(g => g.name == 'video_complete_views_30s').data.reduce((prev, curr) => prev + curr) == pageStats.page.previous_period.page_video_complete_views_30s.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_complete_views_30s.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="graphData.find(g => g.name == 'video_complete_views_30s').data.reduce((prev, curr) => prev + curr) > pageStats.page.previous_period.page_video_complete_views_30s.map(v => v.total).reduce((prev, curr) => prev + curr)" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + numberSpacing(pageStats.page.previous_period.page_video_complete_views_30s.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="pageStats.page.previous_period.page_video_complete_views_30s.map(v => v.total).reduce((prev, curr) => prev + curr) > 0">+{{ formatPercentageChange((graphData.find(g => g.name == 'video_complete_views_30s').data.reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_complete_views_30s.map(v => v.total).reduce((prev, curr) => prev + curr)) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt="">
              
              <!-- <div v-if="pageStats && !(lastPage.isGroup)" class="main-numbers">
                <i class="fa-solid fa-repeat"></i>
                <h3>{{$t('dash.label.fb.video_view_time')}}</h3>
                <img class="icon imp-ico" src="../../../assets/img/reporting_icons/impression.svg" alt="">
                <p v-if="graphData.find(g => g.name == 'video_view_time') === null">N/A</p>
                <p class="min-size" v-else>{{ humanizeTime(graphData.find(g => g.name == 'video_view_time').data.reduce((prev, curr) => prev + curr) / graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr)) }}</p>
                <div class="compare wait" v-if="activeReportingV2 && !pageStats.page.previous_period && lastPage.network == 'facebook'">
                  <img src="../../../assets/img/status-waiting.gif">
                </div>
                <div class="compare" v-else-if="pageStats.page.previous_period && pageStats.page.previous_period.page_video_view_time && pageStats.page.previous_period.page_video_views">
                  <Tooltip v-if="(graphData.find(g => g.name == 'video_view_time').data.reduce((prev, curr) => prev + curr) / graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr)) < (pageStats.page.previous_period.page_video_view_time.map(v => v.total).reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views.map(v => v.total).reduce((prev, curr) => prev + curr))" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + humanizeTime(pageStats.page.previous_period.page_video_view_time.map(v => v.total).reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_down">
                      <span class="negative">-{{ formatPercentageChange(100 - ((graphData.find(g => g.name == 'video_view_time').data.reduce((prev, curr) => prev + curr) / graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr)) / (pageStats.page.previous_period.page_video_view_time.map(v => v.total).reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views.map(v => v.total).reduce((prev, curr) => prev + curr))) * 100) }}%</span>
                      <i class="material-icons">trending_up</i><i class="fas fa-arrow-right negative" style=" transform: rotate(45deg);"></i>
                      
                  </Tooltip>
                  <Tooltip v-if="(graphData.find(g => g.name == 'video_view_time').data.reduce((prev, curr) => prev + curr) / graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr)) != 0 && (graphData.find(g => g.name == 'video_view_time').data.reduce((prev, curr) => prev + curr) / graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr)) == (pageStats.page.previous_period.page_video_view_time.map(v => v.total).reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views.map(v => v.total).reduce((prev, curr) => prev + curr))" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + humanizeTime(pageStats.page.previous_period.page_video_view_time.map(v => v.total).reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_flat">
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right"></i>
                    
                  </Tooltip>
                  <Tooltip v-if="(graphData.find(g => g.name == 'video_view_time').data.reduce((prev, curr) => prev + curr) / graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr)) > (pageStats.page.previous_period.page_video_view_time.map(v => v.total).reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views.map(v => v.total).reduce((prev, curr) => prev + curr))" :text="$t('dash.reporting.previous_period') + ' (' + $t('dash.reporting.from') + ' ' + formatDate(getPreviousPeriod.start, false) + ' ' + $t('dash.reporting.to') + ' ' + formatDate(getPreviousPeriod.end, false) + ') : ' + humanizeTime(pageStats.page.previous_period.page_video_view_time.map(v => v.total).reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views.map(v => v.total).reduce((prev, curr) => prev + curr))" class="trending_up">
                    <span class="positive" v-if="(pageStats.page.previous_period.page_video_view_time.map(v => v.total).reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views.map(v => v.total).reduce((prev, curr) => prev + curr)) > 0">+{{ formatPercentageChange(((graphData.find(g => g.name == 'video_view_time').data.reduce((prev, curr) => prev + curr) / graphData.find(g => g.name == 'video_views').data.reduce((prev, curr) => prev + curr)) / (pageStats.page.previous_period.page_video_view_time.map(v => v.total).reduce((prev, curr) => prev + curr) / pageStats.page.previous_period.page_video_views.map(v => v.total).reduce((prev, curr) => prev + curr))) * 100 - 100) }}%</span>
                    <i class="material-icons">trending_up</i><i class="fas fa-arrow-right positive" style=" transform: rotate(-45deg);"></i>
                    
                  </Tooltip>
                </div>
              </div>
              <img v-else-if="!(lastPage.isGroup)" src="../../../assets/img/content_loader/reporting_info_numbers.svg" alt=""> -->

            </div>  

            <componentGraph
              class="graph"
              :data="graphData.filter(g => ['video_views','video_views_paid','video_views_organic','video_views_autoplayed','video_views_click_to_play','video_views_unique','video_repeat_views','video_complete_views_30s','video_view_time'].includes(g.name))"
              :state="graphShowedVideos"
              :labels="graphLabels"
              :lang="$i18n.locale"
              :section="'videos'"
              :key="'videos'"
            />
            <div class="graph-choice">
              <Tooltip v-for="(item, idx) in graphNetwork.filter(g => ['video_views','video_views_paid','video_views_organic','video_views_autoplayed','video_views_click_to_play','video_views_unique','video_repeat_views','video_complete_views_30s','video_view_time'].includes(g.name))" :key="`graph-select-impressions-${idx}`" :text="item.description" position="bottom">
                <vs-checkbox class='check' 
                  :color="item.color"
                  :vs-value="`${idx}`"
                  v-model="graphShowedVideos">
                  {{item.text}} 
                </vs-checkbox>
                
              </Tooltip>
            </div>
          </div>
          
          <div class="posts table-wrapper">
            <vs-table :hoverFlat='true'
              class="content-table"
              search
              :data="postList.filter(p => p.type == 'video')"
              max-items="20" pagination
              :noDataText="$t('dash.noDataText')"
            >

              <template slot="header">
                <div>
                  <h3>{{$t('dash.reporting.section.videos-list.title')}}</h3>
                </div>
              </template>

              <template slot="thead">
                <vs-th class="t-id"><Tooltip  :text="$t('dash.reporting.header_id')"><span>  </span>  </Tooltip> </vs-th> 
                <vs-th class="t-date" sortKey="created_time"> 
                  {{capitalize($t('dash.table.title.date'))}}
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-msg" sortKey="message"> 
                  {{capitalize($t('dash.table.title.content'))}} 
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>

                <vs-th class="t-video_view_count" sortKey="video_view_count">
                  <Tooltip  :text="$t('dash.reporting.header_video_view_count')"><span>
                  {{$t('dash.reporting.video_view_count')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-video_view_count_15s" sortKey="video_view_count_15s">
                  <Tooltip  :text="$t('dash.reporting.header_video_view_count_15s')"><span>
                  {{$t('dash.reporting.video_view_count_15s')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-video_view_count_organic" sortKey="video_view_count_organic">
                  <Tooltip  :text="$t('dash.reporting.header_video_view_count_organic')"><span>
                  {{$t('dash.reporting.video_view_count_organic')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-video_view_count_paid" sortKey="video_view_count_paid">
                  <Tooltip  :text="$t('dash.reporting.header_video_view_count_paid')"><span>
                  {{$t('dash.reporting.video_view_count_paid')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-video_view_count_sound_on" sortKey="video_view_count_sound_on">
                  <Tooltip  :text="$t('dash.reporting.header_video_view_count_sound_on')"><span>
                  {{$t('dash.reporting.video_view_count_sound_on')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
                <vs-th class="t-video_view_time" sortKey="video_view_time">
                  <Tooltip  :text="$t('dash.reporting.header_video_view_time')"><span>
                  {{$t('dash.reporting.video_view_time')}}
                  </span>  </Tooltip>
                  <span class="sort-th">
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons up-sort">
                      expand_less
                    </i>
                    <i class="vs-icon notranslate icon-scale th-sort-icon material-icons down-sort">
                      expand_more
                    </i>
                  </span>
                </vs-th>
              </template>

              <template slot-scope="{ data }" v-if="data">
                <vs-tr :key="`data-posts-${indextr}`" v-for="(tr, indextr) in data">
                  <vs-td class="t-id" :data="data[indextr].id">
                    <a @click.prevent="openLink(data[indextr].permalink_url || data[indextr].permalink)">#{{ data[indextr].id }}</a>
                  </vs-td>

                  <vs-td class="t-date" :data="data[indextr].created_time || data[indextr].timestamp">
                    {{ formatDate(data[indextr].created_time || data[indextr].timestamp) }}
                  </vs-td>

                  <vs-td class="t-msg" :data="data[indextr].message">
                    <div class="cell-msg">
                      <p class="only-text" v-if="(!data[indextr].attachment_url || data[indextr].attachment_url === '')">
                        {{
                          data[indextr].message
                            ? textTruncat(data[indextr].message
                                      .replace(/[^\s]{25,}/, '')
                                      .replace(/[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                                      '')
                              , 100)
                            : ''
                        }}
                        </p>
                      <div class="thumb-wrapper" v-if="(data[indextr].attachment_url && data[indextr].attachment_url !== '')">
                        <video v-if="lastPage.network == 'instagram' && ['video', 'VIDEO'].includes(data[indextr].type)" :src="data[indextr].attachment_url"></video>
                        <video v-else-if="lastPage.network == 'instagram' && ['story', 'Story'].includes(data[indextr].type) && data[indextr].attachment_url.includes('.mp4')" :src="data[indextr].attachment_url"></video>
                  
                        <img v-else
                          class="table-img"
                          :src="data[indextr].attachment_url"
                          alt="Image"
                          @error="getMetaOgImage(data[indextr].unshimmed_url, `meta-image-${indextr}`, indextr)"
                          :ref="`meta-image-${indextr}`"
                        />
                      </div>
                      <div class="txt-wrapper" v-if="(data[indextr].attachment_url && data[indextr].attachment_url !== '')">
                        <p v-if="data[indextr].message.replace(/[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/, '')">
                          {{  
                            data[indextr].message
                              ? textTruncat(data[indextr].message
                                        .replace(/[^\s]{25,}/, '')
                                        .replace(/[Hh]ttps?:\s?\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/, '')
                                , 100)
                              : ''
                          }}
                        </p>
                        <p v-else-if="data[indextr].unshimmed_url" :ref="`meta-title-${indextr}`">{{ getMetaOgTitle(data[indextr].unshimmed_url, `meta-title-${indextr}`, indextr) }}</p>
                      </div>
                    </div>
                  </vs-td>

                  <vs-td
                    class="t-video_view_count"
                    :data="data[indextr].video_view_count"
                  >
                    <span>
                      {{ numberSpacing(data[indextr].video_view_count)}}
                    </span>
                  </vs-td>
                  <vs-td
                    class="t-video_view_count_15s"
                    :data="data[indextr].video_view_count_15s"
                  >
                    <span>
                      {{ numberSpacing(data[indextr].video_view_count_15s)}}
                    </span>
                  </vs-td>
                  <vs-td
                    class="t-video_view_count_organic"
                    :data="data[indextr].video_view_count_organic"
                  >
                    <span>
                      {{ numberSpacing(data[indextr].video_view_count_organic)}}
                    </span>
                  </vs-td>
                  <vs-td
                    class="t-video_view_count_paid"
                    :data="data[indextr].video_view_count_paid"
                  >
                    <span>
                      {{ numberSpacing(data[indextr].video_view_count_paid)}}
                    </span>
                  </vs-td>
                  <vs-td
                    class="t-video_view_count_sound_on"
                    :data="data[indextr].video_view_count_sound_on"
                  >
                    <span>
                      {{ numberSpacing(data[indextr].video_view_count_sound_on)}}
                    </span>
                  </vs-td>
                  <vs-td
                    class="t-video_view_time"
                    :data="data[indextr].video_view_time"
                  >
                    <span>
                      {{ numberSpacing(data[indextr].video_view_time)}}
                    </span>
                  </vs-td>
                </vs-tr>
              </template>

            </vs-table>
          </div>
        </div>

        <div class="planning optimal-posts" v-if="pageStats && ((lastPage.network === 'facebook' && !lastPage.isGroup && pageStats.postsPercentLoader == 100 && pageStats.page) || (lastPage.network !== 'facebook' || lastPage.isGroup)) && pageStats.page.optimalTimes && pageStats.page.optimalTimes.optimalTimeSlots &&!(lastPage.isGroup) && postList.length">
          <component-optimal-posts-planning
            :interaction="false"
            :network="this.lastPage.network"
            :optimalTimes="this.pageStats.page.optimalTimes">
          </component-optimal-posts-planning>
        </div>
        <div class="section-graph concurrences" v-if="(pageStats && pageStats.page && pageStats.postsPercentLoader == 100 && pageStats.page.concurrences) && (['facebook', 'instagram', 'linkedin'].includes(lastPage.network) || (lastPage.network === 'tiktok' && checkConciergerie(lastPage))) && !lastPage.isGroup">
          <div class="section-title">{{$t('dash.reporting.section.concurrences.title')}}</div>
          <div class="section-subtitle">{{$t('dash.reporting.section.concurrences.subtitle')}}</div>
          <div class="add-concurrent" v-if="!hideAddConcurrent">
            <vs-input
              @keypress.enter.prevent
              vs-size="large"
              type="text"
              name="mention"
              class="inputx mention"
              icon="+"
              v-bind:placeholder="$t(`dash.reporting.concurrent_name_placeholder${currentPage.network == 'facebook' || (['linkedin', 'instagram', 'tiktok'].includes(currentPage.network) && currentPage.story_config && currentPage.story_config.created) ? '' : '_url_'+currentPage.network}`)"
              v-model="concurrent"
              v-on:focus="showSearchConcurrent()"
              v-on:keyup="searchConcurrent()"
              data-qa="form-bot-add-mention"
              autocomplete="off"
            />
            <div class="mentions-load" v-show="openSearchConcurrent && concurrent && concurrent.length >= 2 && searchConcurrentResult && searchConcurrentResult.length == 0">
              <component-loader :progress="90" :unlimitedProgress="true"></component-loader>
            </div>
            <div class="mentions-close" v-show="openSearchConcurrent && concurrent && concurrent.length >= 2 && searchConcurrentResult && searchConcurrentResult.length" @click="closeSearchConcurrent()">
              {{$t('dash.button.close')}}
            </div>
            <div class="auto-mentions row box" :class="currentPage.network" data-qa="form-bot-select-auto-mentions" v-show="openSearchConcurrent && concurrent && concurrent.length >= 2 && searchConcurrentResult && searchConcurrentResult.length" :key="`search-concurrent`">
              <ul>
                <li v-for="(mention, index) in searchConcurrentResult" :key="`list-concurrent-${index}`">
                  <div @click.prevent="addConcurrent(mention)">
                    <img :alt="mention.name" class="image" :src="mention.image" v-if="mention.image"/>
                    <span class="image" v-else></span>
                    <div class="content">
                      <p class="name">{{ mention.name }}</p>
                      <img alt="verified account" src="../../../assets/img/validated-twitter.png" v-if="currentPage.network == 'twitter'"/>
                      <p class="screen_name id" v-if="currentPage.network == 'facebook'">{{ mention.id }}</p>
                      <p class="screen_name" v-else>@{{ currentPage.network == 'twitter' ? mention.screen_name : (currentPage.network == 'instagram' ? mention.id || mention.name : mention.name) }}</p>
                      <p class="description" v-if="['twitter', 'linkedin'].includes(currentPage.network)">{{ mention.description }}</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>          
          <ul class="concurrents-list" v-if="pageStats.page && pageStats.page.concurrences">
            <li class="head">
              <div class="name">
                {{$t('dash.reporting.section.concurrences.list.head.name')}}
              </div>
              <div class="follower_count sortable" :class="{ active: concurrentSortKey === 'follower_count' }" @click="sortConcurrents('follower_count')">
                {{$t('dash.reporting.section.concurrences.list.head.follower_count')}}
                <span class="sort-indicator">{{ concurrentSortKey === 'follower_count' ? (concurrentSortDir === 'desc' ? '↓' : '↑') : '↕' }}</span>
              </div>
              <div class="follower_variation sortable" :class="{ active: concurrentSortKey === 'follower_variation' }" v-if="currentPage.network == 'tiktok'" @click="sortConcurrents('follower_variation')">
                {{$t('dash.reporting.section.concurrences.list.head.follower_variation')}}
                <span class="sort-indicator">{{ concurrentSortKey === 'follower_variation' ? (concurrentSortDir === 'desc' ? '↓' : '↑') : '↕' }}</span>
              </div>
              <div class="posts_count sortable" :class="{ active: concurrentSortKey === 'posts_count' }" @click="sortConcurrents('posts_count')">
                {{$t('dash.reporting.section.concurrences.list.head.posts_count')}}
                <span class="sort-indicator">{{ concurrentSortKey === 'posts_count' ? (concurrentSortDir === 'desc' ? '↓' : '↑') : '↕' }}</span>
              </div>
              <div class="like_count sortable" :class="{ active: concurrentSortKey === 'like_count' }" v-if="currentPage.network != 'tiktok'" @click="sortConcurrents('like_count')">
                {{$t(`dash.reporting.section.concurrences.list.head.like_count${currentPage.network == 'linkedin' ? '_reactions' : ''}`)}}
                <span class="sort-indicator">{{ concurrentSortKey === 'like_count' ? (concurrentSortDir === 'desc' ? '↓' : '↑') : '↕' }}</span>
              </div>
              <div class="likes_count sortable" :class="{ active: concurrentSortKey === 'likes_count' }" v-if="currentPage.network == 'tiktok'" @click="sortConcurrents('likes_count')">
                {{$t('dash.reporting.section.concurrences.list.head.likes_count')}}
                <span class="sort-indicator">{{ concurrentSortKey === 'likes_count' ? (concurrentSortDir === 'desc' ? '↓' : '↑') : '↕' }}</span>
              </div>
              <div class="shares_count sortable" :class="{ active: concurrentSortKey === 'shares_count' }" v-if="currentPage.network == 'facebook'" @click="sortConcurrents('shares_count')">
                {{$t('dash.reporting.section.concurrences.list.head.shares_count')}}
                <span class="sort-indicator">{{ concurrentSortKey === 'shares_count' ? (concurrentSortDir === 'desc' ? '↓' : '↑') : '↕' }}</span>
              </div>
              <div class="comments_count sortable" :class="{ active: concurrentSortKey === 'comments_count' }" v-if="currentPage.network != 'tiktok'" @click="sortConcurrents('comments_count')">
                {{$t('dash.reporting.section.concurrences.list.head.comments_count')}}
                <span class="sort-indicator">{{ concurrentSortKey === 'comments_count' ? (concurrentSortDir === 'desc' ? '↓' : '↑') : '↕' }}</span>
              </div>
              <div class="reactions_count sortable" :class="{ active: concurrentSortKey === 'reactions_count' }" v-if="currentPage.network == 'facebook'" @click="sortConcurrents('reactions_count')">
                {{$t('dash.reporting.section.concurrences.list.head.reactions_count')}}
                <span class="sort-indicator">{{ concurrentSortKey === 'reactions_count' ? (concurrentSortDir === 'desc' ? '↓' : '↑') : '↕' }}</span>
              </div>
              <div class="engagement sortable" :class="{ active: concurrentSortKey === 'engagement' }" v-if="currentPage.network != 'tiktok'" @click="sortConcurrents('engagement')">
                <Tooltip :text="$t('dash.reporting.concurrent.engagement')">
                  <span>{{$t('dash.reporting.section.concurrences.list.head.engagement')}}</span>

                </Tooltip>
                <span class="sort-indicator">{{ concurrentSortKey === 'engagement' ? (concurrentSortDir === 'desc' ? '↓' : '↑') : '↕' }}</span>
              </div>
            </li>
            <li>
              <div class="name no-action">
                <Tooltip :text="lastPage.name">
                  <img v-if="lastPage.avatar" :src="lastPage.avatar" class="avatar"/>
                  {{lastPage.name}}
                </Tooltip>
              </div>
              <div class="follower_count">
                <Tooltip v-if="currentPage.network == 'facebook' && graphData.find(g => g.name == 'page_follows')" :text="numberSpacing(graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1])">
                  <span>{{ unityArround(graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1]) }}</span>

                </Tooltip>
                <Tooltip v-else-if="['instagram', 'linkedin', 'tiktok'].includes(currentPage.network) && pageStats.page.page_fans" :text="numberSpacing(pageStats.page.page_fans)">
                  <span>{{ unityArround(pageStats.page.page_fans) }}</span>

                </Tooltip>
                <template v-else>
                  N/A
                </template>
              </div>
              <div class="follower_variation" v-if="currentPage.network == 'tiktok'">
                <template v-if="pageStats.page.page_follows && pageStats.page.page_follows.length > 1">
                  <span :class="{ 'positive': pageStats.page.page_follows[pageStats.page.page_follows.length - 1].total - pageStats.page.page_follows[0].total > 0, 'negative': pageStats.page.page_follows[pageStats.page.page_follows.length - 1].total - pageStats.page.page_follows[0].total < 0 }">
                    {{ pageStats.page.page_follows[pageStats.page.page_follows.length - 1].total - pageStats.page.page_follows[0].total > 0 ? '+' : '' }}{{ numberSpacing(pageStats.page.page_follows[pageStats.page.page_follows.length - 1].total - pageStats.page.page_follows[0].total) }}
                  </span>
                </template>
                <template v-else>
                  N/A
                </template>
              </div>
              <div class="posts_count">
                <Tooltip v-if="pageStats.posts && Array.isArray(pageStats.posts) && pageStats.posts.length" :text="numberSpacing(pageStats.posts.length)">
                  <span>{{ unityArround(pageStats.posts.length) }}</span>

                </Tooltip>
                <template v-else>
                  {{ pageStats.posts ? 0 : 'N/A' }}
                </template>
              </div>
              <div class="like_count" v-if="currentPage.network != 'tiktok'">
                <Tooltip v-if="currentPage.network == 'facebook' && pageStats.posts && Array.isArray(pageStats.posts) && pageStats.posts.length" :text="numberSpacing(pageStats.posts.reduce((previous, current) => previous + current.post_reactions[0].value.like, 0))">
                  <span>{{ unityArround(pageStats.posts.reduce((previous, current) => previous + current.post_reactions[0].value.like, 0)) }}</span>

                </Tooltip>
                <Tooltip v-else-if="currentPage.network == 'instagram' && pageStats.posts && Array.isArray(pageStats.posts) && pageStats.posts.length" :text="numberSpacing(pageStats.posts.reduce((previous, current) => previous + (typeof current.like_count == 'number' ? current.like_count : 0), 0))">
                  <span>{{ unityArround(pageStats.posts.reduce((previous, current) => previous + (typeof current.like_count == 'number' ? current.like_count : 0), 0)) }}</span>

                </Tooltip>
                <Tooltip v-else-if="currentPage.network == 'linkedin' && pageStats.posts && Array.isArray(pageStats.posts) && pageStats.posts.length" :text="numberSpacing(pageStats.posts.reduce((previous, current) => previous + current.reactions_count, 0))">
                  <span>{{ unityArround(pageStats.posts.reduce((previous, current) => previous + current.post_reactions[0].sum, 0)) }}</span>

                </Tooltip>
                <template v-else>
                  {{ pageStats.posts ? 0 : 'N/A' }}
                </template>
              </div>
              <div class="likes_count" v-if="currentPage.network == 'tiktok'">
                <Tooltip v-if="pageStats.page.page_likes" :text="numberSpacing(pageStats.page.page_likes)">
                  <span>{{ unityArround(pageStats.page.page_likes) }}</span>

                </Tooltip>
                <template v-else>
                  N/A
                </template>
              </div>
              <div class="shares_count" v-if="currentPage.network == 'facebook'">
                <Tooltip v-if="pageStats.posts && Array.isArray(pageStats.posts) && pageStats.posts.length" :text="numberSpacing(pageStats.posts.reduce((previous, current) => previous + current.shares_count, 0))">
                  <span>{{ unityArround(pageStats.posts.reduce((previous, current) => previous + current.shares_count, 0)) }}</span>

                </Tooltip>
                <template v-else>
                  {{ pageStats.posts ? 0 : 'N/A' }}
                </template>
              </div>
              <div class="comments_count" v-if="currentPage.network != 'tiktok'">
                <Tooltip v-if="pageStats.posts && Array.isArray(pageStats.posts) && pageStats.posts.length" :text="numberSpacing(pageStats.posts.reduce((previous, current) => previous + (typeof current.comments_count == 'number' ? current.comments_count : 0), 0))">
                  <span>{{ unityArround(pageStats.posts.reduce((previous, current) => previous + (typeof current.comments_count == 'number' ? current.comments_count : 0), 0)) }}</span>

                </Tooltip>
                <template v-else>
                  {{ pageStats.posts ? 0 : 'N/A' }}
                </template>
              </div>
              <div class="reactions_count" v-if="currentPage.network == 'facebook'">
                <Tooltip v-if="pageStats.posts && Array.isArray(pageStats.posts) && pageStats.posts.length" :text="numberSpacing(pageStats.posts.reduce((previous, current) => previous + current.post_reactions_sum, 0))">
                  <span>{{ unityArround(pageStats.posts.reduce((previous, current) => previous + current.post_reactions_sum, 0)) }}</span>

                </Tooltip>
                <template v-else>
                  {{ pageStats.posts ? 0 : 'N/A' }}
                </template>
              </div>
              <div class="engagement" v-if="currentPage.network == 'facebook'">
                {{ pageStats.posts && Array.isArray(pageStats.posts) && pageStats.posts.length ? unityArround((1000 * pageStats.posts.reduce((previous, current) => previous + current.shares_count + current.comments_count + current.post_reactions_sum, 0) / pageStats.posts.length / graphData.find(g => g.name == 'page_follows').data[graphData.find(g => g.name == 'page_follows').data.length - 1]).toFixed(1)) : 'N/A'}}
              </div>
              <div class="engagement" v-else-if="currentPage.network != 'tiktok'">
                {{ pageStats.posts && Array.isArray(pageStats.posts) && pageStats.posts.length ? unityArround((1000 * pageStats.posts.reduce((previous, current) => previous + (typeof current.comments_count == 'number' ? current.comments_count : 0) + (currentPage.network == 'instagram' ? (typeof current.like_count == 'number' ? current.like_count : 0) : current.post_reactions[0].sum), 0) / pageStats.posts.length / pageStats.page.page_fans).toFixed(1)) : 'N/A'}}
              </div>
            </li>
            <li v-for="(concurrentResult, index) in sortedConcurrences" :key="`concurrent-${index}${hideAddConcurrent ? '-load' : ''}`" >
              <!-- <template v-if="JSON.parse(localStorage.reportingConcurrences).find(c => c.id == currentPage.id).data.find(c => [['linkedin', 'facebook'].includes(currentPage.network) ? c.id.toString() : null, c.name].includes(concurrentResult.concurrent.toString()))"> -->
              <template v-if="JSON.parse(localStorage.reportingConcurrences).find(c => c.id == currentPage.id).data.find(c => [c.id ? c.id.toString() : null, c.name].includes(concurrentResult.concurrent.toString()))">
                <div class="name">
                  <!-- <Tooltip :text="JSON.parse(localStorage.reportingConcurrences).find(c => c.id == currentPage.id).data.find(c => [['linkedin', 'facebook'].includes(currentPage.network) ? c.id.toString() : null, c.name].includes(concurrentResult.concurrent.toString())).name"> -->
                  <Tooltip :text="JSON.parse(localStorage.reportingConcurrences).find(c => c.id == currentPage.id).data.find(c => [c.id ? c.id.toString() : null, c.name].includes(concurrentResult.concurrent.toString())).name">
                    <img v-if="concurrentResult.pagePicture && concurrentResult.pagePicture.data && concurrentResult.pagePicture.data.url" :src="concurrentResult.pagePicture.data.url" class="avatar"/>
                    <!-- {{JSON.parse(localStorage.reportingConcurrences).find(c => c.id == currentPage.id).data.find(c => [['linkedin', 'facebook'].includes(currentPage.network) ? c.id.toString() : null, c.name].includes(concurrentResult.concurrent.toString())).name}} -->
                    {{JSON.parse(localStorage.reportingConcurrences).find(c => c.id == currentPage.id).data.find(c => [c.id ? c.id.toString() : null, c.name].includes(concurrentResult.concurrent.toString())).name}}
                  </Tooltip>
                  <img @click="refreshConcurrent(concurrentResult.concurrent)" src="../../../assets/img/icon_refresh_reload.svg" class="refresh" v-if="!hideAddConcurrent">
                  <img @click="removeConcurrent(concurrentResult.concurrent)" src="../../../assets/img/status-deleted.png" class="remove">
                  <Tooltip v-if="currentPage.network === 'tiktok' && (!concurrentResult.concurrentHistory || concurrentResult.concurrentHistory.length === 0)" :text="$t('dash.reporting.concurrent.live_data_warning')">
                    <span class="live-data-warning">⚠️</span>
                  </Tooltip>
                </div>
                <div class="load-concurrent" v-if="concurrentResult.load">
                  <component-loader :progress="90" :unlimitedProgress="true"></component-loader>
                </div>
                <div class="follower_count">
                  <Tooltip v-if="concurrentResult.pageFollowers" :text="numberSpacing(concurrentResult.pageFollowers)">
                    <span>{{ unityArround(concurrentResult.pageFollowers) }}</span>

                  </Tooltip>
                  <template v-else>
                    N/A
                  </template>
                </div>
                <div class="follower_variation" v-if="currentPage.network == 'tiktok'">
                  <template v-if="concurrentResult.pageFollowersVariation !== null && concurrentResult.pageFollowersVariation !== undefined">
                    <span :class="{ 'positive': concurrentResult.pageFollowersVariation > 0, 'negative': concurrentResult.pageFollowersVariation < 0 }">
                      {{ concurrentResult.pageFollowersVariation > 0 ? '+' : '' }}{{ numberSpacing(concurrentResult.pageFollowersVariation) }}
                    </span>
                  </template>
                  <template v-else>
                    N/A
                  </template>
                </div>
                <div class="posts_count" v-if="currentPage.network != 'tiktok'">
                  <Tooltip v-if="concurrentResult.posts && Array.isArray(concurrentResult.posts) && concurrentResult.posts.length" :text="numberSpacing(concurrentResult.posts.length)">
                    <span>{{ unityArround(concurrentResult.posts.length) }}</span>

                  </Tooltip>
                  <template v-else>
                    {{ concurrentResult.posts ? 0 : 'N/A' }}
                  </template>
                </div>
                <div class="posts_count" v-if="currentPage.network == 'tiktok'">
                  <Tooltip v-if="concurrentResult.pagePostCount" :text="numberSpacing(concurrentResult.pagePostCount)">
                    <span>{{ unityArround(concurrentResult.pagePostCount) }}</span>

                  </Tooltip>
                  <template v-else>
                    N/A
                  </template>
                </div>
                <div class="like_count" v-if="currentPage.network != 'tiktok'">
                  <Tooltip v-if="currentPage.network == 'facebook' && concurrentResult.posts && Array.isArray(concurrentResult.posts) && concurrentResult.posts.length" :text="numberSpacing(concurrentResult.posts.reduce((previous, current) => previous + (current && current.likes ? current.likes.summary.total_count : 0), 0))">
                    <span>{{ unityArround(concurrentResult.posts.reduce((previous, current) => previous + (current && current.likes ? current.likes.summary.total_count : 0), 0)) }}</span>

                  </Tooltip>
                  <Tooltip v-else-if="currentPage.network == 'instagram' && concurrentResult.posts && Array.isArray(concurrentResult.posts) && concurrentResult.posts.length" :text="numberSpacing(concurrentResult.posts.reduce((previous, current) => previous + current.like_count, 0))">
                    <span>{{ unityArround(concurrentResult.posts.reduce((previous, current) => previous + (current.like_count || 0), 0)) }}</span>

                  </Tooltip>
                  <Tooltip v-else-if="currentPage.network == 'linkedin' && concurrentResult.posts && Array.isArray(concurrentResult.posts) && concurrentResult.posts.length" :text="numberSpacing(concurrentResult.posts.reduce((previous, current) => previous + current.reactions_count, 0))">
                    <span>{{ unityArround(concurrentResult.posts.reduce((previous, current) => previous + current.reactions_count, 0)) }}</span>

                  </Tooltip>
                  <template v-else>
                    {{ concurrentResult.posts ? 0 : 'N/A' }}
                  </template>
                </div>
                <div class="likes_count" v-if="currentPage.network == 'tiktok'">
                  <Tooltip v-if="concurrentResult.pageLikes" :text="numberSpacing(concurrentResult.pageLikes)">
                    <span>{{ unityArround(concurrentResult.pageLikes) }}</span>

                  </Tooltip>
                  <template v-else>
                    N/A
                  </template>
                </div>
                <div class="shares_count" v-if="currentPage.network == 'facebook'">
                  <Tooltip v-if="concurrentResult.posts && Array.isArray(concurrentResult.posts) && concurrentResult.posts.length" :text="numberSpacing(concurrentResult.posts.reduce((previous, current) => previous + (current && current.shares ? current.shares.count : 0), 0))">
                    <span>{{ unityArround(concurrentResult.posts.reduce((previous, current) => previous + (current && current.shares ? current.shares.count : 0), 0)) }}</span>

                  </Tooltip>
                  <template v-else>
                    {{ concurrentResult.posts ? 0 : 'N/A' }}
                  </template>
                </div>
                <div class="comments_count" v-if="currentPage.network != 'tiktok'">
                  <Tooltip v-if="currentPage.network == 'facebook' && concurrentResult.posts && Array.isArray(concurrentResult.posts) && concurrentResult.posts.length" :text="numberSpacing(concurrentResult.posts.reduce((previous, current) => previous + current.comments.summary.total_count, 0))">
                    <span>{{ unityArround(concurrentResult.posts.reduce((previous, current) => previous + current.comments.summary.total_count, 0)) }}</span>

                  </Tooltip>
                  <Tooltip v-else-if="['instagram', 'linkedin'].includes(currentPage.network) && concurrentResult.posts && Array.isArray(concurrentResult.posts) && concurrentResult.posts.length" :text="numberSpacing(concurrentResult.posts.reduce((previous, current) => previous + current.comments_count, 0))">
                    <span>{{ unityArround(concurrentResult.posts.reduce((previous, current) => previous + current.comments_count, 0)) }}</span>

                  </Tooltip>
                  <template v-else>
                    {{ concurrentResult.posts ? 0 : 'N/A' }}
                  </template>
                </div>
                <div class="reactions_count" v-if="currentPage.network == 'facebook'">
                  <Tooltip v-if="concurrentResult.posts && Array.isArray(concurrentResult.posts) && concurrentResult.posts.length" :text="numberSpacing(concurrentResult.posts.reduce((previous, current) => previous + current.reactions.summary.total_count, 0))">
                    <span>{{ unityArround(concurrentResult.posts.reduce((previous, current) => previous + current.reactions.summary.total_count, 0)) }}</span>

                  </Tooltip>
                  <template v-else>
                    {{ concurrentResult.posts ? 0 : 'N/A' }}
                  </template>
                </div>
                <div class="engagement" v-if="currentPage.network == 'facebook'">
                  {{ concurrentResult.posts && Array.isArray(concurrentResult.posts) && concurrentResult.posts.length ? unityArround((1000 * concurrentResult.posts.reduce((previous, current) => previous + (current.shares ? current.shares.count : 0) + current.comments.summary.total_count + current.reactions.summary.total_count, 0) / concurrentResult.posts.length / concurrentResult.pageFollowers).toFixed(1)) : (concurrentResult.posts ? 0 : 'N/A')}}
                </div>
                <div class="engagement" v-else-if="currentPage.network != 'tiktok'">
                  {{ concurrentResult.posts && Array.isArray(concurrentResult.posts) && concurrentResult.posts.length ? unityArround((1000 * concurrentResult.posts.reduce((previous, current) => previous + current.comments_count + (currentPage.network == 'instagram' ? current.like_count || 0 : current.reactions_count), 0) / concurrentResult.posts.length / concurrentResult.pageFollowers).toFixed(1)) : (concurrentResult.posts ? 0 : 'N/A')}}
                </div>
              </template>
            </li>
          </ul>
        </div>

        <!-- <div class="progressive-load" v-if="showProgressiveLoad && (!(pageStats && pageStats.postsPercentLoader >=0 && pageStats.postsPercentLoader <=100) || (pageStats.postsPercentLoader == 100 && this.hideAddConcurrent))"> -->
        <div class="progressive-load" v-if="showProgressiveLoad && !(pageStats && pageStats.postsPercentLoader >=0 && pageStats.postsPercentLoader <=100)">
          <component-loader :progress="90" :unlimitedProgress="true"></component-loader>
        </div>
    </div>
    <PrintPdf v-else :graphData="graphData" :pageStats="pageStats" :currentPage="currentPage" :getPreviousPeriod="getPreviousPeriod" :graphLabels="graphLabels" :dateStart="dateStart.getTime()" :dateEnd="dateEnd.getTime()"></PrintPdf>
  </div>
</template>

<script>
import store from './../../../store/index.js'
import moment from 'moment'
import Pages from '../../mixins/Pages'
import User from '../../mixins/User'
import Popup from '../../../utils/Popup'
import Posts from '../../mixins/Posts'
import Bots from '../../mixins/Bots'
import Groups from '../../mixins/Groups'
import Common from '../../mixins/Common'
import Notif from '../../mixins/Notif'
import Upgradable from '../../mixins/Upgradable'
import componentGraph from '../Graph'
import componentDatepicker from '../Datepicker'
import RadialProgressBar from 'vue-radial-progress'
import componentOptimalPostsPlanning from '../OptimalPostsPlanning.vue'
import PageImageAvatar from './../PageImageAvatar.vue'
import componentLoader from './../overlay/Loader.vue'
import ClickOutside from 'vue-click-outside'
import imgDefault from '../../../assets/img/no-picture.png'
import MapChart from 'vue-chart-map'
import pdf from 'pdfvuer'

import Queuer from '../../../utils/Queuer'
import Tooltip from './../tooltip/tooltipInit.vue'
import PrintPdf from '../reporting/PrintPdf.vue'

export default {
  name: 'reporting',

  mixins: [Pages, User, Posts, Groups, Common, Bots, Notif, Upgradable],

  directives: {
    ClickOutside
  },

  components: { 
    componentGraph, 
    componentDatepicker, 
    RadialProgressBar,
    componentOptimalPostsPlanning,
    PageImageAvatar,
    componentLoader,
    MapChart,
    Tooltip,
    PrintPdf,
    pdf
  },

  data() {
    return {
      bots: null,
      selectedTab: 0,
      pages: [],
      dateStart: moment().subtract(3, 'day').startOf('day').toDate(), //il y a 3 jours à la meme heure
      dateEnd: moment().toDate(), // maintenant
      lastSearch: {},
      pageStats: null,
      graphData: [
        {
          data: [0, 0, 0, 0],
          type: 'bar',
          color: '#E4BAF5',
          label: this.capitalize(this.$t('dash.posts.title')),
          labelY: this.capitalize(this.$t('dash.posts.title')),
          name: 'posts'
        },
        {
          data: [0, 0, 0, 0],
          color: '#B20564',
          label: this.$t('dash.reporting.clic'),
          labelY: this.$t('dash.reporting.clic'),
          name: 'clics'
        }
      ],
      graphLabels: [],
      graphShowed: ['0', '1', '2'],
      graphShowedAudience: ['0', '1', '2'],
      graphShowedProfil: ['0', '1', '2'],
      graphShowedImpressions: ['0', '1', '2'],
      graphShowedVideos: ['0', '1', '2'],
      localStorage,
      pageFilter: "",
      progress: 0,
      progressFunction: null,
      unlimitedProgress: false,
      lastPage: null,
      selectedTime: 0,
      refresh: {
        last: null,
        enabled: false,
        frequency: 0,
        intervalObj: null,
        allowed: [
          0,
          30, // seconds
          60,
          120,
          240,
          300,
        ],
      },
      select1: 'csv',
      formats: [
        {text: 'Comma-seperated values (.csv)', value: 'csv'},
        // {text: 'Excel (.xls)', value: 'xls'},
        // {text: 'OpenOffice (.ods)', value: 'ods'},
      ],
      value1:'',
      value2:'',
      popupActivo2:false, 
      popupActivo3:false,
      boards: null,
      boardSelected: null,
      optimalTimes:{},

      selectedPages: {},
      groups: null,
      // advancedTabs: true,

      showLoader: false,
      showProgressiveLoad: false,
      openSearchConcurrent: false,
      concurrent: '',
      searchConcurrentResult: [],
      hideAddConcurrent: true,

      concurrentSortKey: null,
      concurrentSortDir: 'desc',

      sizeHorizontalGraph: 300,

      popupUrlExportApi: false,
      urlExportApi: null,
      updateCountDayLoader: null,
      updateTotalDayLoader: null,
      updateDayLoader: null,

      activeReportingV2: true,
      errorFormatDateStart: false,
      errorFormatDateEnd: false,
      hideToPdf: false
    }
  },

  props: {
    tabsIsMinimize: Boolean
  },

  computed: {

    sortedConcurrences() {
      if (!this.pageStats.page?.concurrences || !this.concurrentSortKey) {
        return this.pageStats.page?.concurrences || []
      }
      const network = this.currentPage.network
      const getValue = (item) => {
        const key = this.concurrentSortKey
        if (key === 'follower_count') {
          return item.pageFollowers || 0
        } else if (key === 'follower_variation') {
          return item.pageFollowersVariation != null ? item.pageFollowersVariation : 0
        } else if (key === 'posts_count') {
          return network === 'tiktok' ? (item.pagePostCount || 0) : (item.posts && item.posts.length || 0)
        } else if (key === 'like_count') {
          if (!item.posts || !item.posts.length) return 0
          if (network === 'facebook') return item.posts.reduce((s, p) => s + (p.likes && p.likes.summary ? p.likes.summary.total_count : 0), 0)
          if (network === 'instagram') return item.posts.reduce((s, p) => s + (p.like_count || 0), 0)
          if (network === 'linkedin') return item.posts.reduce((s, p) => s + (p.reactions_count || 0), 0)
          return 0
        } else if (key === 'likes_count') {
          return item.pageLikes || 0
        } else if (key === 'shares_count') {
          return item.posts ? item.posts.reduce((s, p) => s + (p.shares ? p.shares.count : 0), 0) : 0
        } else if (key === 'comments_count') {
          if (!item.posts || !item.posts.length) return 0
          if (network === 'facebook') return item.posts.reduce((s, p) => s + (p.comments && p.comments.summary ? p.comments.summary.total_count : 0), 0)
          return item.posts.reduce((s, p) => s + (p.comments_count || 0), 0)
        } else if (key === 'reactions_count') {
          return item.posts ? item.posts.reduce((s, p) => s + (p.reactions && p.reactions.summary ? p.reactions.summary.total_count : 0), 0) : 0
        } else if (key === 'engagement') {
          if (!item.posts || !item.posts.length || !item.pageFollowers) return 0
          if (network === 'facebook') {
            return 1000 * item.posts.reduce((s, p) => s + (p.shares ? p.shares.count : 0) + (p.comments && p.comments.summary ? p.comments.summary.total_count : 0) + (p.reactions && p.reactions.summary ? p.reactions.summary.total_count : 0), 0) / item.posts.length / item.pageFollowers
          }
          return 1000 * item.posts.reduce((s, p) => s + (p.comments_count || 0) + (network === 'instagram' ? (p.like_count || 0) : (p.reactions_count || 0)), 0) / item.posts.length / item.pageFollowers
        }
        return 0
      }
      return [...this.pageStats.page.concurrences].sort((a, b) => {
        return this.concurrentSortDir === 'desc' ? getValue(b) - getValue(a) : getValue(a) - getValue(b)
      })
    },

    notInOverview() {
      return ['fans_evol', 'fans_adds', 'fans_paids_adds', 'fans_removes', 
                'page_follows', 'page_daily_follows', 'page_daily_unfollows',
                'impressions','impressions_paid','impressions_organic','impressions_viral', 
                'fans_country', 'fans_locale', 'fans_city', 
                'fans_gender_age', 'fans_male_age', 'fans_female_age', 'fans_undifined_age', 'fans_male', 'fans_female', 'fans_undifined', 'page_post_engagements', 'fans_by_gender',
                'page_views', 'impressions_reach',
                'video_views','video_views_paid','video_views_organic','video_views_autoplayed','video_views_click_to_play','video_views_unique','video_repeat_views','video_complete_views_30s','video_view_time',
                // insta
                'impressions_graph','reach_graph','follower_count_graph',
                'fans_gender', 'fans_age',
                'email_contacts_graph','phone_call_clicks_graph','text_message_clicks_graph', 'get_directions_clicks_graph', 'website_clicks_graph', 'profile_views_graph',
                'typePosts_graph', 'typePosts_engagement_graph', 'dayPosts_graph', 'dayPosts_engagement_graph']
    },

    linkedinOverview() {
      return ['posts', 'shareClickCount', 'shareCommentCount', 'shareLikeCount', 'shareShareCount', 'shareEngagement', 'shareImpressionCount', 'shareUniqueImpressionCount']
    },

    activeReporting(){
      const user = JSON.parse(localStorage.user)
      const force = localStorage.forceReporting ? JSON.parse(localStorage.forceReporting) : false
      return this.checkLock('reporting') || user.email.includes("@mashup-web.com") || this.activeInstagramStories() || force == true
    },

    activeInstagramStories() {
        const accounts = [
            '63fc164e-60da-41a7-9619-0c5fe6561239', //next-plz
            'b0291610-4743-4420-91ee-ea5699647106', //motoblouz
            'a8276ad6-bfe0-4866-a5b0-9fbf14003b27', //objectifgard
            '1863bfe3-f179-49a5-8baa-b1edb7e3282d', //doorinsider
            '9b76ba80-38e5-4b8f-9705-6aaf5259b946', //iadfrance
            '36522076-7ed1-4964-8323-1fd8d773012f', //agenceqg
            '7f0e5b02-a627-432f-89eb-83317b03e478', //santeclair.fr
            '90e789fa-7377-434c-b719-132aa8bcd1d2',  //keepeo.fr
            'cbdec673-84ab-401b-8882-0a72fa29b510',  //archi-tech.digital
            '6a1edfc6-eed2-4945-a48b-5be437a5e955',  //uncertainnicolas
            '411af69b-6839-421f-87d3-2cac55a5cbb3', //auto123
            '485a2ce9-b925-4962-a7eb-3abefebfd134', //komeocreation
        ]

        const user = JSON.parse(localStorage.user)
        return accounts.includes(user.account) || this.checkLock('instagram_credentials') || user.email.includes("@mashup-web.com")
    },

    getPreviousPeriod() {
      if(this.dateStart && this.dateEnd) {
        let daysBetween = Math.ceil((parseInt(moment(this.dateEnd).unix()) - parseInt(moment(this.dateStart).unix())) / 3600 / 24)
        let dateStartPreviousPeriod = moment(this.dateStart).subtract(daysBetween, 'days').format('DD/MM/YYYY')
        let dateEndPreviousPeriod = moment(this.dateStart).subtract(1, 'days').format('DD/MM/YYYY')

        const monthDiff = (d1, d2) => {
          let months;
          months = (d2.getFullYear() - d1.getFullYear()) * 12;
          months -= d1.getMonth();
          months += d2.getMonth();
          return months <= 0 ? 1 : months + 1;
        }
        let startDate = new Date(this.dateStart)
        let endDate = new Date(this.dateEnd)
        let lastDayOfMonth = new Date(endDate.getFullYear(), endDate.getMonth()+1, 0)
        console.log('lastDayOfMonth', lastDayOfMonth)
        if(startDate.getDate() == 1 && moment(lastDayOfMonth).format('DD/MM/YYYY') == moment(this.dateEnd).format('DD/MM/YYYY')){
          let monthCountDiff = monthDiff(startDate, endDate)
          dateStartPreviousPeriod = moment(this.dateStart).subtract(monthCountDiff, 'months').format('DD/MM/YYYY')
          console.log('dateStartPreviousPeriod', dateStartPreviousPeriod)
        }

        console.log('getPreviousPeriod', {start:dateStartPreviousPeriod, end:dateEndPreviousPeriod})
        return {start:dateStartPreviousPeriod, end:dateEndPreviousPeriod}
      }
      console.log('getPreviousPeriod', {start: null, end: null})
      return {start: null, end: null} 
    },

    linkPage() {
      switch (this.lastPage.network) {
        case 'facebook': return `https://www.facebook.com/${this.lastPage.network_id}`;
        case 'twitter': return `https://twitter.com/${this.lastPage.name}`;
        case 'instagram': return `https://www.instagram.com/${this.lastPage.name}`;
        case 'linkedin': return `https://www.linkedin.com/company/${this.lastPage.network_id}/posts/?feedView=all/`;
        case 'tiktok': return `https://www.tiktok.com/@${this.lastPage.name}`;
        default: return '';
      }
    },

    graphNetwork() {
      let lines = [];
      if(!this.lastPage.isGroup) {
        lines.push({
          text: this.$t('dash.reporting.impression'),
          field: 'impression_posts_graph',
          color: '#2052EB',
          description: this.$t('dash.reporting.graph.choice.tooltip.impression'),
          name: 'impression_posts_graph'
        })
      }
      if(['twitter', 'linkedin', 'pinterest'].includes(this.lastPage.network)) {
        lines.push({
          text: this.$t('dash.reporting.clic'),
          field: 'link_clicks_graph',
          color: '#B20564',
          description: this.$t('dash.reporting.graph.choice.tooltip.clics'),
          name: 'clics'
        })
      }
      if (this.lastPage.network === 'facebook') {

        lines.push({
          text: this.$t('dash.reporting.clic'),
          field: 'link_clicks_graph',
          color: '#B20564',
          description: this.$t('dash.reporting.graph.choice.tooltip.link_clicks.fb'),
          name: 'clics'
        })
        lines.push({
          text: this.$t('dash.label.fb.page_views'),
          field: 'page_views_total',
          color: '#B20564',
          description: this.$t('dash.reporting.graph.choice.tooltip.page_views.fb'),
          name: 'page_views'
        })
        lines.push({
          text: this.$t('dash.label.fb.impressions_reach'),
          // field: 'page_impressions_unique',
          field: 'page_impressions',
          color: '#6200ff',
          description: this.$t('dash.reporting.graph.choice.tooltip.impressions_reach.fb'),
          name: 'impressions_reach'
        })
        lines.push({
          text: this.$t('dash.label.fb.impressions'),
          field: 'page_impressions',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.impressions.fb'),
          name: 'impressions'
        })
        lines.push({
          text: this.$t('dash.label.fb.impressions_paid'),
          field: 'page_impressions_paid',
          color: '#ebc849',
          description: this.$t('dash.reporting.graph.choice.tooltip.impressions_paid.fb'),
          name: 'impressions_paid'
        })
        lines.push({
          text: this.$t('dash.label.fb.impressions_organic'),
          field: 'page_impressions_organic_v2',
          color: '#4955eb',
          description: this.$t('dash.reporting.graph.choice.tooltip.impressions_organic.fb'),
          name: 'impressions_organic'
        })
        lines.push({
          text: this.$t('dash.label.fb.impressions_viral'),
          field: 'page_impressions_viral',
          color: '#49EB96',
          description: this.$t('dash.reporting.graph.choice.tooltip.impressions_viral.fb'),
          name: 'impressions_viral'
        })
        lines.push({
          text: this.$t('dash.label.fb.post_engagements'),
          field: 'page_post_engagements',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.post_engagements.fb'),
          name: 'post_engagements'
        })
        lines.push({
          text: this.lastPage.network === 'facebook' ? this.$t('dash.label.fb.page_follows') : this.$t('dash.label.fb.evolution_fans'),
          field: 'dailyPageFansEvol_graph',
          color: '#6a1f4c',
          description: this.lastPage.network === 'facebook' ? this.$t('dash.reporting.graph.choice.tooltip.page_follows.fb') : this.$t('dash.reporting.graph.choice.tooltip.fans_evol.fb'),
          name: 'fans_evol'
        })
        lines.push({
          text: this.lastPage.network === 'facebook' ? this.$t('dash.label.fb.page_daily_follows') : this.$t('dash.label.fb.adds_fans'),
          field: 'page_fan_adds_unique',
          color: '#49EB96',
          description: this.lastPage.network === 'facebook' ? this.$t('dash.reporting.graph.choice.tooltip.page_daily_follows.fb') : this.$t('dash.reporting.graph.choice.tooltip.fans_adds.fb'),
          name: 'fans_adds'
        })
        lines.push({
          text: this.lastPage.network === 'facebook' ? this.$t('dash.label.fb.page_daily_unfollows') : this.$t('dash.label.fb.fans_removes'),
          field: 'page_fan_removes_unique',
          color: '#df2b2b',
          description: this.lastPage.network === 'facebook' ? this.$t('dash.reporting.graph.choice.tooltip.page_daily_unfollows.fb') : this.$t('dash.reporting.graph.choice.tooltip.fans_removes.fb'),
          name: 'fans_removes'
        })
        lines.push({
          text: this.$t('dash.label.fb.paids_adds_fans'),
          field: 'page_fan_paids_adds_unique',
          color: '#ebc849',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_paids_adds.fb'),
          name: 'fans_paids_adds'
        })
        lines.push({
          text: this.$t('dash.label.fb.page_follows'),
          field: 'page_follows',
          color: '#6200ff',
          description: this.$t('dash.reporting.graph.choice.tooltip.page_follows.fb'),
          name: 'page_follows'
        })
        lines.push({
          text: this.$t('dash.label.fb.page_daily_follows'),
          field: 'page_daily_follows_unique',
          color: '#ecb8f5',
          description: this.$t('dash.reporting.graph.choice.tooltip.page_daily_follows.fb'),
          name: 'page_daily_follows'
        })
        lines.push({
          text: this.$t('dash.label.fb.page_daily_unfollows'),
          field: 'page_daily_unfollows_unique',
          color: 'rgb(245 184 193)',
          description: this.$t('dash.reporting.graph.choice.tooltip.page_daily_unfollows.fb'),
          name: 'page_daily_unfollows'
        })
        lines.push({
          text: this.$t('dash.label.fb.locale_fans'),
          field: 'page_follows_locale',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_locale.fb'),
          name: 'fans_locale'
        })
        lines.push({
          text: this.$t('dash.label.fb.city_fans'),
          field: 'page_follows_city',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_city.fb'),
          name: 'fans_city'
        })
        lines.push({
          text: this.$t('dash.label.fb.country_fans'),
          field: 'page_follows_country_percent',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_country.fb'),
          name: 'fans_country'
        })
        lines.push({
          text: this.$t('dash.label.fb.gender_age_fans'),
          field: 'page_follows_gender_age',
          color: '#6a1f4c',
          description: "Répartition par genre/age",
          name: 'fans_gender_age'
        })
        lines.push({
          text: this.$t('dash.label.fb.male_age_fans'),
          field: 'page_follows_male_age',
          color: '#4c34e5',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_male_age.fb'),
          name: 'fans_male_age'
        })
        lines.push({
          text: this.$t('dash.label.fb.female_age_fans'),
          field: 'page_follows_female_age',
          color: '#e53481',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_female_age.fb'),
          name: 'fans_female_age'
        })
        lines.push({
          text: this.$t('dash.label.fb.undifined_age_fans'),
          field: 'page_follows_undifined_age',
          color: '#df34e5',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_undifined_age.fb'),
          name: 'fans_undifined_age'
        })
        lines.push({
          text: this.$t('dash.label.fb.gender_fans'),
          field: 'page_follows_by_gender',
          color: ['#4c34e5', '#e53481', '#df34e5'],
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_by_gender.fb'),
          name: 'fans_by_gender'
        })
        lines.push({
          text: this.$t('dash.label.fb.video_views'),
          field: 'page_video_views',
          color: '#6a1f4c',          
          description: this.$t('dash.reporting.graph.choice.tooltip.video_views.fb'),
          name: 'video_views'
        })
        lines.push({
          text: this.$t('dash.label.fb.video_views_paid'),
          field: 'page_video_views_paid',
          color: '#ebc849',
          description: this.$t('dash.reporting.graph.choice.tooltip.video_views_paid.fb'),
          name: 'video_views_paid'
        })
        lines.push({
          text: this.$t('dash.label.fb.video_views_organic'),
          field: 'page_video_views_organic',
          color: '#4955eb',
          description: this.$t('dash.reporting.graph.choice.tooltip.video_views_organic.fb'),
          name: 'video_views_organic'
        })
        lines.push({
          text: this.$t('dash.label.fb.video_views_unique'),
          field: 'page_video_views_unique',
          color: '#B20564',
          description: this.$t('dash.reporting.graph.choice.tooltip.video_views_unique.fb'),
          name: 'video_views_unique'
        })
        lines.push({
          text: this.$t('dash.label.fb.video_views_autoplayed'),
          field: 'page_video_views_autoplayed',
          color: '#4c34e5',
          description: this.$t('dash.reporting.graph.choice.tooltip.video_views_autoplayed.fb'),
          name: 'video_views_autoplayed'
        })
        lines.push({
          text: this.$t('dash.label.fb.video_views_click_to_play'),
          field: 'page_video_views_click_to_play',
          color: '#e53481',
          description: this.$t('dash.reporting.graph.choice.tooltip.video_views_click_to_play.fb'),
          name: 'video_views_click_to_play'
        })
        lines.push({
          text: this.$t('dash.label.fb.video_repeat_views'),
          field: 'page_video_repeat_views',
          color: '#49EB96',
          description: this.$t('dash.reporting.graph.choice.tooltip.video_repeat_views.fb'),
          name: 'video_repeat_views'
        })
        lines.push({
          text: this.$t('dash.label.fb.video_complete_views_30s'),
          field: 'page_video_complete_views_30s',
          color: '#6200ff',
          description: this.$t('dash.reporting.graph.choice.tooltip.video_complete_views_30s.fb'),
          name: 'video_complete_views_30s'
        })
        // lines.push({
        //   text: this.$t('dash.label.fb.video_view_time'),
        //   field: 'page_video_view_time',
        //   color: '#df2b2b',
        //   description: this.$t('dash.reporting.graph.choice.tooltip.video_view_time.fb'),
        //   name: 'video_view_time'
        // })
      }
      if(this.lastPage.network === 'instagram') {
        //audience
        lines.push({
          text: this.$t('dash.reporting.impressions_graph'),
          field: 'daily_impressions_graph',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.impressions_graph.insta'),
          name: 'impressions_graph'
        })
        lines.push({
          text: this.$t('dash.reporting.reach_graph'),
          field: 'daily_reach_graph',
          color: '#B20564',
          description: this.$t('dash.reporting.graph.choice.tooltip.reach_graph.insta'),
          name: 'reach_graph'
        })
        lines.push({
          text: this.$t('dash.reporting.follower_count_graph'),
          field: 'daily_follower_count_graph',
          color: '#8aaaff',
          description: this.$t('dash.reporting.graph.choice.tooltip.follower_count_graph.insta'),
          name: 'follower_count_graph'
        })
        //profil
        // lines.push({
        //   text: this.$t('dash.reporting.email_contacts_graph'),
        //   field: 'daily_email_contacts_graph',
        //   color: '#6a1f4c',
        //   description: this.$t('dash.reporting.graph.choice.tooltip.email_contacts_graph.insta'),
        //   name: 'email_contacts_graph'
        // })
        // lines.push({
        //   text: this.$t('dash.reporting.phone_call_clicks_graph'),
        //   field: 'daily_phone_call_clicks_graph',
        //   color: '#ebc849',
        //   description: this.$t('dash.reporting.graph.choice.tooltip.phone_call_clicks_graph.insta'),
        //   name: 'phone_call_clicks_graph'
        // })
        // lines.push({
        //   text: this.$t('dash.reporting.text_message_clicks_graph'),
        //   field: 'daily_text_message_clicks_graph',
        //   color: '#4955eb',
        //   description: this.$t('dash.reporting.graph.choice.tooltip.text_message_clicks_graph.insta'),
        //   name: 'text_message_clicks_graph'
        // })
        // lines.push({
        //   text: this.$t('dash.reporting.get_directions_clicks_graph'),
        //   field: 'daily_get_directions_clicks_graph',
        //   color: '#B20564',
        //   description: this.$t('dash.reporting.graph.choice.tooltip.get_directions_clicks_graph.insta'),
        //   name: 'get_directions_clicks_graph'
        // })
        // lines.push({
        //   text: this.$t('dash.reporting.website_clicks_graph'),
        //   field: 'daily_website_clicks_graph',
        //   color: '#4c34e5',
        //   description: this.$t('dash.reporting.graph.choice.tooltip.website_clicks_graph.insta'),
        //   name: 'website_clicks_graph'
        // })
        // lines.push({
        //   text: this.$t('dash.reporting.profile_views_graph'),
        //   field: 'daily_profile_views_graph',
        //   color: '#e53481',
        //   description: this.$t('dash.reporting.graph.choice.tooltip.profile_views_graph.insta'),
        //   name: 'profile_views_graph'
        // })
        //demographic
        lines.push({
          text: this.$t('dash.label.fb.locale_fans'),
          field: 'audience_locale',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_locale.fb'),
          name: 'fans_locale'
        })
        lines.push({
          text: this.$t('dash.label.fb.city_fans'),
          field: 'audience_city',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_city.fb'),
          name: 'fans_city'
        })
        lines.push({
          text: this.$t('dash.label.fb.country_fans'),
          field: 'audience_country_percent',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_country.fb'),
          name: 'fans_country'
        })
        lines.push({
          text: this.$t('dash.label.fb.gender_fans'),
          field: 'audience_gender',
          color: ['#4c34e5', '#e53481', '#df34e5'],
          description: "dash.reporting.graph.choice.tooltip.fans_by_gender.fb",
          name: 'fans_gender'
        })
        lines.push({
          text: this.$t('dash.label.fb.age_fans'),
          field: 'audience_gender_age',
          color: '#6a1f4c',
          description: "Répartition par genre",
          name: 'fans_age'
        })
        lines.push({
          text: this.$t('dash.label.fb.gender_age_fans'),
          field: 'audience_gender_age',
          color: '#6a1f4c',
          description: "Répartition par genre/age",
          name: 'fans_gender_age'
        })
        lines.push({
          text: this.$t('dash.label.fb.male_age_fans'),
          field: 'audience_male_age',
          color: '#4c34e5',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_male_age.fb'),
          name: 'fans_male_age'
        })
        lines.push({
          text: this.$t('dash.label.fb.female_age_fans'),
          field: 'audience_female_age',
          color: '#e53481',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_female_age.fb'),
          name: 'fans_female_age'
        })
        lines.push({
          text: this.$t('dash.label.fb.undifined_age_fans'),
          field: 'audience_undifined_age',
          color: '#df34e5',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_undifined_age.fb'),
          name: 'fans_undifined_age'
        })
        lines.push({
          text: this.$t('dash.label.fb.gender_fans'),
          field: 'audience_by_gender',
          color: ['#4c34e5', '#e53481', '#df34e5'],
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_by_gender.fb'),
          name: 'fans_by_gender'
        })
      }
      if(['facebook', 'instagram'].includes(this.lastPage.network) && !this.lastPage.isGroup) {
        lines.push({
          text: 'Abonnés',
          field: 'dailyPageFans_graph',
          color: '#8aaaff',
          description: "Nombre d'abonnés gagnés ou perdus",
          name: 'fans_win_lost'
        })
      }
      if(['instagram', 'linkedin', 'tiktok'].includes(this.lastPage.network)) {
        lines.push({
          text: this.$t('dash.label.fb.comments'),
          field: 'commentsGraph',
          color: '#EBE134',
          description: "Nombre de commentaire",
          name: 'commentaires'
        })
        if (this.lastPage.network !== 'instagram')
          lines.push({
            text: this.$t('dash.reporting.reaction'),
            field: 'reactionsGraph',
            color: '#EB3A26',
            description: "Nombre de reaction",
            name: 'reactions'
          })
      }
      if(['twitter', 'instagram', 'tiktok'].includes(this.lastPage.network)) {
        lines.push({
          text: 'Like',
          field: 'like_count_graph',
          color: '#49EB96',
          description: "Nombre de Like",
          name: 'likes'
        })
      }
      if(this.lastPage.network === 'pinterest'){
         lines.push({
          text: 'Engagement',
          field: 'dailyEngagement_graph',
          color: '#EB3A26',
          description: "Nombre d'Engagements",
          name: 'engagements'
        })
        lines.push({
          text: this.$t('Enregistrements'),
          field: 'save_graph',
          color: '#EBE134',
          description: "Nombre d'Enregistrements",
          name: 'enregistrements'
        })
        lines.push({
          text: 'Clics sortant',
          field: 'outbound_clicks_graph',
          color: '#EBA132',
          description: "Nombre de Clics sortant",
          name: 'clics_out'
        })
        
      }
      if (this.lastPage.network === 'twitter'){
        lines.push({
          text: 'Quote',
          field: 'quote_count_graph',
          color: '#EBE134',
          description: "Nombre de Quote",
          name: 'quotes'
        })
        lines.push({
          text: 'Reply',
          field: 'reply_count_graph',
          color: '#EB3A26',
          description: "Nombre de reponse",
          name: 'reponses'
        })
        lines.push({
          text: 'Retweet',
          field: 'retweet_count_graph',
          color: '#EBA132',
          description: "Nombre de Retweet",
          name: 'retweets'
        })
      }
      if(this.lastPage.network === 'linkedin') {
        lines.push({
          text: this.$t('dash.label.linkedin.organic_followers') ,
          field: 'organicFollowerGain_graph',
          color: '#8aaaff',
          description: this.$t('dash.reporting.graph.choice.tooltip.organic_followers.linkedin'),
          name: 'organicFollowerGain'
        })
        lines.push({
          text: this.$t('dash.label.linkedin.paid_followers'),
          field: 'paidFollowerGain_graph',
          color: '#ebc849',
          description: this.$t('dash.reporting.graph.choice.tooltip.paid_followers.linkedin'),
          name: 'paidFollowerGain'
        })

        lines.push({
          text: this.$t('dash.label.linkedin.pageViews'),
          field: 'pageViews_graph',
          color: '#4955eb',
          description: this.$t('dash.reporting.graph.choice.tooltip.pageViews.linkedin'),
          name: 'pageViews'
        })
        lines.push({
          text: this.$t('dash.label.linkedin.pageClicks'),
          field: 'pageCustomButtonClickCounts_graph',
          color: '#EBA132',
          description: this.$t('dash.reporting.graph.choice.tooltip.pageClicks.linkedin'),
          name: 'pageCustomButtonClickCounts'
        })

        lines.push({
          text: this.$t('dash.label.linkedin.shareClickCount'),
          field: 'shareClickCount_graph',
          color: '#EBA132',
          description: this.$t('dash.reporting.graph.choice.tooltip.shareClickCount.linkedin'),
          name: 'shareClickCount'
        })
        lines.push({
          text: this.$t('dash.label.linkedin.shareCommentCount'),
          field: 'shareCommentCount_graph',
          color: '#4955eb',
          description: this.$t('dash.reporting.graph.choice.tooltip.shareCommentCount.linkedin'),
          name: 'shareCommentCount'
        })
        lines.push({
          text: this.$t('dash.label.linkedin.shareEngagement'),
          field: 'shareEngagement_graph',
          color: '#49EB96',
          description: this.$t('dash.reporting.graph.choice.tooltip.shareEngagement.linkedin'),
          name: 'shareEngagement'
        })
        lines.push({
          text: this.$t('dash.label.linkedin.shareImpressionCount'),
          field: 'shareImpressionCount_graph',
          color: '#EB3A26',
          description: this.$t('dash.reporting.graph.choice.tooltip.shareImpressionCount.linkedin'),
          name: 'shareImpressionCount'
        })
        lines.push({
          text: this.$t('dash.label.linkedin.shareUniqueImpressionCount'),
          field: 'shareUniqueImpressionCount_graph',
          color: '#EBE134',
          description: this.$t('dash.reporting.graph.choice.tooltip.shareUniqueImpressionCount.linkedin'),
          name: 'shareUniqueImpressionCount'
        })
        lines.push({
          text: this.$t('dash.label.linkedin.shareLikeCount'),
          field: 'shareLikeCount_graph',
          color: '#EBA132',
          description: this.$t('dash.reporting.graph.choice.tooltip.shareLikeCount.linkedin'),
          name: 'shareLikeCount'
        })
        lines.push({
          text: this.$t('dash.label.linkedin.shareShareCount'),
          field: 'shareShareCount_graph',
          color: '#df34e5',
          description: this.$t('dash.reporting.graph.choice.tooltip.shareShareCount.linkedin'),
          name: 'shareShareCount'
        })

        
        lines.push({
          text: this.$t('dash.label.fb.city_fans'),
          field: 'followerCountsByGeo',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_city.fb'),
          name: 'fans_city'
        })
        lines.push({
          text: this.$t('dash.label.fb.country_fans'),
          field: 'followerCountsByGeoCountry',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_country.fb'),
          name: 'fans_country'
        })
        
        lines.push({
          text: this.$t('dash.label.linkedin.followers_by_section'),
          field: 'followerCountsByFunction',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.followers_by_section.linkedin'),
          name: 'followerCountsByFunction'
        })
        lines.push({
          text: this.$t('dash.label.linkedin.followers_by_industry'),
          field: 'followerCountsByIndustry',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.followers_by_industry.linkedin'),
          name: 'followerCountsByIndustry'
        })
        lines.push({
          text: this.$t('dash.label.linkedin.followers_by_seniority'),
          field: 'followerCountsBySeniority',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.followers_by_seniority.linkedin'),
          name: 'followerCountsBySeniority'
        })
        lines.push({
          text: this.$t('dash.label.linkedin.followers_by_StaffCountRange'),
          field: 'followerCountsByStaffCountRange',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.followers_by_StaffCountRange.linkedin'),
          name: 'followerCountsByStaffCountRange'
        })
      }

      if(this.lastPage.network === 'tiktok') {
        lines.push({
          text: this.$t('dash.label.fb.page_follows'),
          field: 'page_follows',
          color: '#6200ff',
          description: this.$t('dash.reporting.graph.choice.tooltip.page_follows.fb'),
          name: 'page_follows'
        })
        lines.push({
          text: this.$t('dash.label.fb.page_daily_follows'),
          field: 'page_daily_follows_unique',
          color: '#ecb8f5',
          description: this.$t('dash.reporting.graph.choice.tooltip.page_daily_follows.fb'),
          name: 'page_daily_follows'
        })
        lines.push({
          text: this.$t('dash.label.fb.page_daily_unfollows'),
          field: 'page_daily_unfollows_unique',
          color: 'rgb(245 184 193)',
          description: this.$t('dash.reporting.graph.choice.tooltip.page_daily_unfollows.fb'),
          name: 'page_daily_unfollows'
        })
        lines.push({
          text: this.$t('dash.label.fb.country_fans'),
          field: 'page_follows_country_percent',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_country.fb'),
          name: 'fans_country'
        })
        lines.push({
          text: this.$t('dash.label.fb.gender_age_fans'),
          field: 'page_follows_gender_age',
          color: '#6a1f4c',
          description: "Répartition par genre/age",
          name: 'fans_gender_age'
        })
        lines.push({
          text: this.$t('dash.label.fb.male_age_fans'),
          field: 'page_follows_male_age',
          color: '#4c34e5',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_male_age.fb'),
          name: 'fans_male_age'
        })
        lines.push({
          text: this.$t('dash.label.fb.female_age_fans'),
          field: 'page_follows_female_age',
          color: '#e53481',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_female_age.fb'),
          name: 'fans_female_age'
        })
        lines.push({
          text: this.$t('dash.label.fb.undifined_age_fans'),
          field: 'page_follows_undifined_age',
          color: '#df34e5',
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_undifined_age.fb'),
          name: 'fans_undifined_age'
        })
        lines.push({
          text: this.$t('dash.label.fb.gender_fans'),
          field: 'page_follows_by_gender',
          color: ['#4c34e5', '#e53481', '#df34e5'],
          description: this.$t('dash.reporting.graph.choice.tooltip.fans_by_gender.fb'),
          name: 'fans_by_gender'
        })
      }

      if(['linkedin', 'instagram', 'facebook', 'tiktok'].includes(this.lastPage.network)) { 
        lines.push({
          text: this.$t('dash.label.linkedin.typePosts_graph'),
          field: 'typePosts_graph',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.typePosts_graph.linkedin'),
          name: 'typePosts_graph'
        })
        lines.push({
          text: this.$t('dash.label.linkedin.typePosts_engagement_graph'),
          field: 'typePosts_engagement_graph',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.typePosts_engagement_graph.linkedin'),
          name: 'typePosts_engagement_graph'
        })
        lines.push({
          text: this.$t('dash.label.linkedin.dayPosts_graph'),
          field: 'dayPosts_graph',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.dayPosts_graph.linkedin'),
          name: 'dayPosts_graph'
        })
        lines.push({
          text: this.$t('dash.label.linkedin.dayPosts_engagement_graph'),
          field: 'dayPosts_engagement_graph',
          color: '#6a1f4c',
          description: this.$t('dash.reporting.graph.choice.tooltip.dayPosts_engagement_graph.linkedin'),
          name: 'dayPosts_engagement_graph'
        })
      }
      
      return lines;
    },

    selectTime() {
      let last = (this.currentPage && this.currentPage.network === 'twitter') 
                          ? [this.$t('dash.reporting.period_thirty_days')] 
                          : [this.$t('dash.reporting.period_last_month'),
                             this.$t('dash.reporting.period_thirty_days')];
      return [
        this.$t('dash.reporting.period_three_days'), 
        this.$t('dash.reporting.period_yesterday'), 
        this.$t('dash.reporting.period_seven_days'),
        this.$t('dash.reporting.period_fifteen_days'), 
        this.$t('dash.reporting.period_this_month'), 
      ].concat(last);
    },

    postList() {
      let posts;
      if (this.lastPage.network === 'instagram') {
        posts = this.pageStats ? this.pageStats.posts.slice().sort((e1, e2) => {
          return e1.like_count < e2.like_count ? 1 : (e1.like_count > e2.like_count ? -1 : 0)
        }) : null;
      } else if(this.lastPage.isGroup){
        posts = this.pageStats ? this.pageStats.posts.slice().sort((e1, e2) => {
          return e1.comments < e2.comments ? 1 : (e1.comments > e2.comments ? -1 : 0)
        }) : null;}
      else{
        posts = this.pageStats ? this.pageStats.posts.slice().sort((e1, e2) => {
          return e1.link_clicks < e2.link_clicks ? 1 : (e1.link_clicks > e2.link_clicks ? -1 : 0)
        }) : null;
      }
      if (!posts) return null;
      posts.forEach((e, i) => {
        e.id = i + 1;
      })
      return posts;
    },

    storiesList() {
      if (!this.pageStats.stories) return null;
      let stories = this.pageStats ? this.pageStats.stories.slice().sort((e1, e2) => {
        return e1.like_count < e2.like_count ? 1 : (e1.like_count > e2.like_count ? -1 : 0)
      }) : null;
      if (!stories) return null;
      stories.forEach((e, i) => {
        e.id = i + 1;
      })
      return stories;
    },

    currentPage() {
      if (!this.pages || this.pages.length === 0) return null
      if(this.pages[this.selectedTab].network == 'pinterest')
        this.getBoardofPinterest(this.pages[this.selectedTab])
      return this.pages[this.selectedTab]
    },

    // disabledDate() {
    //   return {
    //     toStart: moment(this.dateEnd).toDate(),
    //     toEnd: this.currentPage && this.currentPage.network === 'facebook'
    //                           ? moment(this.dateStart).add(93, 'days').toDate()
    //                           : moment().toDate(),
    //     fromStart: (this.currentPage && this.currentPage.network === 'twitter') 
    //                     ? moment().subtract(29, 'day').startOf('day').toDate() 
    //                     : (this.currentPage && this.currentPage.network === 'facebook'
    //                           ? moment(this.dateEnd).subtract(93, 'days').toDate()
    //                           : moment().subtract(5, 'years').toDate()),
    //     fromEnd: moment(this.dateStart).toDate()
    //   }
    // },
    disabledDate() {
      return {
        toStart: moment(this.dateEnd).toDate(),
        toEnd: moment().toDate(),
        fromStart: (this.currentPage && this.currentPage.network === 'twitter') 
                        ? moment().subtract(29, 'day').startOf('day').toDate() 
                        : (this.currentPage && this.currentPage.network === 'facebook'
                              ? moment().subtract(2, 'years').toDate()
                              : moment().subtract(5, 'years').toDate()),
        fromEnd: moment(this.dateStart).toDate()
      }
    },

    activeNewFeatures() {
      const user = JSON.parse(localStorage.user)
      return user.email.includes("@mashup-web.com")
    },
  },

  beforeMount() {
    this.$ga.page(this.$router)
    window.addEventListener('resize', this.resize)
    this.resize()
  },

  beforeDestroy() {
    if (!this.refresh.intervalObj) {
      return
    }
    clearInterval(this.refresh.intervalObj)
    window.removeEventListener('resize', this.resize)
  },

  mounted() {
    localStorage.setItem('section', 'reporting')
    this.getBots()
    this.getPages()
  },

  methods: {
    sortConcurrents(key) {
      if (this.concurrentSortKey === key) {
        this.concurrentSortDir = this.concurrentSortDir === 'desc' ? 'asc' : 'desc'
      } else {
        this.concurrentSortKey = key
        this.concurrentSortDir = 'desc'
      }
    },

    formatPercentageChange(value) {
      if (value > 1 || value < -1) {
        return Math.round(value);
      } else {
        return value.toFixed(2);
      }
    },

    checkErrorFormatDateStart(bool) {
      this.errorFormatDateStart = bool
    },

    checkErrorFormatDateEnd(bool) {
      this.errorFormatDateEnd = bool
    },

    resize() {
      if(document.getElementsByClassName('section-reporting') && document.getElementsByClassName('section-reporting').length && document.getElementsByClassName('section-reporting')[0].offsetWidth)
        this.sizeHorizontalGraph = document.getElementsByClassName('section-reporting')[0].offsetWidth / 4 - 20
    },

    getPercentValue(data, index) {
      return parseFloat(data[index] / data.reduce((partialSum, a) => partialSum + a, 0) * 100).toFixed(2)
    },

    getMetaOgImage(url, ref, index){
      this.getMetaOgField(url, ref, index, 'image')
    },

    getMetaOgTitle(url, ref, index){
      this.getMetaOgField(url, ref, index, 'title')
    },

    getMetaOgField(url, ref, index, field){
      if(url){
        setTimeout(() => {
          if(!url.includes('topito.com')){
            this.getNewsMeta(url).then(res => {
              const { meta } = res.body
              if(field == 'image'){
                if(meta && meta.og && meta.og.image){
                  if(this.$refs[ref] && this.$refs[ref][0])
                    this.$refs[ref][0].src = meta.og.image
                }
              }
              else if(field == 'title') {
                if(meta && meta.og && meta.og.title){
                  if(this.$refs[ref] && this.$refs[ref][0]){
                    this.$refs[ref][0].innerText = meta.og.title
                  }
                }
              }
            })
          }
          else if(field == 'image' && this.$refs[ref] && this.$refs[ref][0])
            this.$refs[ref][0].src = imgDefault
        }, index*200)
      }
    },

    toggleExpandTabs() {
      // this.advancedTabs = !this.advancedTabs
      this.$emit('minimizeTabs', !this.tabsIsMinimize)
    },

    contractTabs(){
      // this.advancedTabs = false
      this.$emit('minimizeTabs', true)
    },
    
    async getPages() {
      this.getBots()
      let linkedPages = JSON.parse(localStorage.pages)
      new Promise((resolve, reject) => {
        this.fetchGroups()
        resolve()
      })
      .then(() => {
        linkedPages = linkedPages.slice().sort((a,b) => {
          if([a,b].every(l => this.bots.some(bot => bot.page.id == l.id))) {
            return (a.name > b.name) ? 1 : ((a.name < b.name) ? -1 : 0)
          }
          else if(this.bots.some(bot => bot.page.id == a.id)){
            return -1
          }
          else if(this.bots.some(bot => bot.page.id == b.id)){
            return 1
          }
        })
      })
      .then(() => {
        //sort by bots updated_at
        linkedPages = linkedPages.slice().sort((a,b) => {
          let botsA = this.bots.filter(bot => bot.page.id == a.id).sort((aB,bB) => (aB.updated_at < bB.updated_at) ? 1 : ((aB.updated_at > bB.updated_at) ? -1 : 0))
          let botsB = this.bots.filter(bot => bot.page.id == b.id).sort((aB,bB) => (aB.updated_at < bB.updated_at) ? 1 : ((aB.updated_at > bB.updated_at) ? -1 : 0))
          if(botsA.length == 0 && botsB.length == 0) return 0 
          else if(botsA.length > 0 && botsB.length == 0) return -1
          else if(botsA.length == 0 && botsB.length > 0) return 1
          else if(botsA[0].updated_at < botsB[0].updated_at) return 1
          else if(botsA[0].updated_at > botsB[0].updated_at) return -1
          else return 0
        })
        // this.pages = linkedPages.slice().filter(p => !['google', 'tiktok', 'youtube'].includes(p.network) && !(p.network ===  'linkedin' && !/^[0-9]+$/.test(p.network_id)) && !(p.network === 'instagram' && p.isGroup))
        // this.pages = linkedPages.slice().filter(p => !['google', 'tiktok', 'youtube', 'pinterest', 'bluesky'].includes(p.network) && !(p.network ===  'linkedin' && !/^[0-9]+$/.test(p.network_id)))
        this.pages = linkedPages.slice().filter(p => {
          if (['facebook', 'instagram', 'twitter', 'tiktok'].includes(p.network)) return !(p.network == 'facebook' && p.story_config && p.story_config.onlyConciergerie);
          if (p.network === 'linkedin' && /^[0-9]+$/.test(p.network_id)) return true;
          return false;
        })
        
        this.selectedPages = this.pages
                                  ? (localStorage.last_selected_page && JSON.parse(localStorage.last_selected_page)
                                            ? JSON.parse(localStorage.last_selected_page)
                                            : (this.pages[0] ? this.pages[0] : {}))
                                  : {}

        this.selectedTab = this.pages.findIndex(p => p.id == this.selectedPages.id)
        if(this.selectedTab == -1) {
          this.selectedTab = 0
          this.selectedPages = this.pages[0]
        }

        if(this.currentPage.reporting && this.currentPage.reporting.concurrents && this.currentPage.reporting.concurrents.length)
          localStorage.setItem('reportingConcurrences', JSON.stringify([{
            id: this.currentPage.id,
            data: this.currentPage.reporting.concurrents.map(c => JSON.parse(c))
          }]))

        if(localStorage.pdf){    
          localStorage.setItem('session_start', Date.now())
          let pdfParams = JSON.parse(localStorage.pdf)
          console.log('pdfParams', pdfParams, new Date(pdfParams.date_start * 1000))
          this.selectedPages = this.pages.find(p => p.id == pdfParams.page)
          this.selectedTab = this.pages.findIndex(p => p.id == this.selectedPages.id)
          this.dateStart = new Date(pdfParams.date_start * 1000) //moment(pdfParams.date_start).startOf('day').toDate();
          this.dateEnd = new Date(pdfParams.date_end * 1000) //moment(pdfParams.date_end).endOf('day').toDate(); 
          this.hideToPdf = true
          this.$emit('hideNav', 'pdf')
          this.getPageStat();
        }
      })
    },

    async getBots() {
      this.bots = JSON.parse(localStorage.bots)

      try {
        const { body, statusText } = await this.getAllBots({})
        const { success, bots } = body
        if (!success) {
          throw Error(statusText)
        }
        this.bots = bots
        await localStorage.setItem('bots', JSON.stringify(bots))
      } catch (err) {
        return this.handleError(err)
      }
    },


    async getBoardofPinterest(page){
      this.boards = null
      let boardtransition = await this.getBoardPinterest(page)
      if(boardtransition.body)
        this.boards = boardtransition.body
      this.boards.board.items.splice(0, 0, {"privacy":"PUBLIC","owner":{"username":"lucasmahlermw"},"name":"Tous les tableaux","description":"","id":"0"});
      if(this.boards && this.boards.board)
        this.boardSelected = this.boards.board.items[0]
    },

    updateScheduled(day, hour) {
      this.pageStats.page.optimalTimes.optimalTimeSlots[day][hour] = !this.pageStats.page.optimalTimes.optimalTimeSlots[day][hour]
    },

    humanizeTime(ms){
      let min = Math.floor((ms/1000/60) << 0)
      let sec = Math.floor((ms/1000) % 60)
      return `${min > 0 ? min + ' min' : ''} ${sec > 0 ? sec + ' sec' : ''}`
    },

    numberSpacing(n) {
      if(n)
        return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      return ""+n
    },
    numbersubstring(number){
      return number.toString.substring(0,5)
    },

    unityArround(n) {
      if(n >= 1000000)
        return `${this.numberSpacing((n / 1000000).toFixed(1))} M`
      else if(n >= 1000)
        return `${this.numberSpacing((n / 1000).toFixed(1))} K`
      return this.numberSpacing(n)
    },

    enableLoading() {
      this.unlimitedProgress = false;
      this.disableLoading();
      this.showLoader = true
      this.progressFunction = setInterval(() => {
        if (this.progress === 85) {
          this.unlimitedProgress = true;
        }
        this.progress += (this.unlimitedProgress ? 7 : 1);
      }, 2.5 * ((this.dateEnd - this.dateStart)/30000000))
    },

    disableLoading() {
      this.showLoader = false
      clearInterval(this.progressFunction);
      this.progressFunction = null;
      this.progress = 0;
    },

    setDateInterval(start, end) {
      this.setDateStart(start, false);
      this.setDateEnd(end, false);
      this.getPageStat();
    },

    checkPageFilter(page){
      return page.name.toLowerCase().includes(this.pageFilter.toLowerCase()) || page.network.toLowerCase().includes(this.pageFilter.toLowerCase()) || (this.pageInGroup(page) && this.pageInGroup(page).name.toLowerCase().includes(this.pageFilter.toLowerCase()))
    },

    accessNotActived(page) {
      return page.network == 'instagram' && page.isGroup
    },

    confirmActiveAccess(page){
      this.$vs.dialog({
        type:'confirm',
        color: 'primary',
        title: this.$t('dash.pages.refresh.no-api.title'),
          text: this.$t(`dash.pages.refresh.no-api.description`),
        cancelText: this.$t('dash.pages.refresh.no-api.btn-cancel'),
        acceptText: this.$t('dash.pages.refresh.no-api.btn-OK'),
        accept: async () => {     
          location.assign(`/?refresh-token=${page.id}#/dash/bots`)
        }
      })
    },

    fetchGroups() {
      if(localStorage.groups) this.groups = JSON.parse(localStorage.groups)
      let hideGroups = localStorage.hideGroups ? JSON.parse(localStorage.hideGroups) : []
      if(localStorage.pages && JSON.parse(localStorage.pages) && JSON.parse(localStorage.pages).length > 1)
        this.getGroups().then(res => {
          this.groups = res.map(group => {
            // return {...group, show: true}
            return {...group, show: !hideGroups.find(g => g == group.id)}
          })
        })
      else this.groups = []
      localStorage.groups = JSON.stringify(this.groups)
    },

    toggleShowGroup(group) {
      let hideGroups = localStorage.hideGroups ? JSON.parse(localStorage.hideGroups) : []
      if(group.show)
        hideGroups.push(group.id)
      else 
        hideGroups = hideGroups.filter(g => g != group.id)
      localStorage.setItem('hideGroups', JSON.stringify(hideGroups))
      
      let index = this.groups.findIndex(g => g.id == group.id)
      this.$set(this.groups[index], 'show', !group.show)
    },

    findPage(pageId) {
      return this.pages.find(p => p.id == pageId)
    },

    pageInGroup(page) {
      return this.groups.find(g => g.pages.includes(page.id))
    },

    checkPagesInGroup(group) {
      return group.pages.some(p => this.findPage(p))
    },

    checkGroupFilter(group){
      if(!group) return false
      return group.pages.every(p => !this.findPage(p) || (this.findPage(p) && !this.checkPageFilter(this.findPage(p))))
    },

    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },

    openLink(url) {
      if (!/https:\/\//.test(url)) {
        url = 'https://'+url;
      }
      Popup.open(url, '', 900, 700)
    },

    formatDate(date, hour=true) {
      if(!hour && typeof date == 'string' && date.length == 10)
        return date
      if (this.$i18n.locale === 'en') {
        return  hour ? moment(date).format('MM/DD/YY hh:mm A').toString() 
                      : moment(date).format('MM/DD/YY').toString()
      } else {
        return hour ? moment(date).locale(this.$i18n.locale || navigator.language).format('DD/MM/YY HH:mm').toString() 
                    : moment(date).locale(this.$i18n.locale || navigator.language).format('DD/MM/YY').toString()
      }
    },

    formatDateHyphen(date) {
      if (this.$i18n.locale === 'en') {
        return moment(date).format('MM-DD-YY').toString()
      } else {
        return moment(date).locale(this.$i18n.locale || navigator.language).format('DD-MM-YY').toString()
      }
    },

    updateSelected(tab) {
      if (tab !== this.selectedTab) {
        this.selectedTab = tab
        this.selectedPages = this.pages[tab]
        if (this.pages[tab].network === 'twitter') {
          if (moment(this.dateStart).toDate() < moment().subtract(29, 'day').toDate()) {
            this.setDateStart(moment().subtract(29, 'day').toDate());
          }
          if (moment(this.dateEnd).toDate() < moment().subtract(29, 'day').toDate()) {
            this.setDateEnd(moment().toDate());
          }
        }
        // this.contractTabs()
        
        localStorage.setItem('last_selected_page', JSON.stringify(this.pages[tab]))
        localStorage.setItem('last_selected_pages', JSON.stringify([this.pages[tab]]))

        if(this.currentPage.reporting && this.currentPage.reporting.concurrents && this.currentPage.reporting.concurrents.length)
          localStorage.setItem('reportingConcurrences', JSON.stringify([{
            id: this.currentPage.id,
            data: this.currentPage.reporting.concurrents.map(c => JSON.parse(c))
          }])) 

        if(this.pageStats) this.getPageStat()
      }
    },

    setDateStart(date, isCustom=true) {
      if (this.dateStart === date) return
      this.dateStart = moment(date).startOf('day').toDate();
      if(isCustom) this.selectedTime = -1
    },

    setDateEnd(date, isCustom=true) {
      if (this.dateEnd === date) return

      this.dateEnd = moment(date).endOf('day').toDate();
      if(isCustom) this.selectedTime = -1
    },

    getExportApiUrl() {
      this.popupActivo2 = false
      this.popupActivo3 = false
      this.enableLoading()
      this.getReportingApiUrl(this.currentPage.id).then(res => {
        this.disableLoading()
        if(res.body && res.body.success && res.body.url) {
          this.urlExportApi = res.body.url
          this.popupUrlExportApi = true
          this.copyUrlExportApi(false) 
        }
        else
        this.notify({
          color:'primary',
          title: this.$t('dash.posts.failed'),
          text: this.$t('dash.reporting.copy.url_export_api'),
          id: 'repeat'
        })
      })
    },

    getPDF() {
      this.popupActivo2 = false
      this.popupActivo3 = false
      // if(this.lastSearch.page == this.currentPage.id && this.lastSearch.dateStart == this.dateStart && this.lastSearch.dateEnd == this.dateEnd) {
        // this.getReportingPDF(this.currentPage.id, moment(this.dateStart).unix(), moment(this.dateEnd).unix(), Intl.DateTimeFormat().resolvedOptions().timeZone, this.$i18n.locale).then(res => {
        this.getReportingPDF(this.currentPage.id, moment(this.lastSearch.dateStart).unix(), moment(this.lastSearch.dateEnd).unix(), Intl.DateTimeFormat().resolvedOptions().timeZone, this.$i18n.locale).then(res => {
          this.disableLoading()
          if(res.body && res.body.success) {
            this.notify({
              color:'primary',
              title: this.$t('dash.reporting-pdf.inprogress'),
              text: this.$t('dash.reporting-pdf.inprogress.content'),
              id: 'repeat'
            })
          }
          else
            this.notify({
              color:'primary',
              title: this.$t('dash.reporting-pdf.failed'),
              text: this.$t('dash.reporting-pdf.failed.content'),
              id: 'repeat'
            })
        })
      // }
      // else 
      //   this.notify({
      //     color:'primary',
      //     title: this.$t('dash.reporting-pdf.failed'),
      //     text: this.$t('dash.reporting-pdf.failed.need_search_period_changed'),
      //     id: 'repeat'
      //   })
    },

    copyUrlExportApi(close=true) {
      const el = document.createElement('textarea');  
      el.value = this.urlExportApi;                                 
      el.setAttribute('readonly', '');                
      el.style.position = 'absolute';                     
      el.style.left = '-9999px';                      
      document.body.appendChild(el);                  
      const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;                                    
      el.select();                                    
      document.execCommand('copy');                   
      document.body.removeChild(el);                  
      if (selected) {                                 
        document.getSelection().removeAllRanges();    
        document.getSelection().addRange(selected);   
      }

      if(close) this.popupUrlExportApi = true

      this.notify({
        color:'primary',
        title: this.$t('dash.posts.success'),
        text: this.$t('dash.reporting.copy.url_export_api'),
        id: 'repeat'
      })
    },

    updateReportingData() {
      // document.querySelector(`.vs-tooltip`).remove()

      if(!this.pages[this.selectedTab].reporting)
        this.pages[this.selectedTab].reporting = {updatated_at: moment().format(), last_refreshed_at: moment().format()}
      
      this.refresh.enabled = false
      // this.pageStats = null
      this.updateCountDayLoader = 0
      this.updateTotalDayLoader = 1

      const sleep = (milliseconds) => {
        const date = Date.now();
        let currentDate = null;
        do {
          currentDate = Date.now();
        } while (currentDate - date < milliseconds);
      }

      const addSection = (sectionData, section) => {
        for (let item of this.graphNetwork) {
          if(sectionData[item.field] && !this.graphData.find(g => g.name == item.name)) {
            let graph = null
            if(['fans_locale', 'fans_city', 'fans_country', 'fans_gender_age', 'fans_male_age', 'fans_female_age', 'fans_undifined_age', 'typePosts_graph', 'typePosts_engagement_graph', 'dayPosts_graph', 'dayPosts_engagement_graph'].includes(item.name)) {
      
              graph = {
                data: Array.isArray(sectionData[item.field]) ? sectionData[item.field].map(l => l.value) : sectionData[item.field],
                type: 'bar',
                color: item.color,
                label: item.text,
                labelY: item.text,
                name: item.name,
                labels: Array.isArray(sectionData[item.field]) ? sectionData[item.field].map(l => ['typePosts_graph', 'typePosts_engagement_graph', 'dayPosts_graph', 'dayPosts_engagement_graph'].includes(item.name) ? this.$t(l.name) : l.name) : null
              }

            }
            else if(['fans_by_gender', 'followerCountsByStaffCountRange', 'followerCountsBySeniority', 'followerCountsByIndustry', 'followerCountsByFunction'].includes(item.name)) {
      
              graph = {
                data: Array.isArray(sectionData[item.field]) ? sectionData[item.field].map(l => l.value) : sectionData[item.field],
                type: 'doughnut',
                color: item.color,
                label: item.text,
                labelY: item.text,
                name: item.name,
                labels: Array.isArray(sectionData[item.field]) ? sectionData[item.field].map(l => l.name) : null
              }

    
            } else {
              let point = sectionData[item.field] 
                                  ? sectionData[item.field].sort((first, sec) => {
                                    return first.date < sec.date ? -1 : (first.date > sec.date ? 1 : 0)
                                  })
                                  : null
                                  
              if(point) {
                if(['fans_adds', 'fans_paids_adds', 'fans_removes', 'page_daily_follows', 'page_daily_unfollows'].includes(item.name)) {
                  graph = {
                    data: point.map((e) => item.name == 'fans_removes' && e.total > 0 ? -e.total : e.total),
                    type: 'bar',
                    color: item.color,
                    label: item.text,
                    labelY: item.text,
                    name: item.name
                  }
                }
                else {
                  graph = {
                    data: point.map((e) => e.total),
                    color: item.color,
                    label: item.text,
                    labelY: item.text,
                    name: item.name
                  }
                }
              }
            }
            if(graph)
              this.graphData.push(graph) 
          }
        }
        sleep(1000)
      }

      const { VUE_APP_API_HOST } = process.env
      let endpoint = `${VUE_APP_API_HOST}/reporting/update/data?pageid=${this.currentPage.id}&since=${moment(this.dateStart).unix()}&until=${moment(this.dateEnd).unix()}&timezone=${new Date().getTimezoneOffset()}`

      // this.pageStats.postsPercentLoader = 0
      const eventSource = new EventSource(endpoint);
      eventSource.onopen = () => {
        console.log("opened");
      };
      eventSource.onerror = async (error) => {
        this.updatePercentLoader = null
        this.updateCountDayLoader = null
        this.updateTotalDayLoader = null
        console.log("error", error);
        // this.pageStats.postsPercentLoader=100
        eventSource.close();

        //concurrences
        if(['facebook', 'instagram', 'linkedin', 'tiktok'].includes(this.currentPage.network) && !this.currentPage.isGroup) {
          if(localStorage.reportingConcurrences) {
            this.$set(this.pageStats.page, 'concurrences', [])
            this.$forceUpdate();
            this.hideAddConcurrent = true
            let concurents = JSON.parse(localStorage.reportingConcurrences).find(c => c.id == this.currentPage.id)
            if(concurents && concurents.data && concurents.data.length) {
              for(let concurrent of concurents.data.map(c => c.unique_id || c.id || c.name)){
                await this.getConcurrent(endpoint+`${['facebook', 'instagram', 'linkedin', 'tiktok'].includes(this.currentPage.network) ? '&step=concurrence&concurrent='+concurrent : ''}`, concurrent)
              }
            } else this.pageStats.page.concurrences = []
          } else this.pageStats.page.concurrences = []
          this.$forceUpdate();
          this.hideAddConcurrent = false
        }
        this.showProgressiveLoad = false
      };
      
      eventSource.onmessage = (event) => {
        this.updateCountDayLoader++
        this.updateTotalDayLoader = this.graphLabels.length
        console.log('message', event)

        if(Math.round(this.updateCountDayLoader / this.graphLabels.length * 100) >= 100) {
        
          this.pageStats = JSON.parse(event.data)

          this.disableLoading()
          console.log('pagestats :', this.pageStats.page.nb_post_graph)
          let data = []
          this.graphLabels = []
          localStorage.lastPageReporting = JSON.stringify(this.currentPage.id)

          let postPoints = this.pageStats.page.nb_post_graph.sort((first, sec) => {
            return first.date < sec.date ? -1 : (first.date > sec.date ? 1 : 0)
          })

          for (let point of postPoints) {
            this.graphLabels.push(
              moment(point.date * 1000).format('MM/DD/YYYY')
            )
            data.push(point.total)
          }
          this.graphData = []

          this.graphData.push({
            data,
            type: 'bar',
            color: '#E4BAF5',
            label: this.capitalize(this.$t('dash.posts.title')),
            labelY: this.capitalize(this.$t('dash.posts.title')),
            name: 'posts'
          })

          addSection(this.pageStats.page, this.currentPage.network == 'facebook' ? 'overview' : null)

          this.graphShowed = ['0', '1', '2'];
          this.graphShowedAudience = ['0', '1', '2'];
          this.refresh.last = moment();
          this.refresh.enabled = true
          console.log('this.refresh.enabled : ', this.refresh.enabled)

          // if(this.pageStats.page.profil_type_age && this.pageStats.page.profil_type_country){
          //   this.pageStats.page.profil_type_age = this.pageStats.page.profil_type_age
          //   this.pageStats.page.profil_type_country = stats.page.profil_type_country
          // }
          // else 
          if(!this.pageStats.page.profil_type_age || !this.pageStats.page.profil_type_country)
            this.pageStats.page.demographicKO = true

          this.pageStats.postsPercentLoader = 100
        

          setTimeout(() => {
            let sortHeader = this.currentPage.network === 'instagram' ? document.getElementsByClassName('t-tw-like')[0] : document.getElementsByClassName('t-clc')[0]
            if(sortHeader) {
              sortHeader.click()
              sortHeader.click()
            }
          }, 500);

          let daysBetween = Math.ceil((parseInt(moment(this.dateEnd).unix()) - parseInt(moment(this.dateStart).unix())) / 3600 / 24)
          let dateStartPreviousPeriod = moment(this.dateStart).subtract(daysBetween, 'days').unix()
          let dateEndPreviousPeriod = moment(this.dateStart).subtract(1, 'days').unix()
          
          const monthDiff = (d1, d2) => {
            let months;
            months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth();
            months += d2.getMonth();
            return months <= 0 ? 1 : months + 1;
          }
          let startDate = new Date(this.dateStart)
          let endDate = new Date(this.dateEnd)
          let lastDayOfMonth = new Date(endDate.getFullYear(), endDate.getMonth()+1, 0)
          console.log('lastDayOfMonth', lastDayOfMonth)
          if(startDate.getDate() == 1 && moment(lastDayOfMonth).format('DD/MM/YYYY') == moment(this.dateEnd).format('DD/MM/YYYY')){
            let monthCountDiff = monthDiff(startDate, endDate)
            dateStartPreviousPeriod = moment(this.dateStart).subtract(monthCountDiff, 'months').unix()
            console.log('dateStartPreviousPeriod', dateStartPreviousPeriod)
          }

          let boardsended = '0'
          let endpointPreviousPeriod = `${VUE_APP_API_HOST}/reporting?pageid=${this.currentPage.id}&since=${dateStartPreviousPeriod}&until=${dateEndPreviousPeriod}&timezone=${new Date().getTimezoneOffset()}&board=${boardsended}`

          let checkResponse = {
            currentPage: this.currentPage.id,
            dateStart: moment(this.dateStart).unix(),
            dateEnd: moment(this.dateEnd).unix(),
            boardsended: boardsended
          }
          
          this.$http.get(endpointPreviousPeriod+'&step=all&forceRefresh=true', {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }, {})
          .then(async (response) => {
            const { success, stats, updateData } = response.body
            if(this.currentPage.id == checkResponse.currentPage 
                && moment(this.dateStart).unix() == checkResponse.dateStart
                && moment(this.dateEnd).unix() == checkResponse.dateEnd
                && boardsended == checkResponse.boardsended) {  
              this.disableLoading()

              if(!success || (stats && stats.error)) {
                console.log(response);
                this.disableLoading();

                return this.notify({
                  title:'Error',
                  text: stats && stats.error ? stats.error : "Une erreur s'est produite lors de la recuperation des données de cette page pendant la periode selectionnée",
                  color: 'danger',
                  time: 5000,
                  id: this.selectedPages.id
                }, {
                  component: "Reporting",
                  action: "getPageStat",
                  endpoint
                })
              }

              //this.pageStats.page.previous_period = stats.page
              this.$set(this.pageStats.page,'previous_period',stats.page)
              this.pageStats.page.previous_period.page_fans = this.graphData.find(g =>g.name == 'fans_evol') && this.graphData.find(g =>g.name == 'fans_evol').data ? this.graphData.find(g =>g.name == 'fans_evol').data[0] : null

              this.$forceUpdate();
            }
          })
          
        }

      };

      // this.$http.get(endpoint, {
      //   headers: {
      //     Authorization: `Bearer ${localStorage.getItem('token')}`
      //   }
      // }, {})
      // .then(async (response) => {
      //   const { success, stats } = response.body
      //   console.log('updateReportingData', success, stats)
      // })
    },

    getPageStat(forceRefresh=false) {
      this.lastPage = this.currentPage
     
      if(this.currentPage && this.currentPage.network == 'facebook' && !this.currentPage.isGroup && !this.currentPage.reporting)
        return this.updateReportingData()

      if(!this.pages[this.selectedTab].reporting)
        this.pages[this.selectedTab].reporting = {updatated_at: moment().format(), last_refreshed_at: moment().format()}

      this.refresh.enabled = false
      this.pageStats = null
      let boardsended = '0'
      if(this.boardSelected)
        boardsended = this.boardSelected.id
      // if((['facebook', 'instagram'].includes(this.currentPage.network) && this.activeReportingV2) == false)
      if((['facebook', 'instagram', 'linkedin', 'tiktok'].includes(this.currentPage.network) && this.activeReportingV2) == false)
        this.enableLoading()
      this.showProgressiveLoad = false
      this.hideAddConcurrent = true
      const { VUE_APP_API_HOST } = process.env
      let checkResponse = {
        currentPage: this.currentPage.id,
        dateStart: moment(this.dateStart).unix(),
        dateEnd: moment(this.dateEnd).unix(),
        boardsended: boardsended
      }

      const sleep = (milliseconds) => {
        const date = Date.now();
        let currentDate = null;
        do {
          currentDate = Date.now();
        } while (currentDate - date < milliseconds);
      }

      const addSection = (sectionData, section) => {
        for (let item of this.graphNetwork) {
          if(sectionData[item.field] && !this.graphData.find(g => g.name == item.name)) {
            let graph = null
            if(['fans_locale', 'fans_city', 'fans_country', 'fans_gender_age', 'fans_age', 'fans_male_age', 'fans_female_age', 'fans_undifined_age', 'typePosts_graph', 'typePosts_engagement_graph', 'dayPosts_graph', 'dayPosts_engagement_graph'].includes(item.name)) {
      
              graph = {
                data: Array.isArray(sectionData[item.field]) ? sectionData[item.field].map(l => l.value) : sectionData[item.field],
                type: 'bar',
                color: item.color,
                label: item.text,
                labelY: item.text,
                name: item.name,
                labels: Array.isArray(sectionData[item.field]) ? sectionData[item.field].map(l => ['typePosts_graph', 'typePosts_engagement_graph', 'dayPosts_graph', 'dayPosts_engagement_graph'].includes(item.name) ? this.$t(l.name) : l.name) : null
              }

              if(item.name == 'fans_age') {
                const getSectionDataIndex = (index) => sectionData[item.field].find(l => l.name == index)
                let tmp = []
                tmp.push({
                  name: '13-17',
                  // value: sectionData[item.field].find(l => l.name == '13-17').value
                  value: getSectionDataIndex('13-17') ? getSectionDataIndex('13-17').value : 0
                })
                tmp.push({
                  name: '18-24',
                  // value: sectionData[item.field].find(l => l.name == '18-24').value
                  value: getSectionDataIndex('18-24') ? getSectionDataIndex('18-24').value : 0
                })
                tmp.push({
                  name: '25-34',
                  // value: sectionData[item.field].find(l => l.name == '25-34').value
                  value: getSectionDataIndex('25-34') ? getSectionDataIndex('25-34').value : 0
                })
                tmp.push({
                  name: '35-44',
                  // value: sectionData[item.field].find(l => l.name == '35-44').value
                  value: getSectionDataIndex('35-44') ? getSectionDataIndex('35-44').value : 0
                })
                tmp.push({
                  name: '45-54',
                  // value: sectionData[item.field].find(l => l.name == '45-54').value
                  value: getSectionDataIndex('45-54') ? getSectionDataIndex('45-54').value : 0
                })
                tmp.push({
                  name: '55-64',
                  // value: sectionData[item.field].find(l => l.name == '55-64').value
                  value: getSectionDataIndex('55-64') ? getSectionDataIndex('55-64').value : 0
                })
                tmp.push({
                  name: '65+',
                  // value: sectionData[item.field].find(l => l.name == '65+').value
                  value: getSectionDataIndex('55-64') ? getSectionDataIndex('65+').value : 0
                })
                graph.data = tmp.map(t => t.value)
                graph.labels = tmp.map(t => t.name)
              }

            }
            else if(['fans_by_gender', 'fans_gender', 'followerCountsByStaffCountRange', 'followerCountsBySeniority', 'followerCountsByIndustry', 'followerCountsByFunction'].includes(item.name)) {
      
              graph = {
                data: Array.isArray(sectionData[item.field]) ? sectionData[item.field].map(l => l.value) : sectionData[item.field],
                type: 'doughnut',
                color: item.color,
                label: item.text,
                labelY: item.text,
                name: item.name,
                labels: Array.isArray(sectionData[item.field]) ? sectionData[item.field].map(l => l.name) : null
              }

              if(['followerCountsByStaffCountRange', 'followerCountsBySeniority', 'followerCountsByIndustry', 'followerCountsByFunction'].includes(item.name)) {
                graph.color = Array.from({length: sectionData[item.field].length}, (_, i) => `rgba(106,31,76,${1-(i/(sectionData[item.field].length+1)+0.1)})`)
              }

              if(Array.isArray(sectionData[item.field]) && ['M', 'F', 'U'].includes((sectionData[item.field][0].name))) {
                let tmp = []
                tmp.push(sectionData[item.field].find(l => l.name == 'M').value)
                tmp.push(sectionData[item.field].find(l => l.name == 'F').value)
                tmp.push(sectionData[item.field].find(l => l.name == 'U').value)
                graph.data = tmp
              }

    
            } else {
              let point = sectionData[item.field] 
                                  ? sectionData[item.field].sort((first, sec) => {
                                    return first.date < sec.date ? -1 : (first.date > sec.date ? 1 : 0)
                                  })
                                  : null
                                  
              if(point) {
                if(['fans_adds', 'fans_paids_adds', 'fans_removes', 'page_daily_follows', 'page_daily_unfollows'].includes(item.name)) {
                  graph = {
                    data: point.map((e) => item.name == 'fans_removes' && e.total > 0 ? -e.total : e.total),
                    type: 'bar',
                    color: item.color,
                    label: item.text,
                    labelY: item.text,
                    name: item.name
                  }
                }
                else {
                  graph = {
                    data: point.map((e) => e.total),
                    color: item.color,
                    label: item.text,
                    labelY: item.text,
                    name: item.name
                  }
                }
              }
            }
            if(graph)
              this.graphData.push(graph) 
          }
        }
        sleep(1000)
      }

      let endpoint = `${VUE_APP_API_HOST}/reporting?pageid=${this.currentPage.id}&since=${moment(this.dateStart).unix()}&until=${moment(this.dateEnd).unix()}&timezone=${new Date().getTimezoneOffset()}&board=${boardsended}`

      // if(this.currentPage.network == 'facebook' && this.currentPage.reporting && this.activeReportingV2) {
      // if(['facebook', 'instagram'].includes(this.currentPage.network) && this.activeReportingV2) {       
      if(['facebook', 'instagram', 'linkedin', 'tiktok'].includes(this.currentPage.network) && this.activeReportingV2) {       
   
        this.showLoader = false
        this.updateDayLoader = null
        this.updateCountDayLoader = 0
        this.updateTotalDayLoader = 1

        this.lastSearch = {
          page: this.currentPage.id,
          dateStart: this.dateStart,
          dateEnd: this.dateEnd
        }

        const eventSource = new EventSource(`${endpoint}&step=all&percent=true${forceRefresh ? '&forceRefresh=true' : ''}`);
        eventSource.onopen = () => {
          console.log("opened");
        };
        eventSource.onerror = async (error) => {
          this.updateDayLoader = null
          this.updateCountDayLoader = null
          this.updateTotalDayLoader = null
          console.log("error", error);
          eventSource.close();
        };

        eventSource.onmessage = async (event) => {
          
          let eventData = JSON.parse(event.data)
          console.log('message', event)
          if(eventData.daysDone){
            this.updateCountDayLoader = eventData.daysDone
            this.updateTotalDayLoader = eventData.total
            if(eventData.day)
              this.updateDayLoader = moment(eventData.day).format('DD/MM/YYYY')
            this.$forceUpdate();
          }  
          else if(eventData.stats) {
            console.log('eventData', eventData)
            let stats = eventData.stats

            this.pageStats = {...stats}
            console.log('pagestats :', stats.page.nb_post_graph)
            let data = []
            this.graphLabels = []
            localStorage.lastPageReporting = JSON.stringify(this.currentPage.id)

            let postPoints = stats.page.nb_post_graph.sort((first, sec) => {
              return first.date < sec.date ? -1 : (first.date > sec.date ? 1 : 0)
            })

            for (let point of postPoints) {
              this.graphLabels.push(
                moment(point.date * 1000).format('MM/DD/YYYY')
              )
              data.push(point.total)
            }
            this.graphData = []

            this.graphData.push({
              data,
              type: 'bar',
              color: '#E4BAF5',
              label: this.capitalize(this.$t('dash.posts.title')),
              labelY: this.capitalize(this.$t('dash.posts.title')),
              name: 'posts'
            })

            addSection(stats.page, this.currentPage.network == 'facebook' ? 'overview' : null)

            this.graphShowed = ['0', '1', '2'];
            this.graphShowedAudience = ['0', '1', '2'];
            this.refresh.last = moment();
            this.refresh.enabled = true
            console.log('this.refresh.enabled : ', this.refresh.enabled)

            if(stats.page.profil_type_age && stats.page.profil_type_country){
              this.pageStats.page.profil_type_age = stats.page.profil_type_age
              this.pageStats.page.profil_type_country = stats.page.profil_type_country
            }
            else
              this.pageStats.page.demographicKO = true

            this.pageStats.postsPercentLoader = 100
         

            setTimeout(() => {
              let sortHeader = this.currentPage.network === 'instagram' ? document.getElementsByClassName('t-tw-like')[0] : document.getElementsByClassName('t-clc')[0]
              if(sortHeader) {
                sortHeader.click()
                sortHeader.click()
              }
            }, 500);
    
          this.updateCountDayLoader = 1
          this.updateTotalDayLoader = 1

          let daysBetween = Math.ceil((parseInt(moment(this.dateEnd).unix()) - parseInt(moment(this.dateStart).unix())) / 3600 / 24)
          let dateStartPreviousPeriod = moment(this.dateStart).subtract(daysBetween, 'days').unix()
          let dateEndPreviousPeriod = moment(this.dateStart).subtract(1, 'days').unix()

          const monthDiff = (d1, d2) => {
            let months;
            months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth();
            months += d2.getMonth();
            return months <= 0 ? 1 : months + 1;
          }
          let startDate = new Date(this.dateStart)
          let endDate = new Date(this.dateEnd)
          let lastDayOfMonth = new Date(endDate.getFullYear(), endDate.getMonth()+1, 0)
          console.log('lastDayOfMonth', lastDayOfMonth, moment(lastDayOfMonth).format('DD/MM/YYYY'), moment(this.dateEnd).format('DD/MM/YYYY'))
          if(startDate.getDate() == 1 && moment(lastDayOfMonth).format('DD/MM/YYYY') == moment(this.dateEnd).format('DD/MM/YYYY')){
            let monthCountDiff = monthDiff(startDate, endDate)
            dateStartPreviousPeriod = moment(this.dateStart).subtract(monthCountDiff, 'months').unix()
            console.log('dateStartPreviousPeriod', dateStartPreviousPeriod)
          }

          let endpointPreviousPeriod = `${VUE_APP_API_HOST}/reporting?pageid=${this.currentPage.id}&since=${dateStartPreviousPeriod}&until=${dateEndPreviousPeriod}&timezone=${new Date().getTimezoneOffset()}&board=${boardsended}`

          this.$http.get(`${endpointPreviousPeriod}&step=all${forceRefresh ? '&forceRefresh=true' : ''}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }, {})
          .then(async (response) => {
            const { success, stats, updateData } = response.body
            if(this.currentPage.id == checkResponse.currentPage 
                && moment(this.dateStart).unix() == checkResponse.dateStart
                && moment(this.dateEnd).unix() == checkResponse.dateEnd
                && boardsended == checkResponse.boardsended) {  
              this.disableLoading()
  
              if(!success || (stats && stats.error)) {
                console.log(response);
                this.disableLoading();
  
                return this.notify({
                  title:'Error',
                  text: stats && stats.error ? stats.error : "Une erreur s'est produite lors de la recuperation des données de cette page pendant la periode selectionnée",
                  color: 'danger',
                  time: 5000,
                  id: this.selectedPages.id
                }, {
                  component: "Reporting",
                  action: "getPageStat",
                  endpoint
                })
              }
              console.log('stats.page', stats.page)
              this.$set(this.pageStats.page,'previous_period',stats.page)
              //this.pageStats.page.previous_period = stats.page
              // this.pageStats.page.previous_period.page_fans = this.graphData.find(g =>g.name == this.currentPage.network == 'facebook' ? 'fans_evol' : 'follower_count_graph').data[0]

              this.$forceUpdate();
            }
          })
        .then(async () => {
          if(['facebook', 'instagram', 'linkedin', 'tiktok'].includes(this.currentPage.network) && !this.currentPage.isGroup) {
            if(localStorage.reportingConcurrences) {
              this.$set(this.pageStats.page, 'concurrences', [])
              this.$forceUpdate();
              this.hideAddConcurrent = true
              let concurents = JSON.parse(localStorage.reportingConcurrences).find(c => c.id == this.currentPage.id)
              if(concurents && concurents.data && concurents.data.length) {
                for(let concurrent of concurents.data.map(c => c.id || c.name)){
                  await this.getConcurrent(endpoint+`${['facebook', 'instagram', 'linkedin', 'tiktok'].includes(this.currentPage.network) ? '&step=concurrence&concurrent='+concurrent : ''}`, concurrent)
                }
              } else this.pageStats.page.concurrences = []
            } else this.pageStats.page.concurrences = []
            this.$forceUpdate();
            this.hideAddConcurrent = false
          }
          this.showProgressiveLoad = false
        })
        .catch((e) => {
          console.log('error', e)
          this.disableLoading();
          this.showProgressiveLoad = false
          this.updateCountDayLoader = 1
          this.updateTotalDayLoader = 1
          this.notify({
              title:'Erreur',
              text: this.$t('dash.reporting.error') + (e.body && e.body[0] ? ` : ${e.body[0]}` : ''),
              color: 'danger',
              time: 5000,
              id: this.selectedPages.id

          }, {
            component: "Reporting",
            action: "getPageStat",
            endpoint
          })
          console.error('Probleme stats', e)
        })
      }
        };
      }
    else {
      this.enableLoading()
      this.$http.get(endpoint+`${this.currentPage.network == 'facebook' ? '&step=overview' : ''}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }, {})
      .then(async (response) => {
        const { success, stats } = response.body
        if(this.currentPage.id == checkResponse.currentPage 
            && moment(this.dateStart).unix() == checkResponse.dateStart
            && moment(this.dateEnd).unix() == checkResponse.dateEnd
            && boardsended == checkResponse.boardsended) {  
          this.disableLoading()

          if(!success || (stats && stats.error)) {
            console.log(response);
            this.disableLoading();

            return this.notify({
              title:'Error',
              text: stats && stats.error ? stats.error : "Une erreur s'est produite lors de la recuperation des données de cette page pendant la periode selectionnée",
              color: 'danger',
              time: 5000,
              id: this.selectedPages.id
            }, {
              component: "Reporting",
              action: "getPageStat",
              endpoint
            })
          }

          this.pageStats = { ...stats, posts: [] }
          console.log('pagestats :', stats.page.nb_post_graph)
          let data = []
          this.graphLabels = []
          localStorage.lastPageReporting = JSON.stringify(this.currentPage.id)

          let postPoints = stats.page.nb_post_graph.sort((first, sec) => {
            return first.date < sec.date ? -1 : (first.date > sec.date ? 1 : 0)
          })

          for (let point of postPoints) {
            this.graphLabels.push(
              moment(point.date * 1000).format('MM/DD/YYYY')
            )
            data.push(point.total)
          }
          this.graphData = []

          this.graphData.push({
            data,
            type: 'bar',
            color: '#E4BAF5',
            label: this.capitalize(this.$t('dash.posts.title')),
            labelY: this.capitalize(this.$t('dash.posts.title')),
            name: 'posts'
          })

          addSection(stats.page, this.currentPage.network == 'facebook' ? 'overview' : null)

          this.graphShowed = ['0', '1', '2'];
          this.graphShowedAudience = ['0', '1', '2'];
          this.refresh.last = moment();
          this.refresh.enabled = true
          console.log('this.refresh.enabled : ', this.refresh.enabled)
          setTimeout(() => {
            let sortHeader = this.currentPage.network === 'instagram' ? document.getElementsByClassName('t-tw-like')[0] : document.getElementsByClassName('t-clc')[0]
            if(sortHeader) {
              sortHeader.click()
              sortHeader.click()
            }
          }, 500);

          if(this.currentPage.network != 'facebook' || this.currentPage.isGroup) 
            this.pageStats.posts = stats.posts
          

        }
      })
      .then(async () => {
        if(this.currentPage.network == 'facebook' && !this.currentPage.isGroup) {
          this.showProgressiveLoad = true
          let audience = await this.$http.get(endpoint+`${this.currentPage.network == 'facebook' ? '&step=audience' : ''}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }, {})
          if(audience && audience.body && audience.body.success && audience.body.sectionData)
            addSection(audience.body.sectionData, 'audience')
        }
      })
      .then(async () => {
        if(this.currentPage.network == 'facebook' && !this.currentPage.isGroup) {
          let impressions = await this.$http.get(endpoint+`${this.currentPage.network == 'facebook' ? '&step=impressions' : ''}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }, {})
          if(impressions && impressions.body && impressions.body.success && impressions.body.sectionData)
            addSection(impressions.body.sectionData, 'impressions')
        }
      })
      .then(async () => {
        if(this.currentPage.network == 'facebook' && !this.currentPage.isGroup) {
          let demographic = await this.$http.get(endpoint+`${this.currentPage.network == 'facebook' ? '&step=demographic' : ''}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }, {})
          if(demographic && demographic.body && demographic.body.success && demographic.body.sectionData){
            addSection(demographic.body.sectionData, 'demographic')
            if(demographic.body.sectionData.profil_type_age && demographic.body.sectionData.profil_type_country){
              this.pageStats.page.profil_type_age = demographic.body.sectionData.profil_type_age
              this.pageStats.page.profil_type_country = demographic.body.sectionData.profil_type_country
            }
            else
            this.pageStats.page.demographicKO = true
          }
        }
      })
      .then(async () => {
        if(this.currentPage.network == 'facebook' && !this.currentPage.isGroup) {
          let videos = await this.$http.get(endpoint+`${this.currentPage.network == 'facebook' ? '&step=video' : ''}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`
            }
          }, {})
          if(videos && videos.body && videos.body.success && videos.body.sectionData){
            addSection(videos.body.sectionData, 'videos')
          }
        }
      })
      .then(async () => {
        if(this.currentPage.network == 'facebook' && !this.currentPage.isGroup) {
          this.pageStats.postsPercentLoader = 0
          const eventSource = new EventSource(endpoint+`${this.currentPage.network == 'facebook' ? '&step=posts' : ''}`);
          eventSource.onopen = () => {
            console.log("opened");
          };
          eventSource.onerror = (error) => {
            console.log("error", error);
            this.pageStats.postsPercentLoader=100
            eventSource.close();
          };
          
          eventSource.onmessage = (event) => {
            console.log('message', event)
            let data = JSON.parse(event.data)
            if(data.posts){
              this.pageStats.posts = data.posts
              this.pageStats.postsPercentLoader = Math.floor(this.pageStats.posts.length / this.pageStats.page.nb_posts * 100)
            }
            if(data.optimalTimes)
              this.pageStats.page.optimalTimes = data.optimalTimes
          }
        }
      })
      .then(async () => {
        if(['facebook', 'instagram', 'linkedin', 'tiktok'].includes(this.currentPage.network) && !this.currentPage.isGroup) {
          if(localStorage.reportingConcurrences) {
            this.$set(this.pageStats.page, 'concurrences', [])
            this.$forceUpdate();
            this.hideAddConcurrent = true
            let concurents = JSON.parse(localStorage.reportingConcurrences).find(c => c.id == this.currentPage.id)
            if(concurents && concurents.data && concurents.data.length) {
              for(let concurrent of concurents.data.map(c => c.id || c.name)){
                await this.getConcurrent(endpoint+`${['facebook', 'instagram', 'linkedin', 'tiktok'].includes(this.currentPage.network) ? '&step=concurrence&concurrent='+concurrent : ''}`, concurrent)
              }
            } else this.pageStats.page.concurrences = []
          } else this.pageStats.page.concurrences = []
          this.$forceUpdate();
          this.hideAddConcurrent = false
        }
        this.showProgressiveLoad = false
      })
      .catch((e) => {
        console.log('error', e)
        this.disableLoading();
        this.showProgressiveLoad = false
        this.notify({
            title:'Erreur',
            text: this.$t('dash.reporting.error') + (e.body && e.body[0] ? ` : ${e.body[0]}` : ''),
            color: 'danger',
            time: 5000,
            id: this.selectedPages.id

        }, {
          component: "Reporting",
          action: "getPageStat",
          endpoint
        })
        console.error('Probleme stats', e)
      })
    }
    },

    async getConcurrent(endpoint, concurrent) {
      console.log('getConcurrent', endpoint, concurrent)
      if(concurrent) {
        console.log('concurrent', concurrent)
        let ind = this.pageStats.page.concurrences.findIndex(c => c.concurrent == concurrent)
        console.log('ind', ind)
        if(ind >= 0) {
          this.$set(this.pageStats.page.concurrences[ind], 'load', true)
        }
        else {
          this.pageStats.page.concurrences.push({
            concurrent,
            load: true
          })
          this.$set(this.pageStats.page, 'concurrences', this.pageStats.page.concurrences)
          // this.$set(this.pageStats.page, 'concurrences', this.pageStats.page.concurrences.concat([{concurrent, load: true}]))
        }
        console.log('this.pageStats.page.concurrences', this.pageStats.page.concurrences)
        this.$forceUpdate();

      }
      let posts = await this.$http.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }, {})
      console.log('posts cccccc', posts)
      if(posts && posts.body && posts.body.success && posts.body.concurrent){
        if(!this.pageStats.page.concurrences || !Array.isArray(this.pageStats.page.concurrences)) this.pageStats.page.concurrences = [] 
        let ind = this.pageStats.page.concurrences.findIndex(c => c.concurrent == posts.body.concurrent.concurrent)
        if(ind >= 0) {
          this.$set(this.pageStats.page.concurrences, ind, posts.body.concurrent)
        }
        else {
          this.pageStats.page.concurrences = this.pageStats.page.concurrences.concat([posts.body.concurrent])
          this.$set(this.pageStats.page, 'concurrences', this.pageStats.page.concurrences)
        }
        this.$forceUpdate();
      }
    },

    findVanityNameByUrl(url){
      if(url && new URL(url) && new URL(url).pathname.includes('/company/')){
        // return  new URL(url).pathname.replace('/company/', '').replace('/', '')
        return url.replace("https://www.linkedin.com/company/", '').split('/').shift()
      }
      return ''
    },

    findInstagramUserByUrl(url){
      if(url && url.includes('https://www.instagram.com/')){
        return new URL(url).pathname.replaceAll('/', '')
      }
      // return url
      return ''
    },

    async searchConcurrent(){
        // this.openSearchConcurrent = true
        this.searchConcurrentResult = []
        // eslint-disable-next-line no-useless-escape
        const urlRegex = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
        const isUrl = urlRegex.test(this.concurrent);

        if(isUrl && this.currentPage.network === 'instagram')
          this.concurrent = this.findInstagramUserByUrl(this.concurrent)
        else if(isUrl && this.currentPage.network === 'linkedin')
          this.concurrent = this.findVanityNameByUrl(this.concurrent)

        let mention = this.concurrent

        let funcToCall = async (pageId, mention, isUrl) =>  await this.getMentionsByApi(pageId, mention, isUrl)

        setTimeout(async () => { 
          let currentMention = this.concurrent
          //user stop typing
          if(mention == currentMention){
            if(mention.length >= 2){
              //console.log('get mentions by api')
              // let needSimulate = false;
              // if (this.currentPage.network === 'instagram') {
              //   let simulate = localStorage.simulateInstagram;
              //   console.log("Simulate", simulate);
              //   let currentPageId = this.currentPage.id;
              //   if (!simulate) {
              //     needSimulate = true;
              //     localStorage.setItem('simulateInstagram', JSON.stringify({[currentPageId]: Date.now()}))
              //   } else {
              //     simulate = JSON.parse(simulate)
              //     let currentSimulate = simulate[currentPageId];
              //     if (!currentSimulate ||  Math.floor(Math.abs(Date.now() - currentSimulate) / (1000 * 60)) > 10) {
              //       needSimulate = true;
              //       simulate[currentPageId] = Date.now();
              //       localStorage.setItem('simulateInstagram', JSON.stringify(simulate))
              //     }
              //   }
              // }
              // console.log("NEED SIMULATE", needSimulate);
              // await this.getMentionsByApi(this.currentPage.id, mention, isUrl)
              await funcToCall(this.currentPage.id, mention, isUrl)
              .then((body) => {  
                console.log('searchMentions', this.currentPage.network, mention, currentMention)  
                if(body.word == currentMention)  {  
                  console.log('OK',this.searchConcurrentResult) 
                  this.searchConcurrentResult = Object.values(body.mentions).map(m => {
                    switch(this.currentPage.network){
                      case 'twitter':
                        return {
                          id: m.id_str,
                          name: m.name,
                          screen_name: m.screen_name,
                          description: m.description,
                          location: m.location,
                          image: m.profile_image_url_https,
                          verified: m.verified
                        }
                      case 'facebook':
                        return {
                          id: m.id,
                          name: m.name,
                          image: m.image && m.image.data && m.image.data.url ? m.image.data.url : null
                        }
                      case 'linkedin':
                      case 'instagram':
                        return m
                      case 'tiktok':
                        return {
                          id: m.id,
                          unique_id: m.unique_id,
                          name: m.name,
                          image: m.image,
                        }
                      default:
                        break
                    }
                  })
                  if(this.currentPage.network == 'facebook') {
                    this.queue = new Queuer({
                      data: JSON.parse(JSON.stringify(this.searchConcurrentResult)),
                      task:(m) => {
                        let ind = this.searchConcurrentResult.findIndex(c => c.id == m.id)
                        this.getAvatarMentionByApi(this.currentPage.id, m.id).then((res) => {
                          if(res.body && res.body.avatar && res.body.avatar.data && res.body.avatar.data.url)
                            this.$set(this.searchConcurrentResult[ind], 'image', res.body.avatar.data.url)
                          this.queue.unlock()
                        })
                      }
                    })
                    this.queue.init()
                  }
                  if(this.currentPage.network == 'twitter'){
                    //filter last entry null
                    this.searchConcurrentResult = this.searchConcurrentResult.filter(m => m.screen_name)
                  }
                  //open proposition
                  if(this.searchConcurrentResult.length > 0)
                    this.openSearchConcurrent = true
                }
              })
            }
          }
        }, 1500);
      },

      showSearchConcurrent(){
        this.searchConcurrent()        
      },

      async addConcurrent(mention) {
        console.log('mention', mention)
        if(!localStorage.reportingConcurrences) localStorage.reportingConcurrences = JSON.stringify([])
        let reportingConcurrences = JSON.parse(localStorage.reportingConcurrences)
        let ind = reportingConcurrences.findIndex(c => c.id == this.currentPage.id)
        if(ind >= 0) {
          if(reportingConcurrences[ind].data.find(d => (['facebook', 'linkedin', 'tiktok'].includes(this.currentPage.network) && d.id == mention.id) || (this.currentPage.network == 'instagram' && d.name == mention.name)))
            return
          reportingConcurrences[ind].data.push(mention)
        }
        else reportingConcurrences.push({id: this.currentPage.id, data: [mention]})
        localStorage.reportingConcurrences = JSON.stringify(reportingConcurrences)

        let respPage = await this.addConcurrentToPage(this.currentPage.id, mention)
        if(respPage && respPage.body && respPage.body.page)
          this.pages[this.selectedTab] = respPage.body.page
        localStorage.setItem('pages', JSON.stringify(this.pages))

        this.concurrent = null
        this.showProgressiveLoad = true
        this.hideAddConcurrent = true
        let boardsended = '0'
        const { VUE_APP_API_HOST } = process.env
        let endpoint = `${VUE_APP_API_HOST}/reporting?pageid=${this.currentPage.id}&since=${moment(this.dateStart).unix()}&until=${moment(this.dateEnd).unix()}&timezone=${new Date().getTimezoneOffset()}&board=${boardsended}`

        await this.getConcurrent(endpoint+`${['facebook', 'instagram', 'linkedin', 'tiktok'].includes(this.currentPage.network) ? '&step=concurrence&concurrent='+(mention.unique_id || mention.id || mention.name) : ''}`, mention.unique_id || mention.id || mention.name)
        
        this.showProgressiveLoad = false
        this.hideAddConcurrent = false
      },

      // async removeConcurrent(index) {
      async removeConcurrent(concurrent) {
        let reportingConcurrences = JSON.parse(localStorage.reportingConcurrences)
        let ind = reportingConcurrences.findIndex(c => c.id == this.currentPage.id)
        // let mention = reportingConcurrences[ind].data[index]
        // reportingConcurrences[ind].data.splice(index, 1)
        let mention = reportingConcurrences[ind].data.find(c => c.concurrent == concurrent || c.id == concurrent || c.name == concurrent)
        console.log('la', mention, concurrent)
        reportingConcurrences[ind].data = reportingConcurrences[ind].data.filter(c => (c.concurrent == concurrent ||  c.id == concurrent || c.name == concurrent) == false)
        localStorage.reportingConcurrences = JSON.stringify(reportingConcurrences)
        
        let respPage = await this.removeConcurrentToPage(this.currentPage.id, mention)
          this.pages[this.selectedTab] = respPage.body.page
        localStorage.setItem('pages', JSON.stringify(this.pages))

        // this.pageStats.page.concurrences.splice(index, 1)
        this.pageStats.page.concurrences.filter(c => c.concurrent !== concurrent)
        this.$forceUpdate();
      },

      // async refreshConcurrent(index) {
      async refreshConcurrent(concurrent) {
        this.showProgressiveLoad = true
        this.hideAddConcurrent = true
        let boardsended = '0'
        const { VUE_APP_API_HOST } = process.env
        let endpoint = `${VUE_APP_API_HOST}/reporting?pageid=${this.currentPage.id}&since=${moment(this.dateStart).unix()}&until=${moment(this.dateEnd).unix()}&timezone=${new Date().getTimezoneOffset()}&board=${boardsended}`

        // await this.getConcurrent(endpoint+`${['facebook', 'instagram', 'linkedin'].includes(this.currentPage.network) ? '&step=concurrence&concurrent='+this.pageStats.page.concurrences[index].concurrent : ''}`, this.pageStats.page.concurrences[index].concurrent)
        await this.getConcurrent(endpoint+`${['facebook', 'instagram', 'linkedin', 'tiktok'].includes(this.currentPage.network) ? '&step=concurrence&concurrent='+concurrent : ''}`, concurrent)
        
        this.showProgressiveLoad = false
        this.hideAddConcurrent = false
      },

      closeSearchConcurrent() {
        this.openSearchConcurrent = false
        this.concurrent = null
      },


    exportData(format, exportType){
      const { Parser } = require('json2csv');

      let data 
      let network =  this.lastPage.network
      let isGroup=  this.lastPage.isGroup
      let lastPage=  this.lastPage
      let lang = this.$i18n.locale
      let dateStart=  this.formatDateHyphen(this.dateStart)
      let dateEnd=  this.formatDateHyphen(this.dateEnd)

      let fields = []
      
      if (exportType === "posts"){
        data = this.pageStats.posts
        fields = [
          {label:'Date', value:'created_time'},'message', 'type',
          {label:(lang === 'fr' ? 'Permalien de publication' : 'Permalink'), value:'permalink_url'},
          {label:(lang === 'fr' ? "Lien de l'article" : 'Article link'), value:'unshimmed_url'},
          {label:(lang === 'fr' ? "Lien d'attachement": 'Attachement link'), value:'attachment_url'}
        ]
        switch(network){
          case 'facebook':
            fields = fields.concat([
              {label:(lang === 'fr' ? 'Réaction Haha': 'Haha Reaction '), value:'post_reactions[0].value.haha'},
              {label:(lang === 'fr' ? "Réaction J'aime": 'Like Reaction '), value:'post_reactions[0].value.like'},
              {label:(lang === 'fr' ? "Réaction J'adore": 'Love Reaction '), value:'post_reactions[0].value.love'},
              {label:(lang === 'fr' ? 'Réaction Wouah': 'Wow Reaction '), value:'post_reactions[0].value.wow'},
              {label:(lang === 'fr' ? 'Réaction Triste': 'Sad Reaction '), value:'post_reactions[0].value.sad'},
              {label:(lang === 'fr' ? 'Réaction Grrr': 'Anger Reaction '), value:'post_reactions[0].value.anger'},
              {label:(lang === 'fr' ? 'Somme des réactions': 'Reactions Sum'), value:'post_reactions_sum'},
              {label:(lang === 'fr' ? 'Partages': 'Shares'), value:'shares_count'},
              {label:(lang === 'fr' ? 'Commentaires': 'Comments'), value:'comments_count'},
              !isGroup && {label:(lang === 'fr' ? 'Clics': 'Clicks'), value:'total_clicks'},
              !isGroup && {label:(lang === 'fr' ? 'Clics sur lien': 'Link clicks'), value:'link_clicks'},
              !isGroup && {label:(lang === 'fr' ? 'Impressions de publication': 'Post Impressions'), value:'post_impressions'},
              {label:(lang === 'fr' ? "Reach des réactions": 'Reach Reactions'), value:'reach_reaction'},
              {label:(lang === 'fr' ? 'Reach des partages': 'Reach Shares'), value:'reach_shares'},
              {label:(lang === 'fr' ? "Reach des commentaires": 'Reach Comments'), value:'reach_comments'},
              !isGroup && {label:(lang === 'fr' ? 'Reach des clics': 'Reach Clicks'), value:'reach_clicks'},
              !isGroup && {label:(lang === 'fr' ? "Reach des impressions": 'Reach Impressions'), value:'reach_impression'},
              !isGroup && {label:(lang === 'fr' ? 'Reach des engagements': 'Reach Engagement'), value:'reach_engagement'},
              !isGroup && {label:(lang === 'fr' ? 'Vues de vidéo': 'Video view'), value:'video_view_count'}
            ].filter(Boolean))
            break;
          case 'twitter':
            fields = fields.concat([
              {label:(lang === 'fr' ? "Reach des réactions": 'Reach Reaction'), value:'reach_reaction'},
              {label:(lang === 'fr' ? 'Retweeter': 'Retweet'), value:'retweet_count'},
              {label: 'Like', value:'like_count'},
              {label:(lang === 'fr' ? 'Répondre': 'Reply'), value:'reply_count'},
              {label:(lang === 'fr' ? 'Citer le Tweet': 'Quote Tweet'), value:'quote_count'},
              {label:(lang === 'fr' ? 'Impressions de publication': 'Post Impressions'), value:'post_impressions'},
              {label:(lang === 'fr' ? 'Clics sur lien': 'Link clicks'), value:'link_clicks'},
              {label:(lang === 'fr' ? "Reach des impressions": 'Reach Impressions'), value:'reach_impression'},
              {label:(lang === 'fr' ? 'Reach des engagements': 'Reach Engagements'), value:'reach_engagement'},
              {label:(lang === 'fr' ? 'Reach des retweets': 'Reach Retweets'), value:'reach_retweet'},
              {label:(lang === 'fr' ? "Reach des like": 'Reach Likes'), value:'reach_reaction'},
              {label:(lang === 'fr' ? 'Reach des réponses': 'Reach Replies'), value:'reach_reply'},
              {label:(lang === 'fr' ? 'Reach des tweets cités': 'Reach Quotes'), value:'reach_quote'},
              {label:(lang === 'fr' ? 'Reach des clics': 'Reach Clicks'), value:'reach_clicks'}
            ])
            break;
          case 'pinterest': 
            fields = fields.concat([
              {label:(lang === 'fr' ? 'Impressions de publication': 'Post Impressions'), value:'post_impressions'},
              {label:(lang === 'fr' ? 'Clics': 'clicks'), value:'link_clicks'},
              {label:(lang === 'fr' ? 'Clics sortants': 'Outbound clicks'), value:'reach_outboundclicks'},
              {label:(lang === 'fr' ? 'Reach des engagements': 'Reach Engagements'), value:'reach_engagement'},
              {label:(lang === 'fr' ? 'Reach des clics': 'Reach Clicks'), value:'reach_clicks'}
            ])
            break;
          case 'instagram':
            fields = fields.concat([
              {label:'Likes', value:'like_count'},
              {label:(lang === 'fr' ? 'Commentaires': 'Comments'), value:'comments_count'},
              {label:(lang === 'fr' ? "Reach des likes": 'Reach Likes'), value:'reach_reaction'},
              {label:(lang === 'fr' ? 'Impressions de publication': 'Post Impressions'), value:'post_impressions'},
              {label:(lang === 'fr' ? "Reach des commentaires": 'Reach Comments'), value:'reach_comments'},
              {label:(lang === 'fr' ? "Reach des impressions": 'Reach Impressions'), value:'reach_impression'},
              {label:(lang === 'fr' ? 'Reach des engagements': 'Reach Engagement'), value:'reach_engagement'}
            ])
            break;
          case 'linkedin':
            // [ value: {  LIKE: 0, PRAISE: 0, MAYBE: 0, EMPATHY: 0,INTEREST: 0, APPRECIATION: 1  }, sum: 1}]
            fields = fields.concat([
              {label:(lang === 'fr' ? "Réaction Like": 'Like Reaction '), value:'post_reactions[0].value.LIKE'},
              {label:(lang === 'fr' ? "Réaction Bravo": 'Celebrate Reaction '), value:'post_reactions[0].value.PRAISE'},
              {label:(lang === 'fr' ? "Réaction Interessant": 'Curious Reaction '), value:'post_reactions[0].value.MAYBE'},
              {label:(lang === 'fr' ? "Réaction J'adore": 'Love Reaction '), value:'post_reactions[0].value.EMPATHY'},
              {label:(lang === 'fr' ? 'Réaction Instructif': 'Insightful Reaction '), value:'post_reactions[0].value.INTEREST'},
              {label:(lang === 'fr' ? 'Réaction Soutien': 'Support Reaction '), value:'post_reactions[0].value.APPRECIATION'},
              {label:(lang === 'fr' ? 'Somme des réactions': 'Reactions Sum'), value:'post_reactions_sum'},
              {label:(lang === 'fr' ? 'Commentaires': 'Comments'), value:'comments_count'},
              {label:(lang === 'fr' ? 'Partages': 'Shares'), value:'shares_count'},
              {label:(lang === 'fr' ? 'Clics sur lien': 'Link clicks'), value:'link_clicks'},
              {label:(lang === 'fr' ? 'Impressions de publication': 'Post impressions'), value:'post_impressions'},
              {label:(lang === 'fr' ? 'Impressions uniques de publication': 'Post impressions Uniques'), value:'post_impressions_unique'},
              {label:(lang === 'fr' ? "Reach des réactions": 'Reach Reactions'), value:'reach_reaction'},
              {label:(lang === 'fr' ? "Reach des commentaires": 'Reach Comments'), value:'reach_comments'},
              {label:(lang === 'fr' ? 'Reach des clics': 'Reach Clicks'), value:'reach_clicks'},
              {label:(lang === 'fr' ? "Reach des impressions": 'Reach Impressions'), value:'reach_impression'},
              {label:(lang === 'fr' ? 'Reach des engagements': 'Reach Engagement'), value:'reach_engagement'},
              {label:(lang === 'fr' ? 'Vues de viedeo': 'Video views'), value:'video_view'},
              {label:(lang === 'fr' ? 'Temps de lecture (ms)': 'Time watched (ms)'), value:'time_watched'},
              {label:(lang === 'fr' ? 'Lecteurs': 'Viewer'), value:'viewer'}
            ])

            break;
          case 'tiktok':
            fields = fields.concat([
              {label:'Likes', value:'like_count'},
              {label:(lang === 'fr' ? 'Commentaires': 'Comments'), value:'comments_count'},
              {label:(lang === 'fr' ? 'Partages': 'Shares'), value:'shares_count'},
              {label:(lang === 'fr' ? 'Vues (Impressions)': 'Views (Impressions)'), value:'post_impressions'},
              {label:(lang === 'fr' ? 'Reach des engagements': 'Reach Engagement'), value:'reach_engagement'},
              {label:(lang === 'fr' ? 'Durée (s)': 'Duration (s)'), value:'duration'},
              {label:(lang === 'fr' ? 'Hauteur': 'Height'), value:'height'},
              {label:(lang === 'fr' ? 'Largeur': 'Width'), value:'width'}
            ])
            break;
          default:
            break;
        }

      }
      


      else if(exportType === "graphs"){
        data = this.pageStats.page
        let newArr = []
        // flat all graphs objects into new array
        data.nb_post_graph.forEach((value, key) => {
          console.log('key',key)
          let newObj = {}
          let newDate = lang=='en' ? moment.unix(value.date).format("MM/DD/YYYY") : moment.unix(value.date).format("DD/MM/YYYY")
          newObj['Date'] = newDate+"\t"
          newObj['Posts'] = value.total
          if((network =='facebook' && !isGroup) || ['twitter', 'instagram'].includes(network)){
            newObj['impressions'] = data.impression_posts_graph[key].total
          }
          if((network =='facebook' && !isGroup) || ['twitter'].includes(network)){
            newObj['clics'] = data.link_clicks_graph[key].total
          }
          if(network == 'pinterest'){
            newObj['clics'] = data.link_clicks_graph[key].total
            newObj['impressions'] = data.impression_posts_graph[key].total
            newObj['engagements'] = data.dailyEngagement_graph[key].total
            newObj['outboundClics'] = data.outbound_clicks_graph[key].total
            newObj['enregistrements'] = data.save_graph[key].total
          }
          if(network =='facebook' || network=='instagram')
            newObj['comments'] = data.commentsGraph[key].total
          if(network=='instagram' || network=='twitter')
            newObj['likes'] = data.like_count_graph[key].total
          if(network =='facebook')
            newObj['reactions'] = data.reactionsGraph[key].total
          if(network =='twitter'){
            newObj['quotes'] = data.quote_count_graph[key].total
            newObj['replies'] = data.reply_count_graph[key].total
            newObj['retweets'] = data.retweet_count_graph[key].total
          }
          if(network =='facebook' || network == 'tiktok')
            newObj['shares'] = data.sharesGraph[key].total
          if((network =='facebook' && !isGroup) || network =='instagram')
            newObj['dailyPageFans'] = key in data.dailyPageFans_graph ? data.dailyPageFans_graph[key].total : null

          if(network == 'linkedin') {
            newObj['impressions'] = data.shareImpressionCount_graph[key] ? data.shareImpressionCount_graph[key].total : 0
            newObj['impressions_uniques'] = data.shareUniqueImpressionCount_graph[key] ? data.shareUniqueImpressionCount_graph[key].total : 0
            newObj['clics'] = data.shareClickCount_graph[key] ? data.shareClickCount_graph[key].total : 0
            newObj['comments'] = data.shareCommentCount_graph[key] ? data.shareCommentCount_graph[key].total : 0
            newObj['likes'] = data.shareLikeCount_graph[key] ? data.shareLikeCount_graph[key].total : 0
            newObj['shares'] = data.shareShareCount_graph[key] ? data.shareShareCount_graph[key].total : 0
          }

          if(network == 'tiktok') {
            newObj['impressions'] = data.impression_posts_graph[key] ? data.impression_posts_graph[key].total : 0
            newObj['comments'] = data.commentsGraph[key] ? data.commentsGraph[key].total : 0
            newObj['likes'] = data.like_count_graph[key] ? data.like_count_graph[key].total : 0
          }

          newArr.push(newObj)
        })

        fields = ['Date', 'Posts',
          ((network =='facebook' && !isGroup) || ['twitter', 'linkedin', 'pinterest', 'instagram', 'tiktok'].includes(network)) &&
            {label: 'Impressions', value:'impressions'},
          (['linkedin'].includes(network)) &&
            {label: 'Impressions uniques', value:'impressions_uniques'},
          ((network =='facebook' && !isGroup) || network=='twitter' || network=='linkedin' || network == 'pinterest') &&
            {label:(lang === 'fr' ? "Clics": 'Clicks'), value:'clics'},
          (network =='facebook' || network=='instagram' || network=='linkedin' || network=='tiktok') &&
            {label:(lang === 'fr' ? "Commentaires": 'Comments'), value:'comments'},
          (network=='instagram' || network=='twitter' || network=='linkedin' || network=='tiktok') &&
            {label:'Likes', value:'likes'},
          (network =='facebook') &&
            {label:(lang === 'fr' ? "Réactions": 'Reactions'), value:'reactions'},
          (network =='twitter') &&
            {label:(lang === 'fr' ? "Citation(quotes)": 'Quotes'), value:'quotes'},
          (network =='twitter') &&
            {label:(lang === 'fr' ? "Réponses": 'Replies'), value:'replies'},
          (network =='twitter') &&
            {label:'Retweets', value:'retweets'},
          (network =='facebook' || network=='linkedin' || network=='tiktok') &&
            {label:(lang === 'fr' ? "Partages": 'Shares'), value:'shares'},
          ((network == 'facebook'&& !isGroup) || network =='instagram') && 
            {label:(lang === 'fr' ? 'Evolution Fans': 'Fans Evolution'), value:'dailyPageFans'},
          (network == 'pinterest') &&
            {label:(lang === 'fr' ? 'Clics Sortant': 'Outbound Clicks'), value:'outboundClics'}, 
          (network == 'pinterest') &&
            {label:(lang === 'fr' ? 'Enregistrements': 'Saves'), value:'enregistrements'} 
        ].filter(Boolean)

        console.log(newArr.length)
        console.log(fields)
        data = newArr
        console.log(data)
       
      }
       
      try {
        console.log("/*/*/*/",fields)
        const json2csvParser = new Parser({fields: fields, delimiter: ';', withBOM: true })
        const csv = json2csvParser.parse(data);
        console.log(csv)
        download(csv, lastPage, dateStart, dateEnd )
      } catch (err) {
        console.error(err);
      } 

      function download(data, lastPage, dateStart, dateEnd ){
        const blob=new Blob([data], { type: `text/${format}` })
        const url=window.URL.createObjectURL(blob)
        const a=document.createElement('a')
        a.setAttribute('hidden', '')
        a.setAttribute('href', url)
        a.setAttribute('download', `${exportType}`+lastPage.name+'-'+ dateStart+ '-'+dateEnd+ `.${format}`)
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
    },

    textTruncat(str, len){
      if (str.length == 0 ) {
        return ""
      } else if (str.length > len) {
        return str.substring(0, len) + "[...]";
      } else {
        return str;
      }
    },
       
  },
  watch: {
      selectedTime: function(val) {
        console.log(val);
        switch (val) {
          case -1: break
          case 0: //break;
            this.setDateInterval(moment().subtract(3, 'day').toDate(), moment().subtract(3, 'day').toDate());
            break;
          case 1: 
            this.setDateInterval(moment().subtract(1, 'day').toDate(), moment().subtract(1, 'day').toDate());
            break;
          case 2: 
            this.setDateInterval(moment().subtract(7, 'day').toDate(), moment().subtract(1, 'day').toDate());
            break;
          case 3: 
            this.setDateInterval(moment().subtract(14, 'day').toDate(), moment().subtract(1, 'day').toDate());
            break;
          case 4: 
            this.setDateInterval(moment().startOf('month').toDate(), moment().toDate());
            break;
          case 5: 
            if (this.currentPage && this.currentPage.network === 'twitter') {
              this.setDateInterval(moment().subtract(29, 'day').toDate(), moment().toDate());
            } else {
              this.setDateInterval(moment().subtract(1, 'month').startOf('month').toDate(), moment().subtract(1, 'month').endOf('month').toDate());
            }
            break;
          case 6: 
            this.setDateInterval(moment().subtract(30, 'day').toDate(), moment().subtract(1, 'day').toDate());
            break;
        }
      },
      'refresh.frequency': function(freq) {
        if (this.refresh.intervalObj) {
          clearInterval(this.refresh.intervalObj)
          this.refresh.intervalObj = null
        }
        if (freq) {
          const f = () => {
            if (this.refresh.enabled && document.visibilityState === 'visible') {
              this.getPageStat()
            }
            this.refresh.last = moment()
          }
          this.refresh.intervalObj = setInterval(f, freq * 1000)
        }
      },
      selectedPages: function(newVal, oldVal) {
        if (newVal.id) {
          this.$store.commit('selectPage/updatePagesSelected', {pagesId: [Object.values(this.$store.getters['selectPage/selectPageAllPages']).find(page => newVal.id == page.id).map(p => p.id)]});
        }
      },
    }
}
</script>

